var items = {
  "block.minecraft.acacia_button": "அகாசி பட்டன்",
  "block.minecraft.acacia_door": "அகாசியா கதவு",
  "block.minecraft.acacia_fence": "அகாசி வேலி",
  "block.minecraft.acacia_fence_gate": "அகாசி வேலி நுழைவாயில்",
  "block.minecraft.acacia_hanging_sign": "அகாசியா தொங்கும் பலகை",
  "block.minecraft.acacia_leaves": "அகாசி இலைகள்",
  "block.minecraft.acacia_log": "அகாசியா பதிவு",
  "block.minecraft.acacia_planks": "அகாசி ப்ளான்ஸ்",
  "block.minecraft.acacia_pressure_plate": "அக்ஸாரியா அழுத்தம் தட்டு",
  "block.minecraft.acacia_sapling": "அகாசி சப்பாளி",
  "block.minecraft.acacia_shelf": "Acacia Shelf",
  "block.minecraft.acacia_sign": "அகாசியா சைன்",
  "block.minecraft.acacia_slab": "அகாசியா ஸ்லாப்",
  "block.minecraft.acacia_stairs": "அகாசி ஸ்டேர்ஸ்",
  "block.minecraft.acacia_trapdoor": "அகாசியா ட்ராபர்டு",
  "block.minecraft.acacia_wall_hanging_sign": "அகாசியா சுவர் பலகை",
  "block.minecraft.acacia_wall_sign": "அகாசியா வோல் சைன்",
  "block.minecraft.acacia_wood": "அகாசி வூட்",
  "block.minecraft.activator_rail": "செயல்பாட்டாளர் ரயில்",
  "block.minecraft.air": "ஏர்",
  "block.minecraft.allium": "அல்லியம்",
  "block.minecraft.amethyst_block": "ஆமெத்திஸ்ட் கனசதுரம்",
  "block.minecraft.amethyst_cluster": "ஆமெத்திஸ்ட் கொத்து",
  "block.minecraft.ancient_debris": "பண்டைய குப்பைகள்",
  "block.minecraft.andesite": "அண்டிசைட்",
  "block.minecraft.andesite_slab": "ஆண்டிசைட் ஸ்லாப்",
  "block.minecraft.andesite_stairs": "ஆண்டிசைட் படிக்கட்டுகள்",
  "block.minecraft.andesite_wall": "ஆண்டிசைட் வால்",
  "block.minecraft.anvil": "பட்டறை",
  "block.minecraft.attached_melon_stem": "இணைக்கப்பட்ட மெலோன் ஸ்டெம்",
  "block.minecraft.attached_pumpkin_stem": "இணைக்கப்பட்ட பூசணி தண்டு",
  "block.minecraft.azalea": "அசேலியா",
  "block.minecraft.azalea_leaves": "அசேலியா இலைகள்",
  "block.minecraft.azure_bluet": "அசோர் ப்ளூட்",
  "block.minecraft.bamboo": "மூங்கில்",
  "block.minecraft.bamboo_block": "மூங்கில் சதுரம்",
  "block.minecraft.bamboo_button": "மூங்கில் பொத்தான்",
  "block.minecraft.bamboo_door": "மூங்கில் கதவு",
  "block.minecraft.bamboo_fence": "மூங்கில் வேலி",
  "block.minecraft.bamboo_fence_gate": "மூங்கில் வேலி வாயில்",
  "block.minecraft.bamboo_hanging_sign": "மூங்கில் தொங்கும் பலகை",
  "block.minecraft.bamboo_mosaic": "மூங்கில் மொசைக்",
  "block.minecraft.bamboo_mosaic_slab": "மூங்கில் மொசைக் பாதி",
  "block.minecraft.bamboo_mosaic_stairs": "மூங்கில் மொசைக் படிக்கட்டு",
  "block.minecraft.bamboo_planks": "மூங்கில் பலகைகள்",
  "block.minecraft.bamboo_pressure_plate": "மூங்கில் அழுத்தம் தட்டு",
  "block.minecraft.bamboo_sapling": "மூங்கில் தண்டு",
  "block.minecraft.bamboo_shelf": "Bamboo Shelf",
  "block.minecraft.bamboo_sign": "மூங்கில் பலகை",
  "block.minecraft.bamboo_slab": "மூங்கில் பாதி",
  "block.minecraft.bamboo_stairs": "மூங்கில் படிக்கட்டுகள்",
  "block.minecraft.bamboo_trapdoor": "மூங்கில் பொறி கதவு",
  "block.minecraft.bamboo_wall_hanging_sign": "மூங்கில் சுவர் தொங்கும் பலகை",
  "block.minecraft.bamboo_wall_sign": "மூங்கில் சுவர் பலகை",
  "block.minecraft.banner.base.black": "முழு கருப்பு நிற புலம்",
  "block.minecraft.banner.base.blue": "முழு நீள நிற புலம்",
  "block.minecraft.banner.base.brown": "முழு பழுப்பு நிற புலம்",
  "block.minecraft.banner.base.cyan": "முழு சியான் நிற புலம்",
  "block.minecraft.banner.base.gray": "முழு இளம் சாம்பல் நிற புலம்",
  "block.minecraft.banner.base.green": "முழு பச்சை நிற புலம்",
  "block.minecraft.banner.base.light_blue": "முழு இளம் நீள நிற புலம்",
  "block.minecraft.banner.base.light_gray": "முழு இளம் சாம்பல் நிற புலம்",
  "block.minecraft.banner.base.lime": "முழு இளம் பச்சை நிற புலம்",
  "block.minecraft.banner.base.magenta": "முழு மெஜந்தா நிற புலம்",
  "block.minecraft.banner.base.orange": "முழு ஆரஞ்சு நிற புலம்",
  "block.minecraft.banner.base.pink": "முழு இளஞ்சிவப்பு நிற புலம்",
  "block.minecraft.banner.base.purple": "முழு ஊதா நிற புலம்",
  "block.minecraft.banner.base.red": "முழு சிவப்பு நிற புலம்",
  "block.minecraft.banner.base.white": "முழு வெள்ளை நிற புலம்",
  "block.minecraft.banner.base.yellow": "முழு மஞ்சள் நிற புலம்",
  "block.minecraft.banner.border.black": "கருப்பு எல்லை",
  "block.minecraft.banner.border.blue": "நீல எல்லை",
  "block.minecraft.banner.border.brown": "பிரவுன் எல்லை",
  "block.minecraft.banner.border.cyan": "சியான் எல்லை",
  "block.minecraft.banner.border.gray": "சாம்பல் எல்லை",
  "block.minecraft.banner.border.green": "பச்சை எல்லை",
  "block.minecraft.banner.border.light_blue": "வெளிர் நீல எல்லை",
  "block.minecraft.banner.border.light_gray": "வெளிர் சாம்பல் எல்லை",
  "block.minecraft.banner.border.lime": "சுண்ணாம்பு எல்லை",
  "block.minecraft.banner.border.magenta": "மெஜந்தா எல்லை",
  "block.minecraft.banner.border.orange": "ஆரஞ்சு எல்லை",
  "block.minecraft.banner.border.pink": "இளஞ்சிவப்பு எல்லை",
  "block.minecraft.banner.border.purple": "ஊதா எல்லை",
  "block.minecraft.banner.border.red": "சிவப்பு எல்லை",
  "block.minecraft.banner.border.white": "வெள்ளை எல்லை",
  "block.minecraft.banner.border.yellow": "மஞ்சள் எல்லை",
  "block.minecraft.banner.bricks.black": "பிளாக் ஃபீல்ட் மேசன்",
  "block.minecraft.banner.bricks.blue": "ப்ளூ ஃபீல்ட் மேசன்",
  "block.minecraft.banner.bricks.brown": "பிரவுன் ஃபீல்ட் மேசன்",
  "block.minecraft.banner.bricks.cyan": "சியான் புலம் மேசன்",
  "block.minecraft.banner.bricks.gray": "சாம்பல் புலம் மேசன்",
  "block.minecraft.banner.bricks.green": "கிரீன் ஃபீல்ட் மேசன்",
  "block.minecraft.banner.bricks.light_blue": "வெளிர் நீல புலம் மேசன்",
  "block.minecraft.banner.bricks.light_gray": "லைட் கிரே ஃபீல்ட் மேசன்",
  "block.minecraft.banner.bricks.lime": "சுண்ணாம்பு புலம் மேசன்",
  "block.minecraft.banner.bricks.magenta": "மெஜந்தா புலம் மேசன்",
  "block.minecraft.banner.bricks.orange": "ஆரஞ்சு புலம் மேசன்",
  "block.minecraft.banner.bricks.pink": "பிங்க் ஃபீல்ட் மேசன்",
  "block.minecraft.banner.bricks.purple": "ஊதா புலம் மேசன்",
  "block.minecraft.banner.bricks.red": "ரெட் ஃபீல்ட் மேசன்",
  "block.minecraft.banner.bricks.white": "வெள்ளை புலம் மேசன்",
  "block.minecraft.banner.bricks.yellow": "மஞ்சள் புலம் மேசன்",
  "block.minecraft.banner.circle.black": "கருப்பு ரவுண்டல்",
  "block.minecraft.banner.circle.blue": "நீல ரவுண்டல்",
  "block.minecraft.banner.circle.brown": "பிரவுன் ரவுண்டல்",
  "block.minecraft.banner.circle.cyan": "சியான் ரவுண்டல்",
  "block.minecraft.banner.circle.gray": "சாம்பல் ரவுண்டல்",
  "block.minecraft.banner.circle.green": "பச்சை ரவுண்டல்",
  "block.minecraft.banner.circle.light_blue": "வெளிர் நீல ரவுண்டல்",
  "block.minecraft.banner.circle.light_gray": "லைட் கிரே ரவுண்டல்",
  "block.minecraft.banner.circle.lime": "சுண்ணாம்பு ரவுண்டல்",
  "block.minecraft.banner.circle.magenta": "மெஜந்தா ரவுண்டல்",
  "block.minecraft.banner.circle.orange": "ஆரஞ்சு ரவுண்டல்",
  "block.minecraft.banner.circle.pink": "பிங்க் ரவுண்டல்",
  "block.minecraft.banner.circle.purple": "ஊதா ரவுண்டல்",
  "block.minecraft.banner.circle.red": "சிவப்பு ரவுண்டல்",
  "block.minecraft.banner.circle.white": "வெள்ளை ரவுண்டல்",
  "block.minecraft.banner.circle.yellow": "மஞ்சள் ரவுண்டல்",
  "block.minecraft.banner.creeper.black": "கருப்பு க்ரீப்பர் கட்டணம்",
  "block.minecraft.banner.creeper.blue": "நீல க்ரீப்பர் கட்டணம்",
  "block.minecraft.banner.creeper.brown": "பிரவுன் க்ரீப்பர் கட்டணம்",
  "block.minecraft.banner.creeper.cyan": "சியான் க்ரீப்பர் கட்டணம்",
  "block.minecraft.banner.creeper.gray": "சாம்பல் க்ரீப்பர் கட்டணம்",
  "block.minecraft.banner.creeper.green": "பச்சை க்ரீப்பர் கட்டணம்",
  "block.minecraft.banner.creeper.light_blue": "வெளிர் நீல க்ரீப்பர் கட்டணம்",
  "block.minecraft.banner.creeper.light_gray": "லைட் கிரே க்ரீப்பர் கட்டணம்",
  "block.minecraft.banner.creeper.lime": "சுண்ணாம்பு க்ரீப்பர் கட்டணம்",
  "block.minecraft.banner.creeper.magenta": "மெஜந்தா க்ரீப்பர் கட்டணம்",
  "block.minecraft.banner.creeper.orange": "ஆரஞ்சு க்ரீப்பர் கட்டணம்",
  "block.minecraft.banner.creeper.pink": "பிங்க் க்ரீப்பர் கட்டணம்",
  "block.minecraft.banner.creeper.purple": "ஊதா க்ரீப்பர் கட்டணம்",
  "block.minecraft.banner.creeper.red": "ரெட் க்ரீப்பர் கட்டணம்",
  "block.minecraft.banner.creeper.white": "வெள்ளை க்ரீப்பர் கட்டணம்",
  "block.minecraft.banner.creeper.yellow": "மஞ்சள் க்ரீப்பர் கட்டணம்",
  "block.minecraft.banner.cross.black": "கருப்பு உப்பு",
  "block.minecraft.banner.cross.blue": "நீல உப்பு",
  "block.minecraft.banner.cross.brown": "பிரவுன் சால்ட்டர்",
  "block.minecraft.banner.cross.cyan": "சியான் சால்டைர்",
  "block.minecraft.banner.cross.gray": "சாம்பல் உப்பு",
  "block.minecraft.banner.cross.green": "பச்சை உப்பு",
  "block.minecraft.banner.cross.light_blue": "வெளிர் நீல உப்பு",
  "block.minecraft.banner.cross.light_gray": "ஒளி சாம்பல் உப்பு",
  "block.minecraft.banner.cross.lime": "சுண்ணாம்பு உப்பு",
  "block.minecraft.banner.cross.magenta": "மெஜந்தா சால்டைர்",
  "block.minecraft.banner.cross.orange": "ஆரஞ்சு சால்ட்டர்",
  "block.minecraft.banner.cross.pink": "இளஞ்சிவப்பு உப்பு",
  "block.minecraft.banner.cross.purple": "ஊதா உப்பு",
  "block.minecraft.banner.cross.red": "சிவப்பு உப்பு",
  "block.minecraft.banner.cross.white": "வெள்ளை உப்பு",
  "block.minecraft.banner.cross.yellow": "மஞ்சள் உப்பு",
  "block.minecraft.banner.curly_border.black": "கருப்பு எல்லை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.curly_border.blue": "நீல எல்லை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.curly_border.brown": "பிரவுன் எல்லை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.curly_border.cyan": "சியான் எல்லை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.curly_border.gray": "சாம்பல் எல்லை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.curly_border.green": "பச்சை எல்லை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.curly_border.light_blue": "வெளிர் நீல எல்லை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.curly_border.light_gray": "ஒளி சாம்பல் எல்லை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.curly_border.lime": "சுண்ணாம்பு எல்லை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.curly_border.magenta": "மெஜந்தா எல்லை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.curly_border.orange": "ஆரஞ்சு எல்லை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.curly_border.pink": "இளஞ்சிவப்பு எல்லை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.curly_border.purple": "ஊதா எல்லை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.curly_border.red": "சிவப்பு எல்லை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.curly_border.white": "வெள்ளை எல்லை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.curly_border.yellow": "மஞ்சள் எல்லை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.diagonal_left.black": "பிளாக் பெர் கெட்டது",
  "block.minecraft.banner.diagonal_left.blue": "ப்ளூ பெண்ட் கெட்டது",
  "block.minecraft.banner.diagonal_left.brown": "பிரவுன் பெண்ட் கெட்ட",
  "block.minecraft.banner.diagonal_left.cyan": "சியான் பெர் பெண்ட் கெட்டது",
  "block.minecraft.banner.diagonal_left.gray": "சாம்பல் ஒன்றுக்கு பெண்ட் கெட்டது",
  "block.minecraft.banner.diagonal_left.green": "பசுமை ஒன்றுக்கு வளைவு கெட்டது",
  "block.minecraft.banner.diagonal_left.light_blue": "வெளிர் நீல ஒன்றுக்கு வளைவு கெட்டது",
  "block.minecraft.banner.diagonal_left.light_gray": "லேசான சாம்பல் ஒன்றுக்கு வளைவு கெட்டது",
  "block.minecraft.banner.diagonal_left.lime": "சுண்ணாம்பு ஒன்றுக்கு பெண்ட் கெட்டது",
  "block.minecraft.banner.diagonal_left.magenta": "மெஜந்தா பெர் பெண்ட் கெட்ட",
  "block.minecraft.banner.diagonal_left.orange": "ஆரஞ்சு ஒன்றுக்கு பெண்ட் கெட்டது",
  "block.minecraft.banner.diagonal_left.pink": "பிங்க் பெண்ட் கெட்டது",
  "block.minecraft.banner.diagonal_left.purple": "ஊதா ஒன்றுக்கு வளைவு கெட்டது",
  "block.minecraft.banner.diagonal_left.red": "ரெட் பெர் கெட்டது",
  "block.minecraft.banner.diagonal_left.white": "வெள்ளை ஒன்றுக்கு பெண்ட் கெட்டது",
  "block.minecraft.banner.diagonal_left.yellow": "மஞ்சள் ஒன்றுக்கு வளைவு கெட்டது",
  "block.minecraft.banner.diagonal_right.black": "பிளாக் பெர்",
  "block.minecraft.banner.diagonal_right.blue": "ப்ளூ பெண்ட்",
  "block.minecraft.banner.diagonal_right.brown": "பிரவுன் ஒன்றுக்கு",
  "block.minecraft.banner.diagonal_right.cyan": "சியான் பெர் பெண்ட்",
  "block.minecraft.banner.diagonal_right.gray": "கிரே பெண்ட்",
  "block.minecraft.banner.diagonal_right.green": "பசுமை ஒன்றுக்கு",
  "block.minecraft.banner.diagonal_right.light_blue": "வளைவுக்கு வெளிர் நீலம்",
  "block.minecraft.banner.diagonal_right.light_gray": "வளைவுக்கு ஒளி சாம்பல்",
  "block.minecraft.banner.diagonal_right.lime": "சுண்ணாம்பு ஒன்றுக்கு",
  "block.minecraft.banner.diagonal_right.magenta": "மெஜந்தா பெர் பெண்ட்",
  "block.minecraft.banner.diagonal_right.orange": "ஆரஞ்சு ஒன்றுக்கு வளைவு",
  "block.minecraft.banner.diagonal_right.pink": "ஒரு வளைவுக்கு இளஞ்சிவப்பு",
  "block.minecraft.banner.diagonal_right.purple": "ஒரு வளைவுக்கு ஊதா",
  "block.minecraft.banner.diagonal_right.red": "ரெட் பெர் பெண்ட்",
  "block.minecraft.banner.diagonal_right.white": "வெள்ளை ஒன்றுக்கு",
  "block.minecraft.banner.diagonal_right.yellow": "மஞ்சள் ஒன்றுக்கு",
  "block.minecraft.banner.diagonal_up_left.black": "பிளாக் பெர் தலைகீழ்",
  "block.minecraft.banner.diagonal_up_left.blue": "ப்ளூ பெர் தலைகீழ்",
  "block.minecraft.banner.diagonal_up_left.brown": "பிரவுன் பெண்ட் தலைகீழ்",
  "block.minecraft.banner.diagonal_up_left.cyan": "சியான் பெர் பெண்ட் தலைகீழ்",
  "block.minecraft.banner.diagonal_up_left.gray": "கிரே பெண்ட் தலைகீழ்",
  "block.minecraft.banner.diagonal_up_left.green": "பசுமை ஒன்றுக்கு தலைகீழ்",
  "block.minecraft.banner.diagonal_up_left.light_blue": "வெளிர் நீல நிறத்திற்கு வெளிர் நீலம்",
  "block.minecraft.banner.diagonal_up_left.light_gray": "ஒளி வளைவு பெண்ட் தலைகீழ்",
  "block.minecraft.banner.diagonal_up_left.lime": "சுண்ணாம்பு ஒன்றுக்கு வளைவு தலைகீழ்",
  "block.minecraft.banner.diagonal_up_left.magenta": "மெஜந்தா பெர் பெண்ட் தலைகீழ்",
  "block.minecraft.banner.diagonal_up_left.orange": "ஆரஞ்சு ஒன்றுக்கு வளைவு தலைகீழ்",
  "block.minecraft.banner.diagonal_up_left.pink": "பிங்க் பெண்ட் தலைகீழ்",
  "block.minecraft.banner.diagonal_up_left.purple": "ஊதா ஒன்றுக்கு வளைவு தலைகீழ்",
  "block.minecraft.banner.diagonal_up_left.red": "ரெட் பெர் தலைகீழ்",
  "block.minecraft.banner.diagonal_up_left.white": "வெள்ளை ஒன்றுக்கு தலைகீழ்",
  "block.minecraft.banner.diagonal_up_left.yellow": "மஞ்சள் ஒன்றுக்கு வளைவு தலைகீழ்",
  "block.minecraft.banner.diagonal_up_right.black": "பிளாக் பெர் கெட்ட தலைகீழ்",
  "block.minecraft.banner.diagonal_up_right.blue": "ப்ளூ பெண்ட் கெட்ட தலைகீழ்",
  "block.minecraft.banner.diagonal_up_right.brown": "பிரவுன் பெண்ட் கெட்ட தலைகீழ்",
  "block.minecraft.banner.diagonal_up_right.cyan": "சியான் பெர் பெண்ட் கெட்ட தலைகீழ்",
  "block.minecraft.banner.diagonal_up_right.gray": "கிரே பெண்ட் கெட்ட தலைகீழ்",
  "block.minecraft.banner.diagonal_up_right.green": "பசுமை ஒன்றுக்கு வளைவு கெட்ட தலைகீழ்",
  "block.minecraft.banner.diagonal_up_right.light_blue": "வெளிர் நீல நிறத்திற்கு வளைவு கெட்ட தலைகீழ்",
  "block.minecraft.banner.diagonal_up_right.light_gray": "ஒளி வளைவு பெண்ட் கெட்ட தலைகீழ்",
  "block.minecraft.banner.diagonal_up_right.lime": "சுண்ணாம்பு ஒன்றுக்கு வளைவு கெட்ட தலைகீழ்",
  "block.minecraft.banner.diagonal_up_right.magenta": "மெஜந்தா பெர் பெண்ட் கெட்ட தலைகீழ்",
  "block.minecraft.banner.diagonal_up_right.orange": "ஆரஞ்சு ஒன்றுக்கு பெண்ட் கெட்ட தலைகீழ்",
  "block.minecraft.banner.diagonal_up_right.pink": "பிங்க் பெண்ட் கெட்ட தலைகீழ்",
  "block.minecraft.banner.diagonal_up_right.purple": "ஊதா ஒன்றுக்கு வளைவு கெட்ட தலைகீழ்",
  "block.minecraft.banner.diagonal_up_right.red": "ரெட் பெர் கெட்ட தலைகீழ்",
  "block.minecraft.banner.diagonal_up_right.white": "வெள்ளை ஒன்றுக்கு பெண்ட் கெட்ட தலைகீழ்",
  "block.minecraft.banner.diagonal_up_right.yellow": "மஞ்சள் ஒன்றுக்கு வளைவு கெட்ட தலைகீழ்",
  "block.minecraft.banner.flow.black": "கருப்பு ஓட்டம்",
  "block.minecraft.banner.flow.blue": "நீல ஓட்டம்",
  "block.minecraft.banner.flow.brown": "பழுப்பு ஓட்டம்",
  "block.minecraft.banner.flow.cyan": "சயான் ஓட்டம்",
  "block.minecraft.banner.flow.gray": "சாம்பல் ஓட்டம்",
  "block.minecraft.banner.flow.green": "பச்சை ஓட்டம்",
  "block.minecraft.banner.flow.light_blue": "வெளிர் நீலம் ஓட்டம்",
  "block.minecraft.banner.flow.light_gray": "வெளிர் சாம்பல் ஓட்டம்",
  "block.minecraft.banner.flow.lime": "வெளிர் பச்சை ஓட்டம்",
  "block.minecraft.banner.flow.magenta": "மெஜந்தா ஓட்டம்",
  "block.minecraft.banner.flow.orange": "ஆரஞ்சு ஓட்டம்",
  "block.minecraft.banner.flow.pink": "இளஞ்சிவப்பு ஓட்டம்",
  "block.minecraft.banner.flow.purple": "ஊதா ஓட்டம்",
  "block.minecraft.banner.flow.red": "சிவப்பு ஓட்டம்",
  "block.minecraft.banner.flow.white": "வெள்ளை ஓட்டம்",
  "block.minecraft.banner.flow.yellow": "மஞ்சள் ஓட்டம்",
  "block.minecraft.banner.flower.black": "கருப்பு மலர் கட்டணம்",
  "block.minecraft.banner.flower.blue": "நீல மலர் கட்டணம்",
  "block.minecraft.banner.flower.brown": "பழுப்பு மலர் கட்டணம்",
  "block.minecraft.banner.flower.cyan": "சியான் மலர் கட்டணம்",
  "block.minecraft.banner.flower.gray": "சாம்பல் மலர் கட்டணம்",
  "block.minecraft.banner.flower.green": "பச்சை மலர் கட்டணம்",
  "block.minecraft.banner.flower.light_blue": "வெளிர் நீல மலர் கட்டணம்",
  "block.minecraft.banner.flower.light_gray": "வெளிர் சாம்பல் மலர் கட்டணம்",
  "block.minecraft.banner.flower.lime": "சுண்ணாம்பு மலர் கட்டணம்",
  "block.minecraft.banner.flower.magenta": "மெஜந்தா மலர் கட்டணம்",
  "block.minecraft.banner.flower.orange": "ஆரஞ்சு மலர் கட்டணம்",
  "block.minecraft.banner.flower.pink": "இளஞ்சிவப்பு மலர் கட்டணம்",
  "block.minecraft.banner.flower.purple": "ஊதா மலர் கட்டணம்",
  "block.minecraft.banner.flower.red": "சிவப்பு மலர் கட்டணம்",
  "block.minecraft.banner.flower.white": "வெள்ளை மலர் கட்டணம்",
  "block.minecraft.banner.flower.yellow": "மஞ்சள் மலர் கட்டணம்",
  "block.minecraft.banner.globe.black": "பிளாக் குளோப்",
  "block.minecraft.banner.globe.blue": "ப்ளூ குளோப்",
  "block.minecraft.banner.globe.brown": "பிரவுன் குளோப்",
  "block.minecraft.banner.globe.cyan": "சியான் குளோப்",
  "block.minecraft.banner.globe.gray": "சாம்பல் குளோப்",
  "block.minecraft.banner.globe.green": "பச்சை குளோப்",
  "block.minecraft.banner.globe.light_blue": "லைட் ப்ளூ குளோப்",
  "block.minecraft.banner.globe.light_gray": "ஒளி சாம்பல் குளோப்",
  "block.minecraft.banner.globe.lime": "சுண்ணாம்பு குளோப்",
  "block.minecraft.banner.globe.magenta": "மெஜந்த குளோப்",
  "block.minecraft.banner.globe.orange": "ஆரஞ்சு குளோப்",
  "block.minecraft.banner.globe.pink": "பிங்க் குளோப்",
  "block.minecraft.banner.globe.purple": "ஊதா குளோப்",
  "block.minecraft.banner.globe.red": "ரெட் குளோப்",
  "block.minecraft.banner.globe.white": "வெள்ளை குளோப்",
  "block.minecraft.banner.globe.yellow": "மஞ்சள் குளோப்",
  "block.minecraft.banner.gradient.black": "கருப்பு சாய்வு",
  "block.minecraft.banner.gradient.blue": "நீல சாய்வு",
  "block.minecraft.banner.gradient.brown": "பிரவுன் சாய்வு",
  "block.minecraft.banner.gradient.cyan": "சியான் சாய்வு",
  "block.minecraft.banner.gradient.gray": "சாம்பல் சாய்வு",
  "block.minecraft.banner.gradient.green": "பச்சை சாய்வு",
  "block.minecraft.banner.gradient.light_blue": "வெளிர் நீல சாய்வு",
  "block.minecraft.banner.gradient.light_gray": "ஒளி சாம்பல் சாய்வு",
  "block.minecraft.banner.gradient.lime": "சுண்ணாம்பு சாய்வு",
  "block.minecraft.banner.gradient.magenta": "மெஜந்தா சாய்வு",
  "block.minecraft.banner.gradient.orange": "ஆரஞ்சு சாய்வு",
  "block.minecraft.banner.gradient.pink": "இளஞ்சிவப்பு சாய்வு",
  "block.minecraft.banner.gradient.purple": "ஊதா சாய்வு",
  "block.minecraft.banner.gradient.red": "சிவப்பு சாய்வு",
  "block.minecraft.banner.gradient.white": "வெள்ளை சாய்வு",
  "block.minecraft.banner.gradient.yellow": "மஞ்சள் சாய்வு",
  "block.minecraft.banner.gradient_up.black": "கருப்பு அடிப்படை சாய்வு",
  "block.minecraft.banner.gradient_up.blue": "ப்ளூ பேஸ் சாய்வு",
  "block.minecraft.banner.gradient_up.brown": "பிரவுன் பேஸ் சாய்வு",
  "block.minecraft.banner.gradient_up.cyan": "சியான் பேஸ் சாய்வு",
  "block.minecraft.banner.gradient_up.gray": "சாம்பல் அடிப்படை சாய்வு",
  "block.minecraft.banner.gradient_up.green": "பசுமை அடிப்படை சாய்வு",
  "block.minecraft.banner.gradient_up.light_blue": "வெளிர் நீல அடிப்படை சாய்வு",
  "block.minecraft.banner.gradient_up.light_gray": "ஒளி சாம்பல் அடிப்படை சாய்வு",
  "block.minecraft.banner.gradient_up.lime": "சுண்ணாம்பு அடிப்படை சாய்வு",
  "block.minecraft.banner.gradient_up.magenta": "மெஜந்தா அடிப்படை சாய்வு",
  "block.minecraft.banner.gradient_up.orange": "ஆரஞ்சு அடிப்படை சாய்வு",
  "block.minecraft.banner.gradient_up.pink": "பிங்க் பேஸ் சாய்வு",
  "block.minecraft.banner.gradient_up.purple": "ஊதா அடிப்படை சாய்வு",
  "block.minecraft.banner.gradient_up.red": "சிவப்பு அடிப்படை சாய்வு",
  "block.minecraft.banner.gradient_up.white": "வெள்ளை அடிப்படை சாய்வு",
  "block.minecraft.banner.gradient_up.yellow": "மஞ்சள் அடிப்படை சாய்வு",
  "block.minecraft.banner.guster.black": "கருப்பு கஸ்டர்",
  "block.minecraft.banner.guster.blue": "நீல கஸ்டர்",
  "block.minecraft.banner.guster.brown": "பழுப்பு கஸ்டர்",
  "block.minecraft.banner.guster.cyan": "சயான் கஸ்டர்",
  "block.minecraft.banner.guster.gray": "சாம்பல் கஸ்டர்",
  "block.minecraft.banner.guster.green": "பச்சை கஸ்டர்",
  "block.minecraft.banner.guster.light_blue": "வெளிர் நீலம் கஸ்டர்",
  "block.minecraft.banner.guster.light_gray": "வெளிர் சாம்பல் கஸ்டர்",
  "block.minecraft.banner.guster.lime": "வெளிர் பச்சை கஸ்டர்",
  "block.minecraft.banner.guster.magenta": "மெஜந்தா கஸ்டர்",
  "block.minecraft.banner.guster.orange": "ஆரஞ்சு கஸ்டர்",
  "block.minecraft.banner.guster.pink": "இளஞ்சிவப்பு கஸ்டர்",
  "block.minecraft.banner.guster.purple": "ஊதா ஊதா",
  "block.minecraft.banner.guster.red": "சிவப்பு கஸ்டர்",
  "block.minecraft.banner.guster.white": "வெள்ளை கஸ்டர்",
  "block.minecraft.banner.guster.yellow": "மஞ்சள் கஸ்டர்",
  "block.minecraft.banner.half_horizontal.black": "ஃபெஸ் பிளாக்",
  "block.minecraft.banner.half_horizontal.blue": "ஃபெஸ் ப்ளூ",
  "block.minecraft.banner.half_horizontal.brown": "பிரவுன் ஒன்றுக்கு",
  "block.minecraft.banner.half_horizontal.cyan": "சியான் பெர் ஃபெஸ்",
  "block.minecraft.banner.half_horizontal.gray": "சாம்பல் ஒன்றுக்கு ஃபெஸ்",
  "block.minecraft.banner.half_horizontal.green": "ஃபெஸ் பசுமை",
  "block.minecraft.banner.half_horizontal.light_blue": "ஃபெஸுக்கு வெளிர் நீலம்",
  "block.minecraft.banner.half_horizontal.light_gray": "ஃபெஸுக்கு ஒளி சாம்பல்",
  "block.minecraft.banner.half_horizontal.lime": "ஃபெஸ் சுண்ணாம்பு",
  "block.minecraft.banner.half_horizontal.magenta": "மெஜந்தா பெர் ஃபெஸ்",
  "block.minecraft.banner.half_horizontal.orange": "ஆரஞ்சு ஒன்றுக்கு",
  "block.minecraft.banner.half_horizontal.pink": "ஃபெஸ் பிங்க்",
  "block.minecraft.banner.half_horizontal.purple": "ஃபெஸுக்கு ஊதா",
  "block.minecraft.banner.half_horizontal.red": "ரெட் பெர் ஃபெஸ்",
  "block.minecraft.banner.half_horizontal.white": "ஃபெஸுக்கு வெள்ளை",
  "block.minecraft.banner.half_horizontal.yellow": "மஞ்சள் ஒன்றுக்கு",
  "block.minecraft.banner.half_horizontal_bottom.black": "பிளாஸ் பெர் தலைகீழ்",
  "block.minecraft.banner.half_horizontal_bottom.blue": "ப்ளூ பெஸ் தலைகீழ்",
  "block.minecraft.banner.half_horizontal_bottom.brown": "பிரவுன் ஒன்றுக்கு தலைகீழ்",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "சியான் பெர் ஃபெஸ் தலைகீழ்",
  "block.minecraft.banner.half_horizontal_bottom.gray": "சாம்பல் ஒன்றுக்கு தலைகீழ்",
  "block.minecraft.banner.half_horizontal_bottom.green": "பசுமை ஒன்றுக்கு தலைகீழ்",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "ஃபெஸ் தலைகீழாக வெளிர் நீலம்",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "ஒளி சாம்பல் ஒன்றுக்கு தலைகீழ்",
  "block.minecraft.banner.half_horizontal_bottom.lime": "சுண்ணாம்பு ஒன்றுக்கு தலைகீழ்",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "மெஜந்தா பெர் ஃபெஸ் தலைகீழ்",
  "block.minecraft.banner.half_horizontal_bottom.orange": "ஆரஞ்சு ஒன்றுக்கு ஃபெஸ் தலைகீழ்",
  "block.minecraft.banner.half_horizontal_bottom.pink": "பிங்க் பெர் ஃபெஸ் தலைகீழ்",
  "block.minecraft.banner.half_horizontal_bottom.purple": "ஃபெஸ் தலைகீழ் ஒரு ஊதா",
  "block.minecraft.banner.half_horizontal_bottom.red": "ரெட் பெர் ஃபெஸ் தலைகீழ்",
  "block.minecraft.banner.half_horizontal_bottom.white": "ஃபெஸ் தலைகீழ் வெள்ளை",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "மஞ்சள் ஒன்றுக்கு தலைகீழ்",
  "block.minecraft.banner.half_vertical.black": "கருப்பு நிறத்திற்கு",
  "block.minecraft.banner.half_vertical.blue": "ப்ளூ பெர்",
  "block.minecraft.banner.half_vertical.brown": "பிரவுன் ஒன்றுக்கு",
  "block.minecraft.banner.half_vertical.cyan": "சியான் பெர் பேல்",
  "block.minecraft.banner.half_vertical.gray": "சாம்பல் ஒன்றுக்கு வெளிர்",
  "block.minecraft.banner.half_vertical.green": "பச்சை நிறத்திற்கு",
  "block.minecraft.banner.half_vertical.light_blue": "வெளிர் நீல நிறத்திற்கு",
  "block.minecraft.banner.half_vertical.light_gray": "வெளிர் சாம்பல்",
  "block.minecraft.banner.half_vertical.lime": "லைம் பெர்",
  "block.minecraft.banner.half_vertical.magenta": "மெஜந்தா பெர் பேல்",
  "block.minecraft.banner.half_vertical.orange": "ஆரஞ்சு ஒன்றுக்கு வெளிர்",
  "block.minecraft.banner.half_vertical.pink": "இளஞ்சிவப்பு ஒன்றுக்கு",
  "block.minecraft.banner.half_vertical.purple": "ஊதா நிறத்திற்கு ஊதா",
  "block.minecraft.banner.half_vertical.red": "சிவப்பு நிறத்திற்கு",
  "block.minecraft.banner.half_vertical.white": "வெள்ளைக்கு வெளிர்",
  "block.minecraft.banner.half_vertical.yellow": "மஞ்சள் ஒன்றுக்கு மஞ்சள்",
  "block.minecraft.banner.half_vertical_right.black": "பிளாக் பெர் தலைகீழ்",
  "block.minecraft.banner.half_vertical_right.blue": "ப்ளூ பெர் தலைகீழ்",
  "block.minecraft.banner.half_vertical_right.brown": "பழுப்பு நிற தலைகீழ்",
  "block.minecraft.banner.half_vertical_right.cyan": "சியான் பெர் தலைகீழ்",
  "block.minecraft.banner.half_vertical_right.gray": "சாம்பல் ஒன்றுக்கு தலைகீழ்",
  "block.minecraft.banner.half_vertical_right.green": "பச்சை நிறத்திற்கு தலைகீழ்",
  "block.minecraft.banner.half_vertical_right.light_blue": "வெளிர் தலைகீழாக வெளிர் நீலம்",
  "block.minecraft.banner.half_vertical_right.light_gray": "வெளிர் தலைகீழ் ஒளி சாம்பல்",
  "block.minecraft.banner.half_vertical_right.lime": "லைம் பெர் தலைகீழ்",
  "block.minecraft.banner.half_vertical_right.magenta": "மெஜந்தா பெர் பேல் தலைகீழ்",
  "block.minecraft.banner.half_vertical_right.orange": "ஆரஞ்சு ஒன்றுக்கு வெளிர் தலைகீழ்",
  "block.minecraft.banner.half_vertical_right.pink": "இளஞ்சிவப்பு ஒன்றுக்கு தலைகீழ்",
  "block.minecraft.banner.half_vertical_right.purple": "ஊதா நிறத்திற்கு வெளிர் தலைகீழ்",
  "block.minecraft.banner.half_vertical_right.red": "ரெட் பெர் தலைகீழ்",
  "block.minecraft.banner.half_vertical_right.white": "வெள்ளை நிறத்திற்கு தலைகீழ்",
  "block.minecraft.banner.half_vertical_right.yellow": "மஞ்சள் ஒன்றுக்கு வெளிர் தலைகீழ்",
  "block.minecraft.banner.mojang.black": "பிளாக் திங்",
  "block.minecraft.banner.mojang.blue": "ப்ளூ திங்",
  "block.minecraft.banner.mojang.brown": "பிரவுன் திங்",
  "block.minecraft.banner.mojang.cyan": "சியான் திங்",
  "block.minecraft.banner.mojang.gray": "சாம்பல் திங்",
  "block.minecraft.banner.mojang.green": "பச்சை திங்",
  "block.minecraft.banner.mojang.light_blue": "லைட் ப்ளூ திங்",
  "block.minecraft.banner.mojang.light_gray": "ஒளி சாம்பல் திங்",
  "block.minecraft.banner.mojang.lime": "சுண்ணாம்பு திங்",
  "block.minecraft.banner.mojang.magenta": "மெஜந்த திங்",
  "block.minecraft.banner.mojang.orange": "ஆரஞ்சு திங்",
  "block.minecraft.banner.mojang.pink": "பிங்க் திங்",
  "block.minecraft.banner.mojang.purple": "ஊதா திங்",
  "block.minecraft.banner.mojang.red": "ரெட் திங்",
  "block.minecraft.banner.mojang.white": "வெள்ளை திங்",
  "block.minecraft.banner.mojang.yellow": "மஞ்சள் திங்",
  "block.minecraft.banner.piglin.black": "கருப்பு முனகல்",
  "block.minecraft.banner.piglin.blue": "நீல முனகல்",
  "block.minecraft.banner.piglin.brown": "பிரவுன் ஸ்னட்",
  "block.minecraft.banner.piglin.cyan": "சியான் ஸ்னவுட்",
  "block.minecraft.banner.piglin.gray": "சாம்பல் முனகல்",
  "block.minecraft.banner.piglin.green": "பச்சை முனகல்",
  "block.minecraft.banner.piglin.light_blue": "வெளிர் நீல முனகல்",
  "block.minecraft.banner.piglin.light_gray": "ஒளி சாம்பல் முனகல்",
  "block.minecraft.banner.piglin.lime": "சுண்ணாம்பு முனகல்",
  "block.minecraft.banner.piglin.magenta": "மெஜந்தா ஸ்னவுட்",
  "block.minecraft.banner.piglin.orange": "ஆரஞ்சு முனகல்",
  "block.minecraft.banner.piglin.pink": "இளஞ்சிவப்பு முனகல்",
  "block.minecraft.banner.piglin.purple": "ஊதா முனகல்",
  "block.minecraft.banner.piglin.red": "சிவப்பு முனகல்",
  "block.minecraft.banner.piglin.white": "வெள்ளை முனகல்",
  "block.minecraft.banner.piglin.yellow": "மஞ்சள் முனகல்",
  "block.minecraft.banner.rhombus.black": "பிளாக் லஸ்ஸெங்கே",
  "block.minecraft.banner.rhombus.blue": "ப்ளூ லாஜெங்கே",
  "block.minecraft.banner.rhombus.brown": "பிரவுன் லோசைங்கே",
  "block.minecraft.banner.rhombus.cyan": "சைன் லோஜெங்கே",
  "block.minecraft.banner.rhombus.gray": "சாம்பல் லோசைங்கே",
  "block.minecraft.banner.rhombus.green": "பசுமை லூசிங்கே",
  "block.minecraft.banner.rhombus.light_blue": "லைட் ப்ளூ லூஸங்கே",
  "block.minecraft.banner.rhombus.light_gray": "லைட் க்ரே லோசைங்கே",
  "block.minecraft.banner.rhombus.lime": "சுண்ணாம்பு",
  "block.minecraft.banner.rhombus.magenta": "மெஜெண்டா லாஜெங்கே",
  "block.minecraft.banner.rhombus.orange": "ஆரஞ்சு லாஜெங்கே",
  "block.minecraft.banner.rhombus.pink": "பிங்க் மூடுதல்",
  "block.minecraft.banner.rhombus.purple": "ஊதா லேசெங்கே",
  "block.minecraft.banner.rhombus.red": "ரெட் லாஜெங்கே",
  "block.minecraft.banner.rhombus.white": "வெள்ளை சுவை",
  "block.minecraft.banner.rhombus.yellow": "மஞ்சள் லாஜெங்கே",
  "block.minecraft.banner.skull.black": "கருப்பு மண்டை கட்டணம்",
  "block.minecraft.banner.skull.blue": "நீல மண்டை கட்டணம்",
  "block.minecraft.banner.skull.brown": "பிரவுன் மண்டை கட்டணம்",
  "block.minecraft.banner.skull.cyan": "சியான் ஸ்கல் சார்ஜ்",
  "block.minecraft.banner.skull.gray": "சாம்பல் மண்டை கட்டணம்",
  "block.minecraft.banner.skull.green": "பச்சை மண்டை கட்டணம்",
  "block.minecraft.banner.skull.light_blue": "வெளிர் நீல மண்டை கட்டணம்",
  "block.minecraft.banner.skull.light_gray": "வெளிர் சாம்பல் மண்டை கட்டணம்",
  "block.minecraft.banner.skull.lime": "சுண்ணாம்பு மண்டை கட்டணம்",
  "block.minecraft.banner.skull.magenta": "மெஜந்தா மண்டை கட்டணம்",
  "block.minecraft.banner.skull.orange": "ஆரஞ்சு மண்டை கட்டணம்",
  "block.minecraft.banner.skull.pink": "இளஞ்சிவப்பு மண்டை கட்டணம்",
  "block.minecraft.banner.skull.purple": "ஊதா மண்டை கட்டணம்",
  "block.minecraft.banner.skull.red": "சிவப்பு மண்டை கட்டணம்",
  "block.minecraft.banner.skull.white": "வெள்ளை மண்டை கட்டணம்",
  "block.minecraft.banner.skull.yellow": "மஞ்சள் மண்டை கட்டணம்",
  "block.minecraft.banner.small_stripes.black": "கருப்பு பாலி",
  "block.minecraft.banner.small_stripes.blue": "ப்ளூ பாலி",
  "block.minecraft.banner.small_stripes.brown": "பிரவுன் பாலி",
  "block.minecraft.banner.small_stripes.cyan": "சியான் பாலி",
  "block.minecraft.banner.small_stripes.gray": "சாம்பல் பாலி",
  "block.minecraft.banner.small_stripes.green": "பச்சை பாலி",
  "block.minecraft.banner.small_stripes.light_blue": "வெளிர் நீல பாலி",
  "block.minecraft.banner.small_stripes.light_gray": "வெளிர் சாம்பல் பாலி",
  "block.minecraft.banner.small_stripes.lime": "சுண்ணாம்பு பாலி",
  "block.minecraft.banner.small_stripes.magenta": "மெஜந்தா பாலி",
  "block.minecraft.banner.small_stripes.orange": "ஆரஞ்சு பாலி",
  "block.minecraft.banner.small_stripes.pink": "பிங்க் பாலி",
  "block.minecraft.banner.small_stripes.purple": "ஊதா பாலி",
  "block.minecraft.banner.small_stripes.red": "சிவப்பு பாலி",
  "block.minecraft.banner.small_stripes.white": "வெள்ளை பாலி",
  "block.minecraft.banner.small_stripes.yellow": "மஞ்சள் பாலி",
  "block.minecraft.banner.square_bottom_left.black": "பிளாக் பேஸ் டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_bottom_left.blue": "ப்ளூ பேஸ் டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_bottom_left.brown": "பிரவுன் பேஸ் டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_bottom_left.cyan": "சியான் பேஸ் டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_bottom_left.gray": "கிரே பேஸ் டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_bottom_left.green": "கிரீன் பேஸ் டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_bottom_left.light_blue": "வெளிர் நீல அடிப்படை டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_bottom_left.light_gray": "லைட் கிரே பேஸ் டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_bottom_left.lime": "லைம் பேஸ் டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_bottom_left.magenta": "மெஜந்தா பேஸ் டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_bottom_left.orange": "ஆரஞ்சு பேஸ் டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_bottom_left.pink": "பிங்க் பேஸ் டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_bottom_left.purple": "ஊதா அடிப்படை டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_bottom_left.red": "ரெட் பேஸ் டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_bottom_left.white": "ஒயிட் பேஸ் டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_bottom_left.yellow": "மஞ்சள் அடிப்படை டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_bottom_right.black": "பிளாக் பேஸ் கெட்ட கேன்டன்",
  "block.minecraft.banner.square_bottom_right.blue": "ப்ளூ பேஸ் கெட்ட கேன்டன்",
  "block.minecraft.banner.square_bottom_right.brown": "பிரவுன் பேஸ் கெட்ட கேன்டன்",
  "block.minecraft.banner.square_bottom_right.cyan": "சியான் பேஸ் கெட்ட கேன்டன்",
  "block.minecraft.banner.square_bottom_right.gray": "கிரே பேஸ் கெட்ட கேன்டன்",
  "block.minecraft.banner.square_bottom_right.green": "கிரீன் பேஸ் கெட்ட கேன்டன்",
  "block.minecraft.banner.square_bottom_right.light_blue": "வெளிர் நீல அடிப்படை கெட்ட கேன்டன்",
  "block.minecraft.banner.square_bottom_right.light_gray": "லைட் கிரே பேஸ் கெட்ட கேன்டன்",
  "block.minecraft.banner.square_bottom_right.lime": "சுண்ணாம்பு அடிப்படை கெட்ட கேன்டன்",
  "block.minecraft.banner.square_bottom_right.magenta": "மெஜந்தா பேஸ் கெட்ட கேன்டன்",
  "block.minecraft.banner.square_bottom_right.orange": "ஆரஞ்சு அடிப்படை கெட்ட கேன்டன்",
  "block.minecraft.banner.square_bottom_right.pink": "பிங்க் பேஸ் கெட்ட கேன்டன்",
  "block.minecraft.banner.square_bottom_right.purple": "ஊதா அடிப்படை கெட்ட கேன்டன்",
  "block.minecraft.banner.square_bottom_right.red": "ரெட் பேஸ் கெட்ட கேன்டன்",
  "block.minecraft.banner.square_bottom_right.white": "வெள்ளை அடிப்படை கெட்ட கேன்டன்",
  "block.minecraft.banner.square_bottom_right.yellow": "மஞ்சள் அடிப்படை கெட்ட கேன்டன்",
  "block.minecraft.banner.square_top_left.black": "பிளாக் தலைமை டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_top_left.blue": "ப்ளூ தலைமை டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_top_left.brown": "பிரவுன் தலைமை டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_top_left.cyan": "சியான் தலைமை டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_top_left.gray": "கிரே தலைமை டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_top_left.green": "பசுமை தலைமை டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_top_left.light_blue": "லைட் ப்ளூ தலைமை டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_top_left.light_gray": "லைட் கிரே தலைமை டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_top_left.lime": "சுண்ணாம்பு தலைமை டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_top_left.magenta": "மெஜந்தா தலைமை டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_top_left.orange": "ஆரஞ்சு தலைமை டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_top_left.pink": "பிங்க் தலைமை டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_top_left.purple": "ஊதா தலைமை டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_top_left.red": "ரெட் தலைமை டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_top_left.white": "வெள்ளை தலைமை டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_top_left.yellow": "மஞ்சள் தலைமை டெக்ஸ்டர் கேன்டன்",
  "block.minecraft.banner.square_top_right.black": "கருப்பு தலைமை கெட்ட கேன்டன்",
  "block.minecraft.banner.square_top_right.blue": "நீல தலைமை கெட்ட கேன்டன்",
  "block.minecraft.banner.square_top_right.brown": "பிரவுன் தலைமை கெட்ட கேன்டன்",
  "block.minecraft.banner.square_top_right.cyan": "சியான் தலைமை கெட்ட கேன்டன்",
  "block.minecraft.banner.square_top_right.gray": "சாம்பல் தலைமை கெட்ட கேன்டன்",
  "block.minecraft.banner.square_top_right.green": "பசுமை தலைமை கெட்ட கேன்டன்",
  "block.minecraft.banner.square_top_right.light_blue": "வெளிர் நீல தலைமை கெட்ட கேன்டன்",
  "block.minecraft.banner.square_top_right.light_gray": "லைட் கிரே தலைமை கெட்ட கேன்டன்",
  "block.minecraft.banner.square_top_right.lime": "சுண்ணாம்பு தலைமை கெட்டன் கேன்டன்",
  "block.minecraft.banner.square_top_right.magenta": "மெஜந்தா தலைமை கெட்ட கேன்டன்",
  "block.minecraft.banner.square_top_right.orange": "ஆரஞ்சு தலைமை கெட்ட கேன்டன்",
  "block.minecraft.banner.square_top_right.pink": "பிங்க் தலைமை கெட்ட கேன்டன்",
  "block.minecraft.banner.square_top_right.purple": "ஊதா தலைமை கெட்ட கேன்டன்",
  "block.minecraft.banner.square_top_right.red": "சிவப்பு தலைமை கெட்ட கேன்டன்",
  "block.minecraft.banner.square_top_right.white": "வெள்ளை தலைமை கெட்ட கேன்டன்",
  "block.minecraft.banner.square_top_right.yellow": "மஞ்சள் தலைமை கெட்ட கேன்டன்",
  "block.minecraft.banner.straight_cross.black": "பிளாக் கிராஸ்",
  "block.minecraft.banner.straight_cross.blue": "ப்ளூ கிராஸ்",
  "block.minecraft.banner.straight_cross.brown": "பிரவுன் க்ராஸ்",
  "block.minecraft.banner.straight_cross.cyan": "சியான் கிராஸ்",
  "block.minecraft.banner.straight_cross.gray": "சாம்பல் கிராஸ்",
  "block.minecraft.banner.straight_cross.green": "கிரீன் கிராஸ்",
  "block.minecraft.banner.straight_cross.light_blue": "லைட் ப்ளூ கிராஸ்",
  "block.minecraft.banner.straight_cross.light_gray": "ஒளி சாம்பல் குறுக்கு",
  "block.minecraft.banner.straight_cross.lime": "சுண்ணாம்பு குறுக்கு",
  "block.minecraft.banner.straight_cross.magenta": "மெஜந்தா கிராஸ்",
  "block.minecraft.banner.straight_cross.orange": "ஆரஞ்சு குறுக்கு",
  "block.minecraft.banner.straight_cross.pink": "பிங்க் கிராஸ்",
  "block.minecraft.banner.straight_cross.purple": "ஊதா கிராஸ்",
  "block.minecraft.banner.straight_cross.red": "செஞ்சிலுவை",
  "block.minecraft.banner.straight_cross.white": "வெள்ளைக் குறுக்கு",
  "block.minecraft.banner.straight_cross.yellow": "மஞ்சள் குறுக்கு",
  "block.minecraft.banner.stripe_bottom.black": "பிளாக் பேஸ்",
  "block.minecraft.banner.stripe_bottom.blue": "ப்ளூ பேஸ்",
  "block.minecraft.banner.stripe_bottom.brown": "பிரவுன் பேஸ்",
  "block.minecraft.banner.stripe_bottom.cyan": "சியான் பேஸ்",
  "block.minecraft.banner.stripe_bottom.gray": "சாம்பல் பேஸ்",
  "block.minecraft.banner.stripe_bottom.green": "பச்சை பேஸ்",
  "block.minecraft.banner.stripe_bottom.light_blue": "வெளிர் நீல அடிப்படை",
  "block.minecraft.banner.stripe_bottom.light_gray": "ஒளி சாம்பல் பேஸ்",
  "block.minecraft.banner.stripe_bottom.lime": "சுண்ணாம்பு தளம்",
  "block.minecraft.banner.stripe_bottom.magenta": "மெஜந்தா அடிப்படை",
  "block.minecraft.banner.stripe_bottom.orange": "ஆரஞ்சு அடிப்படை",
  "block.minecraft.banner.stripe_bottom.pink": "பிங்க் பேஸ்",
  "block.minecraft.banner.stripe_bottom.purple": "ஊதா பேஸ்",
  "block.minecraft.banner.stripe_bottom.red": "ரெட் பேஸ்",
  "block.minecraft.banner.stripe_bottom.white": "வெள்ளைத் தளம்",
  "block.minecraft.banner.stripe_bottom.yellow": "மஞ்சள் அடிப்படை",
  "block.minecraft.banner.stripe_center.black": "கருப்பு வெளிர்",
  "block.minecraft.banner.stripe_center.blue": "நீல வெளிர்",
  "block.minecraft.banner.stripe_center.brown": "பிரவுன் வெளிர்",
  "block.minecraft.banner.stripe_center.cyan": "சியான் பேல்",
  "block.minecraft.banner.stripe_center.gray": "சாம்பல் வெளிர்",
  "block.minecraft.banner.stripe_center.green": "பச்சை வெளிர்",
  "block.minecraft.banner.stripe_center.light_blue": "வெளிர் நீல வெளிர்",
  "block.minecraft.banner.stripe_center.light_gray": "வெளிர் சாம்பல் வெளிர்",
  "block.minecraft.banner.stripe_center.lime": "சுண்ணாம்பு வெளிர்",
  "block.minecraft.banner.stripe_center.magenta": "மெஜந்தா பேல்",
  "block.minecraft.banner.stripe_center.orange": "ஆரஞ்சு வெளிர்",
  "block.minecraft.banner.stripe_center.pink": "இளஞ்சிவப்பு வெளிர்",
  "block.minecraft.banner.stripe_center.purple": "ஊதா வெளிர்",
  "block.minecraft.banner.stripe_center.red": "சிவப்பு வெளிர்",
  "block.minecraft.banner.stripe_center.white": "வெள்ளை வெளிர்",
  "block.minecraft.banner.stripe_center.yellow": "மஞ்சள் வெளிர்",
  "block.minecraft.banner.stripe_downleft.black": "கருப்பு வளைவு கெட்டது",
  "block.minecraft.banner.stripe_downleft.blue": "நீல வளைவு கெட்டது",
  "block.minecraft.banner.stripe_downleft.brown": "பிரவுன் பெண்ட் கெட்டவர்",
  "block.minecraft.banner.stripe_downleft.cyan": "சியான் பெண்ட் கெட்டவர்",
  "block.minecraft.banner.stripe_downleft.gray": "சாம்பல் வளைவு கெட்டது",
  "block.minecraft.banner.stripe_downleft.green": "பச்சை வளைவு கெட்டது",
  "block.minecraft.banner.stripe_downleft.light_blue": "வெளிர் நீல வளைவு கெட்டது",
  "block.minecraft.banner.stripe_downleft.light_gray": "வெளிர் சாம்பல் வளைவு கெட்டது",
  "block.minecraft.banner.stripe_downleft.lime": "சுண்ணாம்பு வளைவு கெட்டது",
  "block.minecraft.banner.stripe_downleft.magenta": "மெஜந்தா பெண்ட் கெட்டது",
  "block.minecraft.banner.stripe_downleft.orange": "ஆரஞ்சு வளைவு கெட்டது",
  "block.minecraft.banner.stripe_downleft.pink": "பிங்க் பெண்ட் கெட்டது",
  "block.minecraft.banner.stripe_downleft.purple": "ஊதா வளைவு கெட்டது",
  "block.minecraft.banner.stripe_downleft.red": "சிவப்பு வளைவு கெட்டது",
  "block.minecraft.banner.stripe_downleft.white": "வெள்ளை வளைவு கெட்டது",
  "block.minecraft.banner.stripe_downleft.yellow": "மஞ்சள் வளைவு கெட்டது",
  "block.minecraft.banner.stripe_downright.black": "கருப்பு வளைவு",
  "block.minecraft.banner.stripe_downright.blue": "நீல வளைவு",
  "block.minecraft.banner.stripe_downright.brown": "பிரவுன் பெண்ட்",
  "block.minecraft.banner.stripe_downright.cyan": "சியான் பெண்ட்",
  "block.minecraft.banner.stripe_downright.gray": "சாம்பல் வளைவு",
  "block.minecraft.banner.stripe_downright.green": "பச்சை வளைவு",
  "block.minecraft.banner.stripe_downright.light_blue": "வெளிர் நீல வளைவு",
  "block.minecraft.banner.stripe_downright.light_gray": "வெளிர் சாம்பல் வளைவு",
  "block.minecraft.banner.stripe_downright.lime": "சுண்ணாம்பு வளைவு",
  "block.minecraft.banner.stripe_downright.magenta": "மெஜந்தா பெண்ட்",
  "block.minecraft.banner.stripe_downright.orange": "ஆரஞ்சு வளைவு",
  "block.minecraft.banner.stripe_downright.pink": "பிங்க் பெண்ட்",
  "block.minecraft.banner.stripe_downright.purple": "ஊதா வளைவு",
  "block.minecraft.banner.stripe_downright.red": "சிவப்பு வளைவு",
  "block.minecraft.banner.stripe_downright.white": "வெள்ளை வளைவு",
  "block.minecraft.banner.stripe_downright.yellow": "மஞ்சள் வளைவு",
  "block.minecraft.banner.stripe_left.black": "கருப்பு வெளிர் டெக்ஸ்டர்",
  "block.minecraft.banner.stripe_left.blue": "நீல வெளிர் டெக்ஸ்டர்",
  "block.minecraft.banner.stripe_left.brown": "பிரவுன் வெளிர் டெக்ஸ்டர்",
  "block.minecraft.banner.stripe_left.cyan": "சியான் பேல் டெக்ஸ்டர்",
  "block.minecraft.banner.stripe_left.gray": "சாம்பல் வெளிர் டெக்ஸ்டர்",
  "block.minecraft.banner.stripe_left.green": "பச்சை வெளிர் டெக்ஸ்டர்",
  "block.minecraft.banner.stripe_left.light_blue": "வெளிர் நீல வெளிர் டெக்ஸ்டர்",
  "block.minecraft.banner.stripe_left.light_gray": "வெளிர் சாம்பல் வெளிர் டெக்ஸ்டர்",
  "block.minecraft.banner.stripe_left.lime": "சுண்ணாம்பு வெளிர் டெக்ஸ்டர்",
  "block.minecraft.banner.stripe_left.magenta": "மெஜந்தா பேல் டெக்ஸ்டர்",
  "block.minecraft.banner.stripe_left.orange": "ஆரஞ்சு வெளிர் டெக்ஸ்டர்",
  "block.minecraft.banner.stripe_left.pink": "இளஞ்சிவப்பு வெளிர் டெக்ஸ்டர்",
  "block.minecraft.banner.stripe_left.purple": "ஊதா வெளிர் டெக்ஸ்டர்",
  "block.minecraft.banner.stripe_left.red": "சிவப்பு வெளிர் டெக்ஸ்டர்",
  "block.minecraft.banner.stripe_left.white": "வெள்ளை வெளிர் டெக்ஸ்டர்",
  "block.minecraft.banner.stripe_left.yellow": "மஞ்சள் வெளிர் டெக்ஸ்டர்",
  "block.minecraft.banner.stripe_middle.black": "கருப்பு ஃபெஸ்",
  "block.minecraft.banner.stripe_middle.blue": "ப்ளூ ஃபெஸ்",
  "block.minecraft.banner.stripe_middle.brown": "பிரவுன் ஃபெஸ்",
  "block.minecraft.banner.stripe_middle.cyan": "சியான் ஃபெஸ்",
  "block.minecraft.banner.stripe_middle.gray": "சாம்பல் ஃபெஸ்",
  "block.minecraft.banner.stripe_middle.green": "பச்சை ஃபெஸ்",
  "block.minecraft.banner.stripe_middle.light_blue": "வெளிர் நீல ஃபெஸ்",
  "block.minecraft.banner.stripe_middle.light_gray": "லைட் கிரே ஃபெஸ்",
  "block.minecraft.banner.stripe_middle.lime": "சுண்ணாம்பு ஃபெஸ்",
  "block.minecraft.banner.stripe_middle.magenta": "மெஜந்தா ஃபெஸ்",
  "block.minecraft.banner.stripe_middle.orange": "ஆரஞ்சு ஃபெஸ்",
  "block.minecraft.banner.stripe_middle.pink": "பிங்க் ஃபெஸ்",
  "block.minecraft.banner.stripe_middle.purple": "ஊதா ஃபெஸ்",
  "block.minecraft.banner.stripe_middle.red": "சிவப்பு ஃபெஸ்",
  "block.minecraft.banner.stripe_middle.white": "வெள்ளை ஃபெஸ்",
  "block.minecraft.banner.stripe_middle.yellow": "மஞ்சள் ஃபெஸ்",
  "block.minecraft.banner.stripe_right.black": "கருப்பு வெளிறிய கெட்ட",
  "block.minecraft.banner.stripe_right.blue": "நீல வெளிர் கெட்டது",
  "block.minecraft.banner.stripe_right.brown": "பிரவுன் வெளிறிய கெட்ட",
  "block.minecraft.banner.stripe_right.cyan": "சியான் வெளிறிய கெட்ட",
  "block.minecraft.banner.stripe_right.gray": "சாம்பல் வெளிறிய கெட்ட",
  "block.minecraft.banner.stripe_right.green": "பச்சை வெளிர் கெட்டது",
  "block.minecraft.banner.stripe_right.light_blue": "வெளிர் நீல வெளிர் கெட்டது",
  "block.minecraft.banner.stripe_right.light_gray": "வெளிர் சாம்பல் வெளிர் கெட்டது",
  "block.minecraft.banner.stripe_right.lime": "சுண்ணாம்பு வெளிர் கெட்டது",
  "block.minecraft.banner.stripe_right.magenta": "மெஜந்தா வெளிறிய கெட்ட",
  "block.minecraft.banner.stripe_right.orange": "ஆரஞ்சு வெளிறிய கெட்டது",
  "block.minecraft.banner.stripe_right.pink": "இளஞ்சிவப்பு வெளிர் கெட்டது",
  "block.minecraft.banner.stripe_right.purple": "ஊதா வெளிர் கெட்டது",
  "block.minecraft.banner.stripe_right.red": "சிவப்பு வெளிறிய கெட்ட",
  "block.minecraft.banner.stripe_right.white": "வெள்ளை வெளிறிய கெட்ட",
  "block.minecraft.banner.stripe_right.yellow": "மஞ்சள் வெளிறிய கெட்ட",
  "block.minecraft.banner.stripe_top.black": "கருப்பு தலைமை",
  "block.minecraft.banner.stripe_top.blue": "நீலத் தலைவர்",
  "block.minecraft.banner.stripe_top.brown": "பிரவுன் தலைமை",
  "block.minecraft.banner.stripe_top.cyan": "சியான் தலைவர்",
  "block.minecraft.banner.stripe_top.gray": "சாம்பல் தலைவர்",
  "block.minecraft.banner.stripe_top.green": "பசுமை தலைவர்",
  "block.minecraft.banner.stripe_top.light_blue": "லைட் ப்ளூ தலைமை",
  "block.minecraft.banner.stripe_top.light_gray": "லைட் கிரே தலைமை",
  "block.minecraft.banner.stripe_top.lime": "சுண்ணாம்பு தலைமை",
  "block.minecraft.banner.stripe_top.magenta": "மெஜந்தா தலைவர்",
  "block.minecraft.banner.stripe_top.orange": "ஆரஞ்சு தலைவர்",
  "block.minecraft.banner.stripe_top.pink": "பிங்க் தலைமை",
  "block.minecraft.banner.stripe_top.purple": "ஊதா முதல்வர்",
  "block.minecraft.banner.stripe_top.red": "சிவப்பு தலைவர்",
  "block.minecraft.banner.stripe_top.white": "வெள்ளை முதல்வர்",
  "block.minecraft.banner.stripe_top.yellow": "மஞ்சள் தலைவர்",
  "block.minecraft.banner.triangle_bottom.black": "கருப்பு செவ்ரான்",
  "block.minecraft.banner.triangle_bottom.blue": "நீல செவ்ரான்",
  "block.minecraft.banner.triangle_bottom.brown": "பிரவுன் செவ்ரான்",
  "block.minecraft.banner.triangle_bottom.cyan": "சியான் செவ்ரான்",
  "block.minecraft.banner.triangle_bottom.gray": "சாம்பல் செவ்ரான்",
  "block.minecraft.banner.triangle_bottom.green": "பச்சை செவ்ரான்",
  "block.minecraft.banner.triangle_bottom.light_blue": "வெளிர் நீல செவ்ரான்",
  "block.minecraft.banner.triangle_bottom.light_gray": "வெளிர் சாம்பல் செவ்ரான்",
  "block.minecraft.banner.triangle_bottom.lime": "சுண்ணாம்பு செவ்ரான்",
  "block.minecraft.banner.triangle_bottom.magenta": "மெஜந்தா செவ்ரான்",
  "block.minecraft.banner.triangle_bottom.orange": "ஆரஞ்சு செவ்ரான்",
  "block.minecraft.banner.triangle_bottom.pink": "பிங்க் செவ்ரான்",
  "block.minecraft.banner.triangle_bottom.purple": "ஊதா செவ்ரான்",
  "block.minecraft.banner.triangle_bottom.red": "சிவப்பு செவ்ரான்",
  "block.minecraft.banner.triangle_bottom.white": "வெள்ளை செவ்ரான்",
  "block.minecraft.banner.triangle_bottom.yellow": "மஞ்சள் செவ்ரான்",
  "block.minecraft.banner.triangle_top.black": "கருப்பு தலைகீழ் செவ்ரான்",
  "block.minecraft.banner.triangle_top.blue": "நீல தலைகீழ் செவ்ரான்",
  "block.minecraft.banner.triangle_top.brown": "பிரவுன் தலைகீழ் செவ்ரான்",
  "block.minecraft.banner.triangle_top.cyan": "சியான் தலைகீழ் செவ்ரான்",
  "block.minecraft.banner.triangle_top.gray": "சாம்பல் தலைகீழ் செவ்ரான்",
  "block.minecraft.banner.triangle_top.green": "பச்சை தலைகீழ் செவ்ரான்",
  "block.minecraft.banner.triangle_top.light_blue": "வெளிர் நீல தலைகீழ் செவ்ரான்",
  "block.minecraft.banner.triangle_top.light_gray": "ஒளி சாம்பல் தலைகீழ் செவ்ரான்",
  "block.minecraft.banner.triangle_top.lime": "சுண்ணாம்பு தலைகீழ் செவ்ரான்",
  "block.minecraft.banner.triangle_top.magenta": "மெஜந்தா தலைகீழ் செவ்ரான்",
  "block.minecraft.banner.triangle_top.orange": "ஆரஞ்சு தலைகீழ் செவ்ரான்",
  "block.minecraft.banner.triangle_top.pink": "பிங்க் தலைகீழ் செவ்ரான்",
  "block.minecraft.banner.triangle_top.purple": "ஊதா தலைகீழ் செவ்ரான்",
  "block.minecraft.banner.triangle_top.red": "சிவப்பு தலைகீழ் செவ்ரான்",
  "block.minecraft.banner.triangle_top.white": "வெள்ளை தலைகீழ் செவ்ரான்",
  "block.minecraft.banner.triangle_top.yellow": "மஞ்சள் தலைகீழ் செவ்ரான்",
  "block.minecraft.banner.triangles_bottom.black": "கருப்பு அடிப்படை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_bottom.blue": "நீல அடிப்படை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_bottom.brown": "பிரவுன் பேஸ் உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_bottom.cyan": "சியான் பேஸ் உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_bottom.gray": "சாம்பல் அடிப்படை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_bottom.green": "பசுமை அடிப்படை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_bottom.light_blue": "வெளிர் நீல அடிப்படை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_bottom.light_gray": "ஒளி சாம்பல் அடிப்படை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_bottom.lime": "சுண்ணாம்பு அடிப்படை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_bottom.magenta": "மெஜந்தா அடிப்படை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_bottom.orange": "ஆரஞ்சு அடிப்படை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_bottom.pink": "பிங்க் பேஸ் உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_bottom.purple": "ஊதா அடிப்படை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_bottom.red": "சிவப்பு அடிப்படை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_bottom.white": "வெள்ளை அடிப்படை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_bottom.yellow": "மஞ்சள் அடிப்படை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_top.black": "கருப்பு தலைமை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_top.blue": "ப்ளூ தலைமை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_top.brown": "பிரவுன் தலைமை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_top.cyan": "சியான் தலைமை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_top.gray": "சாம்பல் தலைமை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_top.green": "பசுமை தலைமை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_top.light_blue": "வெளிர் நீல தலைமை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_top.light_gray": "லைட் கிரே தலைமை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_top.lime": "சுண்ணாம்பு தலைமை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_top.magenta": "மெஜந்தா தலைமை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_top.orange": "ஆரஞ்சு தலைமை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_top.pink": "பிங்க் தலைமை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_top.purple": "ஊதா தலைமை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_top.red": "சிவப்பு தலைமை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_top.white": "வெள்ளை தலைமை உள்தள்ளப்பட்டது",
  "block.minecraft.banner.triangles_top.yellow": "மஞ்சள் தலைமை உள்தள்ளப்பட்டது",
  "block.minecraft.barrel": "பேரல்",
  "block.minecraft.barrier": "தடை",
  "block.minecraft.basalt": "பசால்ட்",
  "block.minecraft.beacon": "பெக்கான்",
  "block.minecraft.beacon.primary": "முதன்மை பவர்",
  "block.minecraft.beacon.secondary": "இரண்டாம் பவர்",
  "block.minecraft.bed.no_sleep": "நீங்கள் இரவில் அல்லது இடியுடன் கூடிய நேரங்களில் மட்டுமே தூங்க முடியும்",
  "block.minecraft.bed.not_safe": "நீங்கள் இப்போது ஓய்வெடுக்க முடியாது; அருகிலுள்ள பேய்கள் உள்ளன",
  "block.minecraft.bed.obstructed": "இந்த படுக்கை தடைசெய்யப்பட்டுள்ளது",
  "block.minecraft.bed.occupied": "இந்த படுக்கை ஆக்கிரமிக்கப்பட்டுள்ளது",
  "block.minecraft.bed.too_far_away": "நீங்கள் இப்போது ஓய்வெடுக்க முடியாது; படுக்கை மிகவும் தொலைவில் உள்ளது",
  "block.minecraft.bedrock": "அடிநிலப்பாறை",
  "block.minecraft.bee_nest": "தேனீ கூடு",
  "block.minecraft.beehive": "தேன் கூடு",
  "block.minecraft.beetroots": "பீட்ரூட்ஸ்",
  "block.minecraft.bell": "பெல்",
  "block.minecraft.big_dripleaf": "பெரிய டிரிப்லீஃப்",
  "block.minecraft.big_dripleaf_stem": "பெரிய டிரிப்லெஃப் ஸ்டெம்",
  "block.minecraft.birch_button": "பிர்ச் பட்டன்",
  "block.minecraft.birch_door": "பிர்ச் டோர்",
  "block.minecraft.birch_fence": "பிர்ச் வேலி",
  "block.minecraft.birch_fence_gate": "பிர்ச் வேலி கேட்",
  "block.minecraft.birch_hanging_sign": "பிர்ச் தொங்கும் பலகை",
  "block.minecraft.birch_leaves": "பிர்ச் இலைகள்",
  "block.minecraft.birch_log": "பிர்ச் பதிவு",
  "block.minecraft.birch_planks": "பிர்ச் பிளாங்க்ஸ்",
  "block.minecraft.birch_pressure_plate": "பிர்ச் அழுத்தம் தட்டு",
  "block.minecraft.birch_sapling": "பிர்ச் சப்பாளிங்",
  "block.minecraft.birch_shelf": "Birch Shelf",
  "block.minecraft.birch_sign": "பிர்ச் சைன்",
  "block.minecraft.birch_slab": "பிர்ச் ஸ்லாப்",
  "block.minecraft.birch_stairs": "பிர்ச் படிக்கட்டுகள்",
  "block.minecraft.birch_trapdoor": "பிர்ச் டிராபூர்",
  "block.minecraft.birch_wall_hanging_sign": "பிர்ச் சுவர் தொங்கும் பலகை",
  "block.minecraft.birch_wall_sign": "பிர்ச் வோல் சைன்",
  "block.minecraft.birch_wood": "பிர்ச் மரம்",
  "block.minecraft.black_banner": "கருப்பு பேனர்",
  "block.minecraft.black_bed": "பிளாக் படுக்கை",
  "block.minecraft.black_candle": "கருப்பு மெழுகுவர்த்தி",
  "block.minecraft.black_candle_cake": "கருப்பு மெழுகுவர்த்தியுடன் கேக்",
  "block.minecraft.black_carpet": "பிளாக் கார்பெட்",
  "block.minecraft.black_concrete": "கருப்பு கான்கிரீட்",
  "block.minecraft.black_concrete_powder": "கருப்பு கான்கிரீட் தூள்",
  "block.minecraft.black_glazed_terracotta": "கருப்பு மெருகூட்டப்பட்ட டெர்ராக்கோட்டா",
  "block.minecraft.black_shulker_box": "பிளாக் ஷுல்கர் பெட்டி",
  "block.minecraft.black_stained_glass": "பிளாக் கறைபடிந்த கண்ணாடி",
  "block.minecraft.black_stained_glass_pane": "பிளாக் ஸ்டென்னை கண்ணாடி பேன்",
  "block.minecraft.black_terracotta": "கருப்பு டெர்ரகோட்டா",
  "block.minecraft.black_wool": "கருப்பு கம்பளி",
  "block.minecraft.blackstone": "கருப்புக்கல்",
  "block.minecraft.blackstone_slab": "கருப்புக்கல் பலகை",
  "block.minecraft.blackstone_stairs": "கருப்புக்கல் படிக்கட்டுக்கள்",
  "block.minecraft.blackstone_wall": "கருப்புக்கல் சுவர்",
  "block.minecraft.blast_furnace": "குண்டு வெடிப்பு",
  "block.minecraft.blue_banner": "நீல பேனர்",
  "block.minecraft.blue_bed": "ப்ளூ படுக்கை",
  "block.minecraft.blue_candle": "நீல மெழுகுவர்த்தி",
  "block.minecraft.blue_candle_cake": "நீல மெழுகுவர்த்தியுடன் கேக்",
  "block.minecraft.blue_carpet": "ப்ளூ கார்பெட்",
  "block.minecraft.blue_concrete": "ப்ளூ கான்கிரீட்",
  "block.minecraft.blue_concrete_powder": "நீல கான்கிரீட் தூள்",
  "block.minecraft.blue_glazed_terracotta": "நீல மெருகூட்டப்பட்ட டெர்ராக்கோட்டா",
  "block.minecraft.blue_ice": "ப்ளூ ஐஸ்",
  "block.minecraft.blue_orchid": "ப்ளூ ஆர்ச்சிட்",
  "block.minecraft.blue_shulker_box": "ப்ளூ ஷுல்கர் பெட்டி",
  "block.minecraft.blue_stained_glass": "நீல கறை படிந்த கண்ணாடி",
  "block.minecraft.blue_stained_glass_pane": "நீல நிற கண்ணாடி கண்ணாடி",
  "block.minecraft.blue_terracotta": "ப்ளூ டெர்ராகோட்டா",
  "block.minecraft.blue_wool": "ப்ளூ கம்பளி",
  "block.minecraft.bone_block": "எலும்பு பிளாக்",
  "block.minecraft.bookshelf": "புக்செல்ஃப்",
  "block.minecraft.brain_coral": "மூளை கோரல்",
  "block.minecraft.brain_coral_block": "மூளை கோரல் பிளாக்",
  "block.minecraft.brain_coral_fan": "மூளை பவள ரசிகர்",
  "block.minecraft.brain_coral_wall_fan": "மூளை பவள வால் ரசிகர்",
  "block.minecraft.brewing_stand": "பிரவுனிங் ஸ்டேண்ட்",
  "block.minecraft.brick_slab": "செங்கல் ஸ்லாப்",
  "block.minecraft.brick_stairs": "செங்கல் மாடி",
  "block.minecraft.brick_wall": "செங்கல் சுவர்",
  "block.minecraft.bricks": "செங்கல்கள்",
  "block.minecraft.brown_banner": "பிரவுன் பேனர்",
  "block.minecraft.brown_bed": "பிரவுன் படுக்கை",
  "block.minecraft.brown_candle": "பிரவுன் மெழுகுவர்த்தி",
  "block.minecraft.brown_candle_cake": "பிரவுன் மெழுகுவர்த்தியுடன் கேக்",
  "block.minecraft.brown_carpet": "பிரவுன் கார்பெட்",
  "block.minecraft.brown_concrete": "பிரவுன் கான்கிரீட்",
  "block.minecraft.brown_concrete_powder": "பிரவுன் கான்கிரீட் தூள்",
  "block.minecraft.brown_glazed_terracotta": "நீல மெருகூட்டப்பட்ட டெர்ராக்கோட்டா",
  "block.minecraft.brown_mushroom": "பிரவுன் காளான்",
  "block.minecraft.brown_mushroom_block": "பிரவுன் காளான் பிளாக்",
  "block.minecraft.brown_shulker_box": "பிரவுன் ஷுல்கர் பெட்டி",
  "block.minecraft.brown_stained_glass": "பிரவுன் கறை படிந்த கண்ணாடி",
  "block.minecraft.brown_stained_glass_pane": "பிரவுன் கறை படிந்த கண்ணாடி தகடு",
  "block.minecraft.brown_terracotta": "பிரவுன் டெர்ராகோட்டா",
  "block.minecraft.brown_wool": "பிரவுன் கம்பளி",
  "block.minecraft.bubble_column": "குமிழி வரிசை",
  "block.minecraft.bubble_coral": "பபுள் கோரல்",
  "block.minecraft.bubble_coral_block": "பபுள் கோரல் பிளாக்",
  "block.minecraft.bubble_coral_fan": "பப்பில் கோரல் ரசிகன்",
  "block.minecraft.bubble_coral_wall_fan": "பபுள் கோரல் வோல் ஃபான்",
  "block.minecraft.budding_amethyst": "வளரும் ஆமெத்திஸ்ட்",
  "block.minecraft.bush": "Bush",
  "block.minecraft.cactus": "கற்றாழை",
  "block.minecraft.cactus_flower": "Cactus Flower",
  "block.minecraft.cake": "கேக்",
  "block.minecraft.calcite": "சுண்ணாம்புக்கல்",
  "block.minecraft.calibrated_sculk_sensor": "அளவீடு செய்யப்பட்ட ஸ்கல்க் சென்சார்",
  "block.minecraft.campfire": "முகாமில் மூட்டும் நெருப்பு",
  "block.minecraft.candle": "மெழுகுவர்த்தி",
  "block.minecraft.candle_cake": "மஞ்சள் மெழுகுவர்த்தி",
  "block.minecraft.carrots": "கேரட்",
  "block.minecraft.cartography_table": "வரைபட அட்டவணை",
  "block.minecraft.carved_pumpkin": "செதுக்கப்பட்ட பூசணி",
  "block.minecraft.cauldron": "கொப்பரை",
  "block.minecraft.cave_air": "குகை ஏர்",
  "block.minecraft.cave_vines": "குகை கொடிகள்",
  "block.minecraft.cave_vines_plant": "குகை கொடிகள் ஆலை",
  "block.minecraft.chain": "செயின்",
  "block.minecraft.chain_command_block": "சங்கிலி கட்டளைத் தொகுதி",
  "block.minecraft.cherry_button": "செர்ரி பட்டன்",
  "block.minecraft.cherry_door": "செர்ரி கதவு",
  "block.minecraft.cherry_fence": "செர்ரி வேலி",
  "block.minecraft.cherry_fence_gate": "செர்ரி வேலி வாயில்",
  "block.minecraft.cherry_hanging_sign": "செர்ரி தொங்கும் பலகை",
  "block.minecraft.cherry_leaves": "செர்ரி இலைகள்",
  "block.minecraft.cherry_log": "செர்ரி மரம்",
  "block.minecraft.cherry_planks": "செர்ரி பலகைகள்",
  "block.minecraft.cherry_pressure_plate": "செர்ரி அழுத்தம் தட்டு",
  "block.minecraft.cherry_sapling": "செர்ரி மரக்கன்று",
  "block.minecraft.cherry_shelf": "Cherry Shelf",
  "block.minecraft.cherry_sign": "செர்ரி குறி",
  "block.minecraft.cherry_slab": "செர்ரி பாதி",
  "block.minecraft.cherry_stairs": "செர்ரி படிக்கட்டுகள்",
  "block.minecraft.cherry_trapdoor": "செர்ரி பொறி கதவு",
  "block.minecraft.cherry_wall_hanging_sign": "செர்ரி சுவர் தொங்கும் அடையாளம்",
  "block.minecraft.cherry_wall_sign": "செர்ரி சுவர் பலகை",
  "block.minecraft.cherry_wood": "செர்ரி மரம்",
  "block.minecraft.chest": "மார்பு",
  "block.minecraft.chipped_anvil": "முட்டாள் அன்வில்",
  "block.minecraft.chiseled_bookshelf": "வெட்டப்பட்ட புத்தக அலமாரி",
  "block.minecraft.chiseled_copper": "வெட்டப்பட்ட செம்பு",
  "block.minecraft.chiseled_deepslate": "வெட்டப்பட்ட ஆழமான",
  "block.minecraft.chiseled_nether_bricks": "வெட்டப்பட்ட நேதர் செங்கற்கள்",
  "block.minecraft.chiseled_polished_blackstone": "வெட்டப்பட்ட மெருகூட்டப்பட்ட பிளாக்ஸ்டோன்",
  "block.minecraft.chiseled_quartz_block": "சிசல்ட் குவார்ட்ஸ் பிளாக்",
  "block.minecraft.chiseled_red_sandstone": "சிவப்பு மணற்கல்",
  "block.minecraft.chiseled_resin_bricks": "Chiseled Resin Bricks",
  "block.minecraft.chiseled_sandstone": "சிஸ்டெல் சாண்ட்ஸ்டோன்",
  "block.minecraft.chiseled_stone_bricks": "சிசிடல் ஸ்டோன் பிரிக்ஸ்",
  "block.minecraft.chiseled_tuff": "வெட்டப்பட்ட டஃப்",
  "block.minecraft.chiseled_tuff_bricks": "வெட்டப்பட்ட டஃப் செங்கல்கள்",
  "block.minecraft.chorus_flower": "கோரஸ் ப்ளூ",
  "block.minecraft.chorus_plant": "கோரஸ் ஆலை",
  "block.minecraft.clay": "களிமண்",
  "block.minecraft.closed_eyeblossom": "Closed Eyeblossom",
  "block.minecraft.coal_block": "நிலக்கரி பிளாக்",
  "block.minecraft.coal_ore": "நிலக்கரி ஓரே",
  "block.minecraft.coarse_dirt": "கரடுமுரடான அழுக்கு",
  "block.minecraft.cobbled_deepslate": "கோபல்ட் டீப்ஸ்லேட்",
  "block.minecraft.cobbled_deepslate_slab": "ஒரு வேளை",
  "block.minecraft.cobbled_deepslate_stairs": "கோபல்ட் டீப்ஸ்லேட் படிக்கட்டுகள்",
  "block.minecraft.cobbled_deepslate_wall": "கோபல்ட் டீப்ஸ்லேட் சுவர்",
  "block.minecraft.cobblestone": "உருளைக்கல்",
  "block.minecraft.cobblestone_slab": "கோபல்ஸ்டோன் ஸ்லாப்",
  "block.minecraft.cobblestone_stairs": "கோபல்ஸ்டோன் மாடிகளில்",
  "block.minecraft.cobblestone_wall": "கோபல்ஸ்டோன் வோல்",
  "block.minecraft.cobweb": "கோப்வெப்",
  "block.minecraft.cocoa": "கோகோ",
  "block.minecraft.command_block": "கட்டளைத் தொகுதி",
  "block.minecraft.comparator": "ரெட்ஸ்டோன் ஒப்பீட்டாளர்",
  "block.minecraft.composter": "உரமாக்கல்",
  "block.minecraft.conduit": "கால்வாய்",
  "block.minecraft.copper_bars": "Copper Bars",
  "block.minecraft.copper_block": "தாமிரத்தின் தொகுதி",
  "block.minecraft.copper_bulb": "செம்பு பல்பு",
  "block.minecraft.copper_chain": "Copper Chain",
  "block.minecraft.copper_chest": "Copper Chest",
  "block.minecraft.copper_door": "செம்பு கதவு",
  "block.minecraft.copper_golem_statue": "Copper Golem Statue",
  "block.minecraft.copper_grate": "செம்பு தட்டி",
  "block.minecraft.copper_lantern": "Copper Lantern",
  "block.minecraft.copper_ore": "செப்பு தாது",
  "block.minecraft.copper_torch": "Copper Torch",
  "block.minecraft.copper_trapdoor": "செம்பு ட்ராப்டோர்",
  "block.minecraft.copper_wall_torch": "Copper Wall Torch",
  "block.minecraft.cornflower": "கான்ஃபிளவர்",
  "block.minecraft.cracked_deepslate_bricks": "கிராக் டீப்ஸ்லேட் செங்கற்கள்",
  "block.minecraft.cracked_deepslate_tiles": "கிராக் டீப்ஸ்லேட் செங்கற்கள்",
  "block.minecraft.cracked_nether_bricks": "கிராக் செய்யப்பட்ட நேதர் செங்கற்கள்",
  "block.minecraft.cracked_polished_blackstone_bricks": "கிராக் செய்யப்பட்ட பளபளப்பான பிளாக்ஸ்டோன் செங்கற்கள்",
  "block.minecraft.cracked_stone_bricks": "கிராக் ஸ்டோன் பிரிக்ஸ்",
  "block.minecraft.crafter": "கைவினைஞர்",
  "block.minecraft.crafting_table": "கைவினை அட்டவணை",
  "block.minecraft.creaking_heart": "Creaking Heart",
  "block.minecraft.creeper_head": "க்ரீப்பர் ஹெட்",
  "block.minecraft.creeper_wall_head": "க்ரீப்பர் வோல் ஹெட்",
  "block.minecraft.crimson_button": "கிரிம்சன் பட்டன்",
  "block.minecraft.crimson_door": "கிரிம்சன் கதவு",
  "block.minecraft.crimson_fence": "கிரிம்சன் வேலி",
  "block.minecraft.crimson_fence_gate": "கிரிம்சன் வேலி வாயில்",
  "block.minecraft.crimson_fungus": "கிரிம்சன் பூஞ்சை",
  "block.minecraft.crimson_hanging_sign": "Crimson Hanging Sign",
  "block.minecraft.crimson_hyphae": "கிரிம்சன் ஹைஃபே",
  "block.minecraft.crimson_nylium": "கிரிம்சன் நைலியம்",
  "block.minecraft.crimson_planks": "கிரிம்சன் பலகைகள்",
  "block.minecraft.crimson_pressure_plate": "கிரிம்சன் பிரஷர் பிளேட்",
  "block.minecraft.crimson_roots": "கிரிம்சன் ரூட்ஸ்",
  "block.minecraft.crimson_shelf": "Crimson Shelf",
  "block.minecraft.crimson_sign": "கிரிம்சன் அடையாளம்",
  "block.minecraft.crimson_slab": "கிரிம்சன் ஸ்லாப்",
  "block.minecraft.crimson_stairs": "கிரிம்சன் படிக்கட்டுகள்",
  "block.minecraft.crimson_stem": "கிரிம்சன் ஸ்டெம்",
  "block.minecraft.crimson_trapdoor": "கிரிம்சன் டிராப்டூர்",
  "block.minecraft.crimson_wall_hanging_sign": "Crimson Wall Hanging Sign",
  "block.minecraft.crimson_wall_sign": "கிரிம்சன் சுவர் அடையாளம்",
  "block.minecraft.crying_obsidian": "அழுகை அப்சிடியன்",
  "block.minecraft.cut_copper": "செதுக்கிய செப்பு",
  "block.minecraft.cut_copper_slab": "செதுக்கிய செப்பு அறைகணசதுரம்",
  "block.minecraft.cut_copper_stairs": "செதுக்கிய செப்பு படிகள்",
  "block.minecraft.cut_red_sandstone": "சிவப்பு மணற்கல் வெட்டு",
  "block.minecraft.cut_red_sandstone_slab": "சிவப்பு மணற்கல் கல்லின் அடி",
  "block.minecraft.cut_sandstone": "வெட்டு மணல்",
  "block.minecraft.cut_sandstone_slab": "சாண்ட்ஸ்டோன் ஸ்லாப் வெட்டு",
  "block.minecraft.cyan_banner": "சியான் பதாகை",
  "block.minecraft.cyan_bed": "சியான் படுக்கை",
  "block.minecraft.cyan_candle": "சியான் மெழுகுவர்த்தி",
  "block.minecraft.cyan_candle_cake": "சியான் மெழுகுவர்த்தியுடன் கேக்",
  "block.minecraft.cyan_carpet": "சியான் கார்பெட்",
  "block.minecraft.cyan_concrete": "சயன் கான்கிரீட்",
  "block.minecraft.cyan_concrete_powder": "சியான் கான்கிரீட் தூள்",
  "block.minecraft.cyan_glazed_terracotta": "சியான் கிளேசட் டெர்ராகோட்டா",
  "block.minecraft.cyan_shulker_box": "சியான் ஷுல்கர் பெட்டி",
  "block.minecraft.cyan_stained_glass": "சியான் கறை படிந்த கண்ணாடி",
  "block.minecraft.cyan_stained_glass_pane": "சியான் படிந்த கண்ணாடி பேன்",
  "block.minecraft.cyan_terracotta": "சியான் டெர்ராகோட்டா",
  "block.minecraft.cyan_wool": "சியான் கம்பளி",
  "block.minecraft.damaged_anvil": "சேதமடைந்த அன்வில்",
  "block.minecraft.dandelion": "டேன்டேலியன்",
  "block.minecraft.dark_oak_button": "டார்க் ஓக் பட்டன்",
  "block.minecraft.dark_oak_door": "டார்க் ஓக் கதவு",
  "block.minecraft.dark_oak_fence": "டார்க் ஓக் ஃபென்ஸ்",
  "block.minecraft.dark_oak_fence_gate": "டார்க் ஓக் வேலி கேட்",
  "block.minecraft.dark_oak_hanging_sign": "Dark Oak Hanging Sign",
  "block.minecraft.dark_oak_leaves": "டார்க் ஓக் இலைகள்",
  "block.minecraft.dark_oak_log": "டார்க் ஓக் புகுபதிகை",
  "block.minecraft.dark_oak_planks": "டார்க் ஓக் பிளாங்குகள்",
  "block.minecraft.dark_oak_pressure_plate": "டார்க் ஓக் அழுத்தம் தட்டு",
  "block.minecraft.dark_oak_sapling": "டார்க் ஓக் சப்பாளி",
  "block.minecraft.dark_oak_shelf": "Dark Oak Shelf",
  "block.minecraft.dark_oak_sign": "டார்க் ஓக் சைன்",
  "block.minecraft.dark_oak_slab": "டார்க் ஓக் ஸ்லாப்",
  "block.minecraft.dark_oak_stairs": "டார்க் ஓக் மாடி",
  "block.minecraft.dark_oak_trapdoor": "டார்க் ஓக் ட்ராபர்டு",
  "block.minecraft.dark_oak_wall_hanging_sign": "Dark Oak Wall Hanging Sign",
  "block.minecraft.dark_oak_wall_sign": "டார்க் ஓக் வால் சைன்",
  "block.minecraft.dark_oak_wood": "டார்க் ஓக் வூட்",
  "block.minecraft.dark_prismarine": "டார்க் பிரைசரைன்",
  "block.minecraft.dark_prismarine_slab": "டார்க் பிரைசரைன் ஸ்லாப்",
  "block.minecraft.dark_prismarine_stairs": "டார்க் பிரைசரைன் மாடிப்படி",
  "block.minecraft.daylight_detector": "பகல் கண்டறிதல்",
  "block.minecraft.dead_brain_coral": "இறந்த மூளை கோரல்",
  "block.minecraft.dead_brain_coral_block": "இறந்த மூளை கோரல் பிளாக்",
  "block.minecraft.dead_brain_coral_fan": "இறந்த மூளை கோரல் ரசிகன்",
  "block.minecraft.dead_brain_coral_wall_fan": "டெட் மூளை பவள வால் ரசிகர்",
  "block.minecraft.dead_bubble_coral": "இறந்த குமிழ் கோரல்",
  "block.minecraft.dead_bubble_coral_block": "இறந்த குமிழ் கோரல் பிளாக்",
  "block.minecraft.dead_bubble_coral_fan": "இறந்த பபுள் கோரல் ரசிகன்",
  "block.minecraft.dead_bubble_coral_wall_fan": "இறந்த குமிழ் கோரல் வால் ரசிகன்",
  "block.minecraft.dead_bush": "டெட் புஷ்",
  "block.minecraft.dead_fire_coral": "டெட் ஃபயர் கோரல்",
  "block.minecraft.dead_fire_coral_block": "டெட் ஃபயர் கோரல் பிளாக்",
  "block.minecraft.dead_fire_coral_fan": "டெட் தீ கோரல் ஃபேன்",
  "block.minecraft.dead_fire_coral_wall_fan": "டெட் ஃபயர் கோரல் வால் பேன்",
  "block.minecraft.dead_horn_coral": "டெட் ஹார்ன் கோரல்",
  "block.minecraft.dead_horn_coral_block": "டெட் ஹார்ன் கொரல் பிளாக்",
  "block.minecraft.dead_horn_coral_fan": "டெட் ஹார்ன் கோரல் ரசிகன்",
  "block.minecraft.dead_horn_coral_wall_fan": "டெட் ஹார்ன் கொரல் வோல் ஃபான்",
  "block.minecraft.dead_tube_coral": "டெட் குழாய் கோரல்",
  "block.minecraft.dead_tube_coral_block": "டெட் குழாய் கோரல் பிளாக்",
  "block.minecraft.dead_tube_coral_fan": "டெட் குழாய் கோரல் ரசிகன்",
  "block.minecraft.dead_tube_coral_wall_fan": "டெட் குழாய் பவள வால் ரசிகர்",
  "block.minecraft.decorated_pot": "அலங்கரிக்கப்பட்டது பாட்",
  "block.minecraft.deepslate": "ஆழமான",
  "block.minecraft.deepslate_brick_slab": "ஆழமான செங்கற்கள்",
  "block.minecraft.deepslate_brick_stairs": "ஆழமான செங்கல் படிக்கட்டுகள்",
  "block.minecraft.deepslate_brick_wall": "ஆழமான செங்கல் சுவர்",
  "block.minecraft.deepslate_bricks": "ஆழமான செங்கற்கள்",
  "block.minecraft.deepslate_coal_ore": "ஆழமான நிலக்கரி தாது",
  "block.minecraft.deepslate_copper_ore": "ஆழமான செப்பு தாது",
  "block.minecraft.deepslate_diamond_ore": "ஆழமான நிலக்கரி தாது",
  "block.minecraft.deepslate_emerald_ore": "ஆழமான நிலக்கரி தாது",
  "block.minecraft.deepslate_gold_ore": "ஆழமான நிலக்கரி தாது",
  "block.minecraft.deepslate_iron_ore": "ஆழமான நிலக்கரி தாது",
  "block.minecraft.deepslate_lapis_ore": "டீப்ஸ்லேட் லாபிஸ் லாசுலி தாது",
  "block.minecraft.deepslate_redstone_ore": "ஆழமான நிலக்கரி தாது",
  "block.minecraft.deepslate_tile_slab": "ஆழமான செங்கற்கள்",
  "block.minecraft.deepslate_tile_stairs": "ஆழமான செங்கல் படிக்கட்டுகள்",
  "block.minecraft.deepslate_tile_wall": "ஆழமான செங்கல் சுவர்",
  "block.minecraft.deepslate_tiles": "ஆழமான ஓடுகள்",
  "block.minecraft.detector_rail": "கண்டறிதல் ரயில்",
  "block.minecraft.diamond_block": "டயமண்ட் பிளாக்",
  "block.minecraft.diamond_ore": "டயமண்ட் ஓரே",
  "block.minecraft.diorite": "Diorite",
  "block.minecraft.diorite_slab": "தியரிட் ஸ்லாப்",
  "block.minecraft.diorite_stairs": "கிரானைட் படிக்கட்டுகள்",
  "block.minecraft.diorite_wall": "தியரிட் வோல்",
  "block.minecraft.dirt": "டர்ட்",
  "block.minecraft.dirt_path": "அழுக்கு பாதை",
  "block.minecraft.dispenser": "வழங்கு",
  "block.minecraft.dragon_egg": "டிராகன் முட்டை",
  "block.minecraft.dragon_head": "டிராகன் தலைமை",
  "block.minecraft.dragon_wall_head": "டிராகன் வோல் தலை",
  "block.minecraft.dried_ghast": "காய்ந்த காஸ்ட்",
  "block.minecraft.dried_kelp_block": "உலர்ந்த கெல்ப் பிளாக்",
  "block.minecraft.dripstone_block": "சொட்டு கல் கனசதுரம்",
  "block.minecraft.dropper": "துளிசொட்டி",
  "block.minecraft.emerald_block": "எமரால்டு தடுப்பு",
  "block.minecraft.emerald_ore": "எமரால்டு தாது",
  "block.minecraft.enchanting_table": "மயக்கும் அட்டவணை",
  "block.minecraft.end_gateway": "முடிவு நுழைவாயில்",
  "block.minecraft.end_portal": "இறுதி வலைவாசல்",
  "block.minecraft.end_portal_frame": "இறுதி வலைத் தளம்",
  "block.minecraft.end_rod": "முடிவு ராட்",
  "block.minecraft.end_stone": "முடிவு கல்",
  "block.minecraft.end_stone_brick_slab": "முடிவு கல் செங்கல் ஸ்லாப்",
  "block.minecraft.end_stone_brick_stairs": "முடிவு கல் செங்கல் மாடி",
  "block.minecraft.end_stone_brick_wall": "முடிவு கல் செங்கல் சுவர்",
  "block.minecraft.end_stone_bricks": "முடிவு கல் செங்கல்கள்",
  "block.minecraft.ender_chest": "எண்டர் செஸ்ட்",
  "block.minecraft.exposed_chiseled_copper": "Exposed Chiseled Copper",
  "block.minecraft.exposed_copper": "அம்பலப்படுத்தப்பட்ட செம்பு",
  "block.minecraft.exposed_copper_bars": "Exposed Copper Bars",
  "block.minecraft.exposed_copper_bulb": "Exposed Copper Bulb",
  "block.minecraft.exposed_copper_chain": "Exposed Copper Chain",
  "block.minecraft.exposed_copper_chest": "Exposed Copper Chest",
  "block.minecraft.exposed_copper_door": "Exposed Copper Door",
  "block.minecraft.exposed_copper_golem_statue": "Exposed Copper Golem Statue",
  "block.minecraft.exposed_copper_grate": "வெளிப்பட்ட செப்பு கிரேட்",
  "block.minecraft.exposed_copper_lantern": "Exposed Copper Lantern",
  "block.minecraft.exposed_copper_trapdoor": "வெளிப்பட்ட செப்பு கிரேட்",
  "block.minecraft.exposed_cut_copper": "மெழுகு பூசிய செதுக்கிய செப்பு",
  "block.minecraft.exposed_cut_copper_slab": "மெழுகு பூசிய செதுக்கிய செப்பு படிகள்",
  "block.minecraft.exposed_cut_copper_stairs": "மெழுகு பூசிய செதுக்கிய செப்பு படிகள்",
  "block.minecraft.exposed_lightning_rod": "Exposed Lightning Rod",
  "block.minecraft.farmland": "விவசாய நிலத்தை",
  "block.minecraft.fern": "பன்னம்",
  "block.minecraft.fire": "தீ",
  "block.minecraft.fire_coral": "தீ கோரல்",
  "block.minecraft.fire_coral_block": "தீ கோரல் பிளாக்",
  "block.minecraft.fire_coral_fan": "தீ கோரல் ரசிகன்",
  "block.minecraft.fire_coral_wall_fan": "தீ பவள வால் ரசிகர்",
  "block.minecraft.firefly_bush": "Firefly Bush",
  "block.minecraft.fletching_table": "ஃபிளெக்கிங் டேபிள்",
  "block.minecraft.flower_pot": "மலர் பாட்",
  "block.minecraft.flowering_azalea": "பூக்கும் அசேலியா",
  "block.minecraft.flowering_azalea_leaves": "பூக்கும் அசேலியா இலைகள்",
  "block.minecraft.frogspawn": "தவளை பறவை",
  "block.minecraft.frosted_ice": "உறைந்த பனி",
  "block.minecraft.furnace": "சூளை",
  "block.minecraft.gilded_blackstone": "கில்டட் பிளாக்ஸ்டோன்",
  "block.minecraft.glass": "கண்ணாடி",
  "block.minecraft.glass_pane": "கண்ணாடி பேன்",
  "block.minecraft.glow_lichen": "ஒளிரும் லிச்சென்",
  "block.minecraft.glowstone": "ஒளி கல்",
  "block.minecraft.gold_block": "தங்கம் பிளாக்",
  "block.minecraft.gold_ore": "தங்க ஓரே",
  "block.minecraft.golden_dandelion": "Golden Dandelion",
  "block.minecraft.granite": "கிரானைட்",
  "block.minecraft.granite_slab": "கிரானைட் ஸ்லாப்",
  "block.minecraft.granite_stairs": "கிரானைட் படிக்கட்டுகள்",
  "block.minecraft.granite_wall": "கிரானைட் வால்",
  "block.minecraft.grass": "புல்",
  "block.minecraft.grass_block": "குறுக்கு பிளாக்",
  "block.minecraft.gravel": "சரளை",
  "block.minecraft.gray_banner": "சாம்பல் பதாகை",
  "block.minecraft.gray_bed": "கிரே படுக்கை",
  "block.minecraft.gray_candle": "சாம்பல் மெழுகுவர்த்தி",
  "block.minecraft.gray_candle_cake": "சாம்பல் மெழுகுவர்த்தியுடன் கேக்",
  "block.minecraft.gray_carpet": "சாம்பல் கம்பளம்",
  "block.minecraft.gray_concrete": "சாம்பல் கான்கிரீட்",
  "block.minecraft.gray_concrete_powder": "சாம்பல் கான்கிரீட் தூள்",
  "block.minecraft.gray_glazed_terracotta": "சாம்பல் பளபளப்பான டெர்ராகோட்டா",
  "block.minecraft.gray_shulker_box": "சாம்பல் ஷுல்கர் பெட்டி",
  "block.minecraft.gray_stained_glass": "சாம்பல் நிற கண்ணாடி",
  "block.minecraft.gray_stained_glass_pane": "சாம்பல் நிற கண்ணாடி கண்ணாடி",
  "block.minecraft.gray_terracotta": "சாம்பல் டெர்ராகோட்டா",
  "block.minecraft.gray_wool": "சாம்பல் கம்பளி",
  "block.minecraft.green_banner": "பச்சை பேனர்",
  "block.minecraft.green_bed": "பசுமை படுக்கை",
  "block.minecraft.green_candle": "பச்சை மெழுகுவர்த்தி",
  "block.minecraft.green_candle_cake": "பச்சை மெழுகுவர்த்தியுடன் கேக்",
  "block.minecraft.green_carpet": "பச்சை கம்பளம்",
  "block.minecraft.green_concrete": "பச்சை கான்கிரீட்",
  "block.minecraft.green_concrete_powder": "பச்சை கான்கிரீட் தூள்",
  "block.minecraft.green_glazed_terracotta": "பச்சை மெருகூட்டப்பட்ட டெர்ராக்கோட்டா",
  "block.minecraft.green_shulker_box": "பச்சை ஷூல்கர் பெட்டி",
  "block.minecraft.green_stained_glass": "பசுமை கறை படிந்த கண்ணாடி",
  "block.minecraft.green_stained_glass_pane": "பசுமை படிந்த கண்ணாடி தகடு",
  "block.minecraft.green_terracotta": "பச்சை டெர்ராகோட்டா",
  "block.minecraft.green_wool": "பச்சை கம்பளி",
  "block.minecraft.grindstone": "அம்மி",
  "block.minecraft.hanging_roots": "தொங்கும் வேர்கள்",
  "block.minecraft.hay_block": "ஹே பேல்",
  "block.minecraft.heavy_core": "கனமான கோர்",
  "block.minecraft.heavy_weighted_pressure_plate": "கனரக எடை அழுத்த அழுத்தம்",
  "block.minecraft.honey_block": "தேன் தொகுதி",
  "block.minecraft.honeycomb_block": "தேன்கூடு தொகுதி",
  "block.minecraft.hopper": "ஹாப்பர்",
  "block.minecraft.horn_coral": "ஹார்ன் கோரல்",
  "block.minecraft.horn_coral_block": "ஹார்ன் கோரல் பிளாக்",
  "block.minecraft.horn_coral_fan": "ஹார்ன் கோரல் ரசிகன்",
  "block.minecraft.horn_coral_wall_fan": "ஹார்ன் கொரல் வோல் ஃபான்",
  "block.minecraft.ice": "ஐஸ்",
  "block.minecraft.infested_chiseled_stone_bricks": "உட்செலுத்தப்பட்ட கல் வெட்டப்பட்ட செங்கற்கள்",
  "block.minecraft.infested_cobblestone": "பாதிக்கப்பட்ட உருளைக்கல்",
  "block.minecraft.infested_cracked_stone_bricks": "உள்ளார்ந்த கிராக் ஸ்டோன் பிரிக்ஸ்",
  "block.minecraft.infested_deepslate": "வெட்டப்பட்ட ஆழமான",
  "block.minecraft.infested_mossy_stone_bricks": "பாதிக்கப்பட்ட மோஸ்ஸி கல் செங்கல்கள்",
  "block.minecraft.infested_stone": "இன்ஸ்டஸ்ட் ஸ்டோன்",
  "block.minecraft.infested_stone_bricks": "இன்ஸ்ட்டெட் ஸ்டோன் பிரிக்ஸ்",
  "block.minecraft.iron_bars": "இரும்பு பார்கள்",
  "block.minecraft.iron_block": "இரும்புத் தொகுதி",
  "block.minecraft.iron_chain": "Iron Chain",
  "block.minecraft.iron_door": "இரும்பு கதவு",
  "block.minecraft.iron_ore": "இரும்பு தாது",
  "block.minecraft.iron_trapdoor": "அயன் ட்ராபர்டு",
  "block.minecraft.jack_o_lantern": "ஜாக் ஓ'லாந்தர்ன்",
  "block.minecraft.jigsaw": "ஜிக் பிளாக்",
  "block.minecraft.jukebox": "ஜூக்பாக்ஸ்",
  "block.minecraft.jungle_button": "ஜங்கிள் பட்டன்",
  "block.minecraft.jungle_door": "ஜங்கிள் கதவு",
  "block.minecraft.jungle_fence": "ஜங்கிள் வேலி",
  "block.minecraft.jungle_fence_gate": "ஜங்கிள் ஃபென்ஸ் கேட்",
  "block.minecraft.jungle_hanging_sign": "ஜங்கிள் தொங்கும் பலகை",
  "block.minecraft.jungle_leaves": "ஜங்கிள் இலைகள்",
  "block.minecraft.jungle_log": "ஜங்கிள் பதிவு",
  "block.minecraft.jungle_planks": "ஜங்கிள் பிளாங்க்ஸ்",
  "block.minecraft.jungle_pressure_plate": "ஜங்கிள் அழுத்தம் தட்டு",
  "block.minecraft.jungle_sapling": "ஜங்கிள் சந்திப்பு",
  "block.minecraft.jungle_shelf": "Jungle Shelf",
  "block.minecraft.jungle_sign": "ஜங்கிள் சைன்",
  "block.minecraft.jungle_slab": "ஜங்கிள் ஸ்லாப்",
  "block.minecraft.jungle_stairs": "ஜங்கிள் மாடி",
  "block.minecraft.jungle_trapdoor": "ஜங்கிள் டிராபூர்",
  "block.minecraft.jungle_wall_hanging_sign": "ஜங்கிள் வோல் தொங்கும் பலகை",
  "block.minecraft.jungle_wall_sign": "ஜங்கிள் வோல் சைன்",
  "block.minecraft.jungle_wood": "ஜங்கிள் வூட்",
  "block.minecraft.kelp": "கெல்ப்",
  "block.minecraft.kelp_plant": "கெல்ப் ஆலை",
  "block.minecraft.ladder": "லேடர்",
  "block.minecraft.lantern": "விளக்கு",
  "block.minecraft.lapis_block": "லாபிஸ் லாசூலியின் தொகுதி",
  "block.minecraft.lapis_ore": "லாபீஸ் லஸுலி ஓரே",
  "block.minecraft.large_amethyst_bud": "பெரிய ஆமெத்திஸ்ட் மொட்டு",
  "block.minecraft.large_fern": "பெரிய பெர்ன்",
  "block.minecraft.lava": "எரிமலைக்குழம்பு",
  "block.minecraft.lava_cauldron": "லாவா கொதிகலன்",
  "block.minecraft.leaf_litter": "Leaf Litter",
  "block.minecraft.lectern": "இதனூடாக",
  "block.minecraft.lever": "லீவர்",
  "block.minecraft.light": "ஒளி",
  "block.minecraft.light_blue_banner": "வெளிர் நீல பதாகை",
  "block.minecraft.light_blue_bed": "ஒளி நீலம் படுக்கை",
  "block.minecraft.light_blue_candle": "வெளிர் நீல மெழுகுவர்த்தி",
  "block.minecraft.light_blue_candle_cake": "வெளிர் நீல மெழுகுவர்த்தியுடன் கேக்",
  "block.minecraft.light_blue_carpet": "லைட் ப்ளூ கார்பெட்",
  "block.minecraft.light_blue_concrete": "ஒளி ப்ளூ கான்கிரீட்",
  "block.minecraft.light_blue_concrete_powder": "லைட் ப்ளூ கான்கிரீட் தூள்",
  "block.minecraft.light_blue_glazed_terracotta": "லைட் ப்ளூ பளபளப்பான டெர்ராகோட்டா",
  "block.minecraft.light_blue_shulker_box": "லைட் ப்ளூ ஷுல்கர் பாக்ஸ்",
  "block.minecraft.light_blue_stained_glass": "ஒளி நீல கறை படிந்த கண்ணாடி",
  "block.minecraft.light_blue_stained_glass_pane": "லைட் ப்ளூ ஸ்டேன்ட் கண்ணாடி பேன்",
  "block.minecraft.light_blue_terracotta": "ஒளி ப்ளூ டெர்ராகோட்டா",
  "block.minecraft.light_blue_wool": "லைட் ப்ளூ கம்பளி",
  "block.minecraft.light_gray_banner": "ஒளி சாம்பல் பதாகை",
  "block.minecraft.light_gray_bed": "மெல்லிய சாம்பல் நிறம் படுக்கை",
  "block.minecraft.light_gray_candle": "வெளிர் சாம்பல் மெழுகுவர்த்தி",
  "block.minecraft.light_gray_candle_cake": "ஒளி சாம்பல் மெழுகுவர்த்தியுடன் கேக்",
  "block.minecraft.light_gray_carpet": "ஒளி சாம்பல் கம்பளம்",
  "block.minecraft.light_gray_concrete": "ஒளி சாம்பல் கான்கிரீட்",
  "block.minecraft.light_gray_concrete_powder": "ஒளி சாம்பல் கான்கிரீட் தூள்",
  "block.minecraft.light_gray_glazed_terracotta": "லைட் சாம்பல் பளபளப்பான டெர்ராக்கோட்டா",
  "block.minecraft.light_gray_shulker_box": "ஒளி சாம்பல் ஷுல்கர் பெட்டி",
  "block.minecraft.light_gray_stained_glass": "ஒளி சாம்பல் நிற கண்ணாடி",
  "block.minecraft.light_gray_stained_glass_pane": "லைட் கிரே ஸ்டைண்ட்டு கண்ணாடி பேன்",
  "block.minecraft.light_gray_terracotta": "ஒளி சாம்பல் டெர்ராகோட்டா",
  "block.minecraft.light_gray_wool": "ஒளி சாம்பல் கம்பளி",
  "block.minecraft.light_weighted_pressure_plate": "லேசான எடை கொண்ட அழுத்தம் தட்டு",
  "block.minecraft.lightning_rod": "மின்னல் ஈற்பு கம்பி",
  "block.minecraft.lilac": "இளஞ்சிவப்பு",
  "block.minecraft.lily_of_the_valley": "பள்ளத்தாக்கு லில்லி",
  "block.minecraft.lily_pad": "லில்லி பேட்",
  "block.minecraft.lime_banner": "சுண்ணாம்பு பேனர்",
  "block.minecraft.lime_bed": "எலுமிச்சை படுக்கை",
  "block.minecraft.lime_candle": "சுண்ணாம்பு மெழுகுவர்த்தி",
  "block.minecraft.lime_candle_cake": "சுண்ணாம்பு மெழுகுவர்த்தியுடன் கேக்",
  "block.minecraft.lime_carpet": "சுண்ணாம்பு கம்பளம்",
  "block.minecraft.lime_concrete": "எலுமிச்சை கான்கிரீட்",
  "block.minecraft.lime_concrete_powder": "சுண்ணாம்பு கான்கிரீட் தூள்",
  "block.minecraft.lime_glazed_terracotta": "சுண்ணாம்பு பளபளப்பான டெர்ராக்கோட்டா",
  "block.minecraft.lime_shulker_box": "சுண்ணாம்பு சுருள் பெட்டி",
  "block.minecraft.lime_stained_glass": "எலுமிச்சை கறை படிந்த கண்ணாடி",
  "block.minecraft.lime_stained_glass_pane": "சுண்ணாம்பு படிந்த கண்ணாடி தகடு",
  "block.minecraft.lime_terracotta": "எலுமிச்சை டெர்ராகோட்டா",
  "block.minecraft.lime_wool": "சுண்ணாம்பு கம்பளி",
  "block.minecraft.lodestone": "மடய்கல்",
  "block.minecraft.loom": "தறி",
  "block.minecraft.magenta_banner": "மெஜந்தா பேனர்",
  "block.minecraft.magenta_bed": "மெஜந்தா படுக்கை",
  "block.minecraft.magenta_candle": "மெஜந்தா மெழுகுவர்த்தி",
  "block.minecraft.magenta_candle_cake": "ஒரு வேளை",
  "block.minecraft.magenta_carpet": "மெஜந்தா கார்பெட்",
  "block.minecraft.magenta_concrete": "மெஜந்தா கான்கிரீட்",
  "block.minecraft.magenta_concrete_powder": "மெஜந்தா கான்கிரீட் தூள்",
  "block.minecraft.magenta_glazed_terracotta": "மெஜந்தா பளபளப்பான டெர்ராகோட்டா",
  "block.minecraft.magenta_shulker_box": "மெஜந்த ஷுல்கர் பெட்டி",
  "block.minecraft.magenta_stained_glass": "மெஜந்தா கறை படிந்த கண்ணாடி",
  "block.minecraft.magenta_stained_glass_pane": "மெஜந்தா படிந்த கண்ணாடி பேன்",
  "block.minecraft.magenta_terracotta": "மெஜந்த டெர்ராகோட்டா",
  "block.minecraft.magenta_wool": "மெஜந்தா கம்பளி",
  "block.minecraft.magma_block": "மாக்மா பிளாக்",
  "block.minecraft.mangrove_button": "சதுப்புநில மர பொத்தான்",
  "block.minecraft.mangrove_door": "சதுப்புநில மர கதவு",
  "block.minecraft.mangrove_fence": "சதுப்புநில மர வேலி",
  "block.minecraft.mangrove_fence_gate": "சதுப்புநில மர வேலி கதவு",
  "block.minecraft.mangrove_hanging_sign": "மாங்குரோவ் தொங்கும் அடையாளம்",
  "block.minecraft.mangrove_leaves": "சதுப்புநில மர இலைகள்",
  "block.minecraft.mangrove_log": "சதுப்புநில மரத்துண்டு",
  "block.minecraft.mangrove_planks": "சதுப்புநில மர பலகை",
  "block.minecraft.mangrove_pressure_plate": "சதுப்புநில மர அழுத்தம் தட்டு",
  "block.minecraft.mangrove_propagule": "சதுப்புநில மர பிள்ளை",
  "block.minecraft.mangrove_roots": "சதுப்புநில மர வேர்",
  "block.minecraft.mangrove_shelf": "Mangrove Shelf",
  "block.minecraft.mangrove_sign": "சதுப்புநில மர பெயர்ப் பலகை",
  "block.minecraft.mangrove_slab": "சதுப்புநில மர அடுக்கு",
  "block.minecraft.mangrove_stairs": "சதுப்புநில மர படிக்கட்டு",
  "block.minecraft.mangrove_trapdoor": "சதுப்புநில மர பொறி கதவு",
  "block.minecraft.mangrove_wall_hanging_sign": "Mangrove Wall Hanging Sign",
  "block.minecraft.mangrove_wall_sign": "சதுப்புநில மர சுவர் பெயர்ப் பலகை",
  "block.minecraft.mangrove_wood": "சதுப்புநில மர கட்டை",
  "block.minecraft.medium_amethyst_bud": "நடுத்தர அளவிலான ஆமெத்திஸ்ட் மொட்டு",
  "block.minecraft.melon": "முலாம்பழம்",
  "block.minecraft.melon_stem": "மெலோன் ஸ்டெம்",
  "block.minecraft.moss_block": "பாசி தொகுதி",
  "block.minecraft.moss_carpet": "பாசி கம்பளம்",
  "block.minecraft.mossy_cobblestone": "மோஸ்ஸி உருளைக்கல்",
  "block.minecraft.mossy_cobblestone_slab": "மோஸ்ஸி உருளைக்கல் ஸ்லாப்",
  "block.minecraft.mossy_cobblestone_stairs": "மோஸ்ஸி உருளைக்கல் மாடிப்படி",
  "block.minecraft.mossy_cobblestone_wall": "மோஸி கோப்ஸ்டோன் சுவர்",
  "block.minecraft.mossy_stone_brick_slab": "மோசி ஸ்டோன் பிரிக் ஸ்லாப்",
  "block.minecraft.mossy_stone_brick_stairs": "மோஸ்ஸி கல் செங்கல் மாடிப்படி",
  "block.minecraft.mossy_stone_brick_wall": "மோசி ஸ்டோன் செங்கல் சுவர்",
  "block.minecraft.mossy_stone_bricks": "மோசி ஸ்டோன் பிரிக்ஸ்",
  "block.minecraft.moving_piston": "பிஸ்டன் நகரும்",
  "block.minecraft.mud": "சேறு",
  "block.minecraft.mud_brick_slab": "மண் செங்கல் அடுக்கு",
  "block.minecraft.mud_brick_stairs": "மண் செங்கல் படிக்கட்டு",
  "block.minecraft.mud_brick_wall": "மண் செங்கல் சுவர்",
  "block.minecraft.mud_bricks": "மண் செங்கல்",
  "block.minecraft.muddy_mangrove_roots": "சேற்று நிறைந்த சதுப்புநில மர வேர்கள்",
  "block.minecraft.mushroom_stem": "காளான் தண்டு",
  "block.minecraft.mycelium": "பூசண",
  "block.minecraft.nether_brick_fence": "நெதர்லாந்து செங்கல் வேலி",
  "block.minecraft.nether_brick_slab": "நெதர் ப்ரிக் ஸ்லாப்",
  "block.minecraft.nether_brick_stairs": "நெதர்லாந்து செங்கல் மாடி",
  "block.minecraft.nether_brick_wall": "நெதர்லாந்து செங்கல் சுவர்",
  "block.minecraft.nether_bricks": "நெதர்லாந்து பிரிக்ஸ்",
  "block.minecraft.nether_gold_ore": "நெதர் தங்க தாது",
  "block.minecraft.nether_portal": "நெதர்லாந்து போர்ட்டல்",
  "block.minecraft.nether_quartz_ore": "நெதர்லாந்தின் குவார்ட்ஸ்",
  "block.minecraft.nether_sprouts": "நேதர் முளைகள்",
  "block.minecraft.nether_wart": "நெதர் வார்",
  "block.minecraft.nether_wart_block": "நெதர் வொர்க் பிளாக்",
  "block.minecraft.netherite_block": "நெதரைட்டின் தொகுதி",
  "block.minecraft.netherrack": "நரகத்தின் பாறை",
  "block.minecraft.note_block": "குறிப்பு தடு",
  "block.minecraft.oak_button": "ஓக் பட்டன்",
  "block.minecraft.oak_door": "ஓக் கதவு",
  "block.minecraft.oak_fence": "ஓக் ஃபென்ஸ்",
  "block.minecraft.oak_fence_gate": "ஓக் வேலி கேட்",
  "block.minecraft.oak_hanging_sign": "Oak Hanging Sign",
  "block.minecraft.oak_leaves": "ஓக் இலைகள்",
  "block.minecraft.oak_log": "ஓக் பதிவு",
  "block.minecraft.oak_planks": "ஓக் பிளாங்க்ஸ்",
  "block.minecraft.oak_pressure_plate": "ஓக் அழுத்தம் தட்டு",
  "block.minecraft.oak_sapling": "ஓக் சப்பாளி",
  "block.minecraft.oak_shelf": "Oak Shelf",
  "block.minecraft.oak_sign": "ஓக் சைன்",
  "block.minecraft.oak_slab": "ஓக் ஸ்லாப்",
  "block.minecraft.oak_stairs": "ஓக் மாடி",
  "block.minecraft.oak_trapdoor": "ஓக் ட்ராபர்டு",
  "block.minecraft.oak_wall_hanging_sign": "Oak Wall Hanging Sign",
  "block.minecraft.oak_wall_sign": "ஓக் வோல் சைன்",
  "block.minecraft.oak_wood": "கருவாலி மரம்",
  "block.minecraft.observer": "அப்சர்வர்",
  "block.minecraft.obsidian": "ஒபசிடியன் ஸ்டோன்",
  "block.minecraft.ochre_froglight": "ஓச்சர் ஃபிராக்லைட்",
  "block.minecraft.ominous_banner": "அச்சுறுத்தும் பதாகை",
  "block.minecraft.open_eyeblossom": "Open Eyeblossom",
  "block.minecraft.orange_banner": "ஆரஞ்சு பேனர்",
  "block.minecraft.orange_bed": "ஆரஞ்சு படுக்கை",
  "block.minecraft.orange_candle": "ஆரஞ்சு மெழுகுவர்த்தி",
  "block.minecraft.orange_candle_cake": "ஆரஞ்சு மெழுகுவர்த்தியுடன் கேக்",
  "block.minecraft.orange_carpet": "ஆரஞ்சு கார்பெட்",
  "block.minecraft.orange_concrete": "ஆரஞ்சு கான்கிரீட்",
  "block.minecraft.orange_concrete_powder": "ஆரஞ்சு கான்கிரீட் தூள்",
  "block.minecraft.orange_glazed_terracotta": "ஆரஞ்சு பளபளப்பான டெர்ராகோட்டா",
  "block.minecraft.orange_shulker_box": "ஆரஞ்சு ஷூல்கர் பெட்டி",
  "block.minecraft.orange_stained_glass": "ஆரஞ்சு கறை படிந்த கண்ணாடி",
  "block.minecraft.orange_stained_glass_pane": "ஆரஞ்சு படிந்த கண்ணாடி தகடு",
  "block.minecraft.orange_terracotta": "ஆரஞ்சு டெர்ராகோட்டா",
  "block.minecraft.orange_tulip": "ஆரஞ்சு துலிப்",
  "block.minecraft.orange_wool": "ஆரஞ்சு கம்பளி",
  "block.minecraft.oxeye_daisy": "ஒக்ஸே டெய்ஸி",
  "block.minecraft.oxidized_chiseled_copper": "Oxidized Chiseled Copper",
  "block.minecraft.oxidized_copper": "ஆக்ஸிஜனேற்றப்பட்ட செம்பு",
  "block.minecraft.oxidized_copper_bars": "Oxidized Copper Bars",
  "block.minecraft.oxidized_copper_bulb": "Oxidized Copper Bulb",
  "block.minecraft.oxidized_copper_chain": "Oxidized Copper Chain",
  "block.minecraft.oxidized_copper_chest": "Oxidized Copper Chest",
  "block.minecraft.oxidized_copper_door": "Oxidized Copper Door",
  "block.minecraft.oxidized_copper_golem_statue": "Oxidized Copper Golem Statue",
  "block.minecraft.oxidized_copper_grate": "Oxidized Copper Grate",
  "block.minecraft.oxidized_copper_lantern": "Oxidized Copper Lantern",
  "block.minecraft.oxidized_copper_trapdoor": "Oxidized Copper Trapdoor",
  "block.minecraft.oxidized_cut_copper": "மெழுகு பூசிய செதுக்கிய செப்பு",
  "block.minecraft.oxidized_cut_copper_slab": "மெழுகு பூசிய செதுக்கிய செப்பு படிகள்",
  "block.minecraft.oxidized_cut_copper_stairs": "மெழுகு பூசிய செதுக்கிய செப்பு படிகள்",
  "block.minecraft.oxidized_lightning_rod": "Oxidized Lightning Rod",
  "block.minecraft.packed_ice": "பேக் ஐஸ்",
  "block.minecraft.packed_mud": "கெட்டி சேறு",
  "block.minecraft.pale_hanging_moss": "Pale Hanging Moss",
  "block.minecraft.pale_moss_block": "Pale Moss Block",
  "block.minecraft.pale_moss_carpet": "Pale Moss Carpet",
  "block.minecraft.pale_oak_button": "Pale Oak Button",
  "block.minecraft.pale_oak_door": "Pale Oak Door",
  "block.minecraft.pale_oak_fence": "Pale Oak Fence",
  "block.minecraft.pale_oak_fence_gate": "Pale Oak Fence Gate",
  "block.minecraft.pale_oak_hanging_sign": "Pale Oak Hanging Sign",
  "block.minecraft.pale_oak_leaves": "Pale Oak Leaves",
  "block.minecraft.pale_oak_log": "Pale Oak Log",
  "block.minecraft.pale_oak_planks": "Pale Oak Planks",
  "block.minecraft.pale_oak_pressure_plate": "Pale Oak Pressure Plate",
  "block.minecraft.pale_oak_sapling": "Pale Oak Sapling",
  "block.minecraft.pale_oak_shelf": "Pale Oak Shelf",
  "block.minecraft.pale_oak_sign": "Pale Oak Sign",
  "block.minecraft.pale_oak_slab": "Pale Oak Slab",
  "block.minecraft.pale_oak_stairs": "Pale Oak Stairs",
  "block.minecraft.pale_oak_trapdoor": "Pale Oak Trapdoor",
  "block.minecraft.pale_oak_wall_hanging_sign": "Pale Oak Wall Hanging Sign",
  "block.minecraft.pale_oak_wall_sign": "Pale Oak Wall Sign",
  "block.minecraft.pale_oak_wood": "Pale Oak Wood",
  "block.minecraft.pearlescent_froglight": "முத்து தவளை",
  "block.minecraft.peony": "பியோனி",
  "block.minecraft.petrified_oak_slab": "பேபிஃபிட் ஓக் ஸ்லாப்",
  "block.minecraft.piglin_head": "பிக்லின் தலை",
  "block.minecraft.piglin_wall_head": "பிக்லின் செங்கல் தலை",
  "block.minecraft.pink_banner": "பிங்க் பேனர்",
  "block.minecraft.pink_bed": "பிங்க் படுக்கை",
  "block.minecraft.pink_candle": "இளஞ்சிவப்பு மெழுகுவர்த்தி",
  "block.minecraft.pink_candle_cake": "பிங்க் மெழுகுவர்த்தியுடன் கேக்",
  "block.minecraft.pink_carpet": "பிங்க் கார்பெட்",
  "block.minecraft.pink_concrete": "பிங்க் கான்கிரீட்",
  "block.minecraft.pink_concrete_powder": "பிங்க் கான்கிரீட் தூள்",
  "block.minecraft.pink_glazed_terracotta": "பிங்க் மெழுகுவர்த்தி டெர்ராகோட்டா",
  "block.minecraft.pink_petals": "இளஞ்சிவப்பு இதழ்கள்",
  "block.minecraft.pink_shulker_box": "பிங்க் ஷுல்கர் பெட்டி",
  "block.minecraft.pink_stained_glass": "பிங்க் கறை படிந்த கண்ணாடி",
  "block.minecraft.pink_stained_glass_pane": "பிங்க் கறைபடிந்த கண்ணாடி தகடு",
  "block.minecraft.pink_terracotta": "பிங்க் டெர்ராகோட்டா",
  "block.minecraft.pink_tulip": "பிங்க் துலிப்",
  "block.minecraft.pink_wool": "பிங்க் கம்பளி",
  "block.minecraft.piston": "பிஸ்டன்",
  "block.minecraft.piston_head": "பிஸ்டன் தலைமை",
  "block.minecraft.pitcher_crop": "Pitcher Crop",
  "block.minecraft.pitcher_plant": "Pitcher Plant",
  "block.minecraft.player_head": "வீரர் தலைவர்",
  "block.minecraft.player_head.named": "%s's தலைமை",
  "block.minecraft.player_wall_head": "வீரர் வோல் தலைமை",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "கூர்மையான சொட்டு கள்",
  "block.minecraft.polished_andesite": "பளபளப்பான ஆண்டிசைட்",
  "block.minecraft.polished_andesite_slab": "பளபளப்பான ஆன்டிசைட் ஸ்லாப்",
  "block.minecraft.polished_andesite_stairs": "பளபளப்பான ஆன்டிசைட் படிக்கட்டுகள்",
  "block.minecraft.polished_basalt": "பளபளப்பான கருங்கல்",
  "block.minecraft.polished_blackstone": "மெருகூட்டப்பட்ட பிளாக்ஸ்டோன்",
  "block.minecraft.polished_blackstone_brick_slab": "மெருகேற்றப்பட்ட கருப்புக்கல் செங்கல் பலகை",
  "block.minecraft.polished_blackstone_brick_stairs": "மெருகேற்றப்பட்ட கருப்புக்கல் செங்கல் படிக்கட்டுகள்",
  "block.minecraft.polished_blackstone_brick_wall": "மெருகேற்றப்பட்ட கருப்புக்கல் செங்கல் சுவர்",
  "block.minecraft.polished_blackstone_bricks": "மெருகேற்றப்பட்ட கருப்புக்கல் செங்கற்கள்",
  "block.minecraft.polished_blackstone_button": "மெருகூட்டப்பட்ட பிளாக்ஸ்டோன் பொத்தான்",
  "block.minecraft.polished_blackstone_pressure_plate": "மெருகூட்டப்பட்ட பிளாக்ஸ்டோன் பிரஷர் பிளேட்",
  "block.minecraft.polished_blackstone_slab": "மெருகூட்டப்பட்ட பிளாக்ஸ்டோன் ஸ்லாப்",
  "block.minecraft.polished_blackstone_stairs": "மெருகூட்டப்பட்ட பிளாக்ஸ்டோன் படிக்கட்டுகள்",
  "block.minecraft.polished_blackstone_wall": "மெருகூட்டப்பட்ட பிளாக்ஸ்டோன் சுவர்",
  "block.minecraft.polished_deepslate": "வெட்டப்பட்ட ஆழமான",
  "block.minecraft.polished_deepslate_slab": "மெருகூட்டப்பட்ட ஆழமான அடுக்கு",
  "block.minecraft.polished_deepslate_stairs": "மெருகூட்டப்பட்அடுக்கு",
  "block.minecraft.polished_deepslate_wall": "மெருகூட்டப்பட்ட ஆழமான சுவர்",
  "block.minecraft.polished_diorite": "பளபளப்பான Diorite",
  "block.minecraft.polished_diorite_slab": "பளபளப்பான Diorite ஸ்லாப்",
  "block.minecraft.polished_diorite_stairs": "பளபளப்பான டியோசடங்குடன் படிகள்",
  "block.minecraft.polished_granite": "பளபளப்பான கிரானைட்",
  "block.minecraft.polished_granite_slab": "பளபளப்பான கிரானைட் ஸ்லாப்",
  "block.minecraft.polished_granite_stairs": "பளபளப்பான கிரானைட் படிக்கட்டுகள்",
  "block.minecraft.polished_tuff": "Polished Tuff",
  "block.minecraft.polished_tuff_slab": "Polished Tuff Slab",
  "block.minecraft.polished_tuff_stairs": "Polished Tuff Stairs",
  "block.minecraft.polished_tuff_wall": "Polished Tuff Wall",
  "block.minecraft.poppy": "பாப்பி",
  "block.minecraft.potatoes": "உருளைக்கிழங்குகள்",
  "block.minecraft.potted_acacia_sapling": "பொட்டாசியம் அசிசி சப்பாளிங்",
  "block.minecraft.potted_allium": "பொதியிட்ட அலியம்",
  "block.minecraft.potted_azalea_bush": "பானை அசேலியா",
  "block.minecraft.potted_azure_bluet": "பாட்டில் அஜ்யூ ப்ளூலெட்",
  "block.minecraft.potted_bamboo": "பாம்பெக் மூங்கில்",
  "block.minecraft.potted_birch_sapling": "பாட்ரூட் சாக்லெட்",
  "block.minecraft.potted_blue_orchid": "பாட்டில் ப்ளூ ஆர்ச்சிட்",
  "block.minecraft.potted_brown_mushroom": "பழுத்த பிரவுன் காளான்",
  "block.minecraft.potted_cactus": "பாட்டில் கற்றாழை",
  "block.minecraft.potted_cherry_sapling": "Potted Cherry Sapling",
  "block.minecraft.potted_closed_eyeblossom": "Potted Closed Eyeblossom",
  "block.minecraft.potted_cornflower": "குங்குமப்பூ",
  "block.minecraft.potted_crimson_fungus": "பானை கிரிம்சன் பூஞ்சை",
  "block.minecraft.potted_crimson_roots": "பானை கிரிம்சன் வேர்கள்",
  "block.minecraft.potted_dandelion": "பையிலிடப்பட்ட டேன்டேலியன்",
  "block.minecraft.potted_dark_oak_sapling": "தொட்டது டார்க் ஓக் மரக்கன்று",
  "block.minecraft.potted_dead_bush": "பையுடேட் டெட் புஷ்",
  "block.minecraft.potted_fern": "பையட் ஃபர்ன்",
  "block.minecraft.potted_flowering_azalea_bush": "பானை பூக்கும் அசேலியா",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Dandelion",
  "block.minecraft.potted_jungle_sapling": "பாட்டில் ஜங்கிள் சந்திப்பு",
  "block.minecraft.potted_lily_of_the_valley": "பள்ளத்தாக்கில் பாட் லில்லி",
  "block.minecraft.potted_mangrove_propagule": "பானையிடப்பட்ட சதுப்புநில மர பிள்ளை",
  "block.minecraft.potted_oak_sapling": "பாட் ஓக் சப்பாளி",
  "block.minecraft.potted_open_eyeblossom": "Potted Open Eyeblossom",
  "block.minecraft.potted_orange_tulip": "ஊற்றப்பட்ட ஆரஞ்சு துலிப்",
  "block.minecraft.potted_oxeye_daisy": "பாட் ஒக்ஸே டெய்ஸி",
  "block.minecraft.potted_pale_oak_sapling": "Potted Pale Oak Sapling",
  "block.minecraft.potted_pink_tulip": "பானை பிங்க் துலிப்",
  "block.minecraft.potted_poppy": "பாட்டி பாப்பி",
  "block.minecraft.potted_red_mushroom": "பாட்டில் ரெட் காளான்",
  "block.minecraft.potted_red_tulip": "பாட்டில் ரெட் துலிப்",
  "block.minecraft.potted_spruce_sapling": "பட்ரூட் ஸ்ப்ரெஸ் சந்தா",
  "block.minecraft.potted_torchflower": "Potted Torchflower",
  "block.minecraft.potted_warped_fungus": "பானை வார்ப்பட் பூஞ்சை",
  "block.minecraft.potted_warped_roots": "பானை வார்ப் வேர்கள்",
  "block.minecraft.potted_white_tulip": "பட்டுள்ள வெள்ளை துலிப்",
  "block.minecraft.potted_wither_rose": "வாட் ரோட் ரோட்",
  "block.minecraft.powder_snow": "பொடிபொன்ற பனி",
  "block.minecraft.powder_snow_cauldron": "தூள் பனி கால்ட்ரான்",
  "block.minecraft.powered_rail": "திருத்தினோம் ரயில்",
  "block.minecraft.prismarine": "ப்ரிஸ்டார்ன்",
  "block.minecraft.prismarine_brick_slab": "பிரைசரைன் பிரிக் ஸ்லாப்",
  "block.minecraft.prismarine_brick_stairs": "பிரைசரைன் செங்கல் மாடி",
  "block.minecraft.prismarine_bricks": "ப்ரிஸ்டார்ன் பிரிக்ஸ்",
  "block.minecraft.prismarine_slab": "ப்ரிஸ்மரைன் ஸ்லாப்",
  "block.minecraft.prismarine_stairs": "ப்ரீஸ்மரைன் மாடி",
  "block.minecraft.prismarine_wall": "ப்ரிஸ்ரைன் வால்",
  "block.minecraft.pumpkin": "பூசணிக்காய்",
  "block.minecraft.pumpkin_stem": "பூசணி தண்டு",
  "block.minecraft.purple_banner": "ஊதா பதாகை",
  "block.minecraft.purple_bed": "ஊதா படுக்கை",
  "block.minecraft.purple_candle": "ஊதா மெழுகுவர்த்தி",
  "block.minecraft.purple_candle_cake": "ஊதா மெழுகுவர்த்தியுடன் கேக்",
  "block.minecraft.purple_carpet": "ஊதா நிற கம்பளம்",
  "block.minecraft.purple_concrete": "ஊதா கான்கிரீட்",
  "block.minecraft.purple_concrete_powder": "ஊதா கான்கிரீட் தூள்",
  "block.minecraft.purple_glazed_terracotta": "ஊதா மெழுகுவர்த்தி டெர்ராகோட்டா",
  "block.minecraft.purple_shulker_box": "ஊதா ஷூல்கர் பெட்டி",
  "block.minecraft.purple_stained_glass": "ஊதா கறை படிந்த கண்ணாடி",
  "block.minecraft.purple_stained_glass_pane": "ஊதா படிந்த கண்ணாடி பேன்",
  "block.minecraft.purple_terracotta": "ஊதா டெர்ராகோட்டா",
  "block.minecraft.purple_wool": "ஊதா வூல்",
  "block.minecraft.purpur_block": "புர்பூர் பிளாக்",
  "block.minecraft.purpur_pillar": "புர்பூர் தூண்",
  "block.minecraft.purpur_slab": "புர்பூர் ஸ்லாப்",
  "block.minecraft.purpur_stairs": "புருபூர் மாடி",
  "block.minecraft.quartz_block": "குவார்ட்ஸ் பிளாக்",
  "block.minecraft.quartz_bricks": "குவார்ட்ஸ் செங்கற்கள்",
  "block.minecraft.quartz_pillar": "குவார்ட்ஸ் தூண்",
  "block.minecraft.quartz_slab": "குவார்ட்ஸ் ஸ்லாப்",
  "block.minecraft.quartz_stairs": "குவார்ட்ஸ் படிக்கட்டுகள்",
  "block.minecraft.rail": "ரயில்",
  "block.minecraft.raw_copper_block": "மூல தாமிரத்தின் தொகுதி",
  "block.minecraft.raw_gold_block": "மூல தங்கத்தின் தொகுதி",
  "block.minecraft.raw_iron_block": "மூல இரும்பின் தொகுதி",
  "block.minecraft.red_banner": "சிவப்பு பேனர்",
  "block.minecraft.red_bed": "ரெட் படுக்கை",
  "block.minecraft.red_candle": "சிவப்பு மெழுகுவர்த்தி",
  "block.minecraft.red_candle_cake": "சிவப்பு மெழுகுவர்த்தியுடன் கேக்",
  "block.minecraft.red_carpet": "சிவப்பு கம்பளம்",
  "block.minecraft.red_concrete": "சிவப்பு கான்கிரீட்",
  "block.minecraft.red_concrete_powder": "சிவப்பு கான்கிரீட் தூள்",
  "block.minecraft.red_glazed_terracotta": "சிவப்பு மெருகூட்டப்பட்ட டெர்ராக்கோட்டா",
  "block.minecraft.red_mushroom": "சிவப்பு காளான்",
  "block.minecraft.red_mushroom_block": "சிவப்பு மஷ்ரூம் பிளாக்",
  "block.minecraft.red_nether_brick_slab": "ரெட் நெதர் ப்ரிக் ஸ்லாப்",
  "block.minecraft.red_nether_brick_stairs": "ரெட் நெதர் செங்கல் மாடி",
  "block.minecraft.red_nether_brick_wall": "சிவப்பு செங்கல் சுவர்",
  "block.minecraft.red_nether_bricks": "ரெட் நெதர் பிரிக்ஸ்",
  "block.minecraft.red_sand": "சிவப்பு மணல்",
  "block.minecraft.red_sandstone": "சிவப்பு மணற்கல்",
  "block.minecraft.red_sandstone_slab": "ரெட் சாண்ட்ஸ்டோன் ஸ்லாப்",
  "block.minecraft.red_sandstone_stairs": "சிவப்பு மணற்கல் மாடி",
  "block.minecraft.red_sandstone_wall": "சிவப்பு மணற்கல் சுவர்",
  "block.minecraft.red_shulker_box": "சிவப்பு ஷெல்கர் பெட்டி",
  "block.minecraft.red_stained_glass": "சிவப்பு நிற கண்ணாடி",
  "block.minecraft.red_stained_glass_pane": "சிவப்பு நிற கண்ணாடி கண்ணாடி",
  "block.minecraft.red_terracotta": "ரெட் டெர்ரகோட்டா",
  "block.minecraft.red_tulip": "சிவப்பு துலிப்",
  "block.minecraft.red_wool": "சிவப்பு கம்பளி",
  "block.minecraft.redstone_block": "சிவப்பு கல் தொகுதி",
  "block.minecraft.redstone_lamp": "ரெட்ஸ்டோன் லேம்ப்",
  "block.minecraft.redstone_ore": "ரெட்ஸ்டோன் ஓரே",
  "block.minecraft.redstone_torch": "ரெட்ஸ்டோன் டார்ச்",
  "block.minecraft.redstone_wall_torch": "ரெட்ஸ்டோன் வோல் டார்ச்",
  "block.minecraft.redstone_wire": "ரெட்ஸ்டோன் கம்பி",
  "block.minecraft.reinforced_deepslate": "வலுவூட்டப்பட்ட டீப்ஸ்லேட்",
  "block.minecraft.repeater": "ரெட்ஸ்டோன் ரிப்பீட்டர்",
  "block.minecraft.repeating_command_block": "கட்டளை தொகுதி மீண்டும் மீண்டும்",
  "block.minecraft.resin_block": "Block of Resin",
  "block.minecraft.resin_brick_slab": "Resin Brick Slab",
  "block.minecraft.resin_brick_stairs": "Resin Brick Stairs",
  "block.minecraft.resin_brick_wall": "Resin Brick Wall",
  "block.minecraft.resin_bricks": "Resin Bricks",
  "block.minecraft.resin_clump": "Resin Clump",
  "block.minecraft.respawn_anchor": "மறுதோற்ற நங்கூரம்",
  "block.minecraft.rooted_dirt": "வேரூன்றிய அழுக்கு",
  "block.minecraft.rose_bush": "ரோஸ் புஷ்",
  "block.minecraft.sand": "மணல்",
  "block.minecraft.sandstone": "மணற்கல்",
  "block.minecraft.sandstone_slab": "சாண்ட்ஸ்டோன் ஸ்லாப்",
  "block.minecraft.sandstone_stairs": "மணல் மாடி",
  "block.minecraft.sandstone_wall": "மணல் வால்",
  "block.minecraft.scaffolding": "சாரக்கட்டு",
  "block.minecraft.sculk": "ஸ்கல்க்",
  "block.minecraft.sculk_catalyst": "ஸ்கல்க் கேடலிஸ்ட்",
  "block.minecraft.sculk_sensor": "ஸ்கல்க் சென்சார்",
  "block.minecraft.sculk_shrieker": "ஸ்கல்க் ஷ்ரீக்கர்",
  "block.minecraft.sculk_vein": "ஸ்கல்க் வெயின்",
  "block.minecraft.sea_lantern": "கடல் விளக்கு",
  "block.minecraft.sea_pickle": "கடல் பிகில்",
  "block.minecraft.seagrass": "கடல் புல்",
  "block.minecraft.set_spawn": "ரெஸ்பான் புள்ளி தொகுப்பு",
  "block.minecraft.short_dry_grass": "Short Dry Grass",
  "block.minecraft.short_grass": "Short Grass",
  "block.minecraft.shroomlight": "ஷ்ரூம்லைட்",
  "block.minecraft.shulker_box": "ஷுல்கர் பெட்டி",
  "block.minecraft.skeleton_skull": "எலும்புக்கூடு ஸ்கல்",
  "block.minecraft.skeleton_wall_skull": "எலும்புக்கூடு வோல் ஸ்கல்",
  "block.minecraft.slime_block": "மெல்லிய பிளாக்",
  "block.minecraft.small_amethyst_bud": "சிறிய ஆமெத்திஸ்ட் மொட்டு",
  "block.minecraft.small_dripleaf": "சிறிய டிரிப்லீஃப்",
  "block.minecraft.smithing_table": "ஸ்மிமிங் டேபிள்",
  "block.minecraft.smoker": "ஸ்மோக்கர்",
  "block.minecraft.smooth_basalt": "மென்மையான பசால்ட்",
  "block.minecraft.smooth_quartz": "மென்மையான குவார்ட்ஸ் தொகுதி",
  "block.minecraft.smooth_quartz_slab": "மென்மையான குவார்ட்ஸ் ஸ்லாப்",
  "block.minecraft.smooth_quartz_stairs": "மென்மையான குவார்ட்ஸ் மாடிகளில்",
  "block.minecraft.smooth_red_sandstone": "மென்மையான சிவப்பு மணற்கல்",
  "block.minecraft.smooth_red_sandstone_slab": "மென்மையான சிவப்பு மணற்கல் மாடி",
  "block.minecraft.smooth_red_sandstone_stairs": "மென்மையான சிவப்பு மணற்கல் மாடி",
  "block.minecraft.smooth_sandstone": "மென்மையான மணல்",
  "block.minecraft.smooth_sandstone_slab": "மென்மையான மணல் ஸ்டாப்",
  "block.minecraft.smooth_sandstone_stairs": "மென்மையான மணற்கல் மாடி",
  "block.minecraft.smooth_stone": "மென்மையான கல்",
  "block.minecraft.smooth_stone_slab": "மென்மையான ஸ்டோன் ஸ்லாப்",
  "block.minecraft.sniffer_egg": "ஸ்னிஃபர் முட்டை",
  "block.minecraft.snow": "ஸ்னோ",
  "block.minecraft.snow_block": "பனி தடுப்பு",
  "block.minecraft.soul_campfire": "சோல் கேம்ப்ஃபயர்",
  "block.minecraft.soul_fire": "ஆத்மா தீ",
  "block.minecraft.soul_lantern": "சோல் விளக்கு",
  "block.minecraft.soul_sand": "சோல் மணல்",
  "block.minecraft.soul_soil": "ஆத்மா மண்",
  "block.minecraft.soul_torch": "சோல் டார்ச்",
  "block.minecraft.soul_wall_torch": "சோல் வால் டார்ச்",
  "block.minecraft.spawn.not_valid": "உங்களிடம் வீட்டு படுக்கை இல்லை அல்லது ரெஸ்பான் நங்கூரம் வசூலிக்கப்படவில்லை, அல்லது அது தடைபட்டது",
  "block.minecraft.spawner": "Monster Spawner",
  "block.minecraft.spawner.desc1": "Interact with Spawn Egg:",
  "block.minecraft.spawner.desc2": "Sets Mob Type",
  "block.minecraft.sponge": "கடற்பாசி",
  "block.minecraft.spore_blossom": "வித்து மலரும்",
  "block.minecraft.spruce_button": "ஸ்ப்ரூஸ் பட்டன்",
  "block.minecraft.spruce_door": "ஸ்ப்ரூஸ் கதவு",
  "block.minecraft.spruce_fence": "ஸ்ப்ரூஸ் ஃபென்ஸ்",
  "block.minecraft.spruce_fence_gate": "ஸ்ப்ரூஸ் வேலி கேட்",
  "block.minecraft.spruce_hanging_sign": "Spruce Hanging Sign",
  "block.minecraft.spruce_leaves": "ஸ்ப்ரூஸ் இலைகள்",
  "block.minecraft.spruce_log": "ஸ்ப்ரூஸ் பதிவு",
  "block.minecraft.spruce_planks": "ஸ்ப்ரூஸ் ப்ளாங்க்கள்",
  "block.minecraft.spruce_pressure_plate": "ஸ்ப்ரூஸ் அழுத்தம் தட்டு",
  "block.minecraft.spruce_sapling": "ஸ்ப்ரெஸ் சந்தா",
  "block.minecraft.spruce_shelf": "Spruce Shelf",
  "block.minecraft.spruce_sign": "ஸ்ப்ரூஸ் சைன்",
  "block.minecraft.spruce_slab": "ஸ்ப்ரூஸ் ஸ்லாப்",
  "block.minecraft.spruce_stairs": "ஸ்ப்ரூஸ் மாடிகளில்",
  "block.minecraft.spruce_trapdoor": "ஸ்ப்ரூஸ் ட்ராபர்டு",
  "block.minecraft.spruce_wall_hanging_sign": "Spruce Wall Hanging Sign",
  "block.minecraft.spruce_wall_sign": "ஸ்ப்ரூஸ் வோல் சைன்",
  "block.minecraft.spruce_wood": "ஸ்ப்ரூ வூட்",
  "block.minecraft.sticky_piston": "ஒட்டும் பிஸ்டன்",
  "block.minecraft.stone": "கல்",
  "block.minecraft.stone_brick_slab": "ஸ்டோன் பிரிக் ஸ்லாப்",
  "block.minecraft.stone_brick_stairs": "கல் செங்கல் மாடி",
  "block.minecraft.stone_brick_wall": "கல் செங்கல் சுவர்",
  "block.minecraft.stone_bricks": "கல் செங்கல்கள்",
  "block.minecraft.stone_button": "ஸ்டோன் பட்டன்",
  "block.minecraft.stone_pressure_plate": "கல் அழுத்தம் தட்டு",
  "block.minecraft.stone_slab": "ஸ்டோன் ஸ்லாப்",
  "block.minecraft.stone_stairs": "கல் மாடி",
  "block.minecraft.stonecutter": "கல்கட்டர்",
  "block.minecraft.stripped_acacia_log": "அகாசியா பதிவை அகற்றினார்",
  "block.minecraft.stripped_acacia_wood": "அக்ஸா வூட் ஸ்ட்ரிப்ட்",
  "block.minecraft.stripped_bamboo_block": "Block of Stripped Bamboo",
  "block.minecraft.stripped_birch_log": "பிர்ச் பதிவு ஸ்ட்ரிப்ட்",
  "block.minecraft.stripped_birch_wood": "பிர்ச் வூட் ஸ்ட்ரிப்ட்",
  "block.minecraft.stripped_cherry_log": "Stripped Cherry Log",
  "block.minecraft.stripped_cherry_wood": "Stripped Cherry Wood",
  "block.minecraft.stripped_crimson_hyphae": "அகற்றப்பட்ட கிரிம்சன் ஹைஃபே",
  "block.minecraft.stripped_crimson_stem": "அகற்றப்பட்ட கிரிம்சன் ஸ்டெம்",
  "block.minecraft.stripped_dark_oak_log": "ஸ்டிரிப்டு டார்க் ஓக் புகுபதிகை",
  "block.minecraft.stripped_dark_oak_wood": "ஸ்ட்ரிப்ட் டார்க் ஓக் வூட்",
  "block.minecraft.stripped_jungle_log": "ஜங்கிள் பதிவு இழுக்கப்பட்டது",
  "block.minecraft.stripped_jungle_wood": "ஜங்கிள் வூட் ஸ்ட்ரைப்ஸ்",
  "block.minecraft.stripped_mangrove_log": "உரித்த சதுப்புநில மரத்துண்டு",
  "block.minecraft.stripped_mangrove_wood": "உரித்த சதுப்புநில மரக்கட்டை",
  "block.minecraft.stripped_oak_log": "ஸ்ட்ரெபிட் ஓக் லா",
  "block.minecraft.stripped_oak_wood": "ஓக் வுட் ஸ்ட்ரைப்ட்",
  "block.minecraft.stripped_pale_oak_log": "Stripped Pale Oak Log",
  "block.minecraft.stripped_pale_oak_wood": "Stripped Pale Oak Wood",
  "block.minecraft.stripped_spruce_log": "ஸ்ட்ரைப்ஸ் ஸ்ட்ரீப் பதிவு",
  "block.minecraft.stripped_spruce_wood": "ஸ்ட்ரைப்ஸ் ஸ்ப்ரூஸ் வூட்",
  "block.minecraft.stripped_warped_hyphae": "அகற்றப்பட்ட வார்ப் ஹைஃபே",
  "block.minecraft.stripped_warped_stem": "அகற்றப்பட்ட வார்ப் ஸ்டெம்",
  "block.minecraft.structure_block": "கட்டமைப்பு பிளாக்",
  "block.minecraft.structure_void": "அமைப்பு வெற்றிடத்தை",
  "block.minecraft.sugar_cane": "கரும்பு",
  "block.minecraft.sunflower": "சூரியகாந்தி",
  "block.minecraft.suspicious_gravel": "Suspicious Gravel",
  "block.minecraft.suspicious_sand": "Suspicious Sand",
  "block.minecraft.sweet_berry_bush": "இனிப்பு பெர்ரி புஷ்",
  "block.minecraft.tall_dry_grass": "Tall Dry Grass",
  "block.minecraft.tall_grass": "உயரமான புல்",
  "block.minecraft.tall_seagrass": "உயரமான சீகிராஸ்",
  "block.minecraft.target": "இலக்கு",
  "block.minecraft.terracotta": "சிவப்பாய்",
  "block.minecraft.test_block": "Test Block",
  "block.minecraft.test_instance_block": "Test Instance Block",
  "block.minecraft.tinted_glass": "நிறம் பூசப்பட்ட கண்ணாடி",
  "block.minecraft.tnt": "டிஎன்டி",
  "block.minecraft.tnt.disabled": "TNT explosions are disabled",
  "block.minecraft.torch": "ஜோதி",
  "block.minecraft.torchflower": "Torchflower",
  "block.minecraft.torchflower_crop": "Torchflower Crop",
  "block.minecraft.trapped_chest": "சிக்கிய மார்பு",
  "block.minecraft.trial_spawner": "Trial Spawner",
  "block.minecraft.tripwire": "ட்ரிப்வைர்",
  "block.minecraft.tripwire_hook": "ட்ரிப்வைர் ஹூக்",
  "block.minecraft.tube_coral": "குழாய் பவள",
  "block.minecraft.tube_coral_block": "குழாய் கோரல் பிளாக்",
  "block.minecraft.tube_coral_fan": "குழி பவள ஃபேன்",
  "block.minecraft.tube_coral_wall_fan": "குழாய் பவள வால் ரசிகர்",
  "block.minecraft.tuff": "எரிமலை சாம்பற்பாரை",
  "block.minecraft.tuff_brick_slab": "Tuff Brick Slab",
  "block.minecraft.tuff_brick_stairs": "Tuff Brick Stairs",
  "block.minecraft.tuff_brick_wall": "Tuff Brick Wall",
  "block.minecraft.tuff_bricks": "Tuff Bricks",
  "block.minecraft.tuff_slab": "Tuff Slab",
  "block.minecraft.tuff_stairs": "Tuff Stairs",
  "block.minecraft.tuff_wall": "Tuff Wall",
  "block.minecraft.turtle_egg": "ஆமை முட்டை",
  "block.minecraft.twisting_vines": "முறுக்கு கொடிகள்",
  "block.minecraft.twisting_vines_plant": "ஜாலத்தால் கொடிகள் தாவர",
  "block.minecraft.vault": "Vault",
  "block.minecraft.verdant_froglight": "பசுமையான தவளை விளக்கு",
  "block.minecraft.vine": "கொடிகள்",
  "block.minecraft.void_air": "வெற்றிட ஏர்",
  "block.minecraft.wall_torch": "வோல் டார்ச்",
  "block.minecraft.warped_button": "வார்ப்பட் பட்டன்",
  "block.minecraft.warped_door": "வார்ப் டோர்",
  "block.minecraft.warped_fence": "திசைதிருப்பப்பட்ட வேலி",
  "block.minecraft.warped_fence_gate": "திசைதிருப்பப்பட்ட வேலி வாயில்",
  "block.minecraft.warped_fungus": "வார்ப்பட் பூஞ்சை",
  "block.minecraft.warped_hanging_sign": "Warped Hanging Sign",
  "block.minecraft.warped_hyphae": "வார்ப்பட் ஹைஃபே",
  "block.minecraft.warped_nylium": "வார்ப் நைலியம்",
  "block.minecraft.warped_planks": "திசைதிருப்பப்பட்ட பலகைகள்",
  "block.minecraft.warped_pressure_plate": "வார்ப் பிரஷர் பிளேட்",
  "block.minecraft.warped_roots": "திசைதிருப்பப்பட்ட வேர்கள்",
  "block.minecraft.warped_shelf": "Warped Shelf",
  "block.minecraft.warped_sign": "திசைதிருப்பப்பட்ட அடையாளம்",
  "block.minecraft.warped_slab": "வார்ப் ஸ்லாப்",
  "block.minecraft.warped_stairs": "திசைதிருப்பப்பட்ட படிக்கட்டுகள்",
  "block.minecraft.warped_stem": "வார்ப் ஸ்டெம்",
  "block.minecraft.warped_trapdoor": "வார்ப் டிராப்டோர்",
  "block.minecraft.warped_wall_hanging_sign": "Warped Wall Hanging Sign",
  "block.minecraft.warped_wall_sign": "திசைதிருப்பப்பட்ட சுவர் அடையாளம்",
  "block.minecraft.warped_wart_block": "வார்ப் வார்ட் பிளாக்",
  "block.minecraft.water": "நீர்",
  "block.minecraft.water_cauldron": "தண்ணீர்கொதிகலன்",
  "block.minecraft.waxed_chiseled_copper": "Waxed Chiseled Copper",
  "block.minecraft.waxed_copper_bars": "Waxed Copper Bars",
  "block.minecraft.waxed_copper_block": "செம்பு மெழுகு தொகுதி",
  "block.minecraft.waxed_copper_bulb": "Waxed Copper Bulb",
  "block.minecraft.waxed_copper_chain": "Waxed Copper Chain",
  "block.minecraft.waxed_copper_chest": "Waxed Copper Chest",
  "block.minecraft.waxed_copper_door": "Waxed Copper Door",
  "block.minecraft.waxed_copper_golem_statue": "Waxed Copper Golem Statue",
  "block.minecraft.waxed_copper_grate": "Waxed Copper Grate",
  "block.minecraft.waxed_copper_lantern": "Waxed Copper Lantern",
  "block.minecraft.waxed_copper_trapdoor": "Waxed Copper Trapdoor",
  "block.minecraft.waxed_cut_copper": "மெழுகு பூசிய செதுக்கிய செப்பு",
  "block.minecraft.waxed_cut_copper_slab": "மெழுகு பூசிய செதுக்கிய செப்பு அறைகானசதுரம்",
  "block.minecraft.waxed_cut_copper_stairs": "மெழுகு பூசிய செதுக்கிய செப்பு படிகள்",
  "block.minecraft.waxed_exposed_chiseled_copper": "Waxed Exposed Chiseled Copper",
  "block.minecraft.waxed_exposed_copper": "மெழுகு வெளிப்படுத்தப்பட்ட செம்பு",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Exposed Copper Bars",
  "block.minecraft.waxed_exposed_copper_bulb": "Waxed Exposed Copper Bulb",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Exposed Copper Chain",
  "block.minecraft.waxed_exposed_copper_chest": "Waxed Exposed Copper Chest",
  "block.minecraft.waxed_exposed_copper_door": "Waxed Exposed Copper Door",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Exposed Copper Golem Statue",
  "block.minecraft.waxed_exposed_copper_grate": "Waxed Exposed Copper Grate",
  "block.minecraft.waxed_exposed_copper_lantern": "Waxed Exposed Copper Lantern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Waxed Exposed Copper Trapdoor",
  "block.minecraft.waxed_exposed_cut_copper": "மெழுகு வெளிப்படுத்தப்பட்ட வெட்டு தாமிரம்",
  "block.minecraft.waxed_exposed_cut_copper_slab": "மெழுகு வெளிப்படுத்தப்பட்ட வெட்டு காப்பர் ஸ்லாப்",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "மெழுகு வெளிப்படுத்தப்பட்ட வெட்டு செப்பு படிக்கட்டுகள்",
  "block.minecraft.waxed_exposed_lightning_rod": "Waxed Exposed Lightning Rod",
  "block.minecraft.waxed_lightning_rod": "Waxed Lightning Rod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Waxed Oxidized Chiseled Copper",
  "block.minecraft.waxed_oxidized_copper": "மெழுகு ஆக்ஸிஜனேற்றப்பட்ட செம்பு",
  "block.minecraft.waxed_oxidized_copper_bars": "Waxed Oxidized Copper Bars",
  "block.minecraft.waxed_oxidized_copper_bulb": "Waxed Oxidized Copper Bulb",
  "block.minecraft.waxed_oxidized_copper_chain": "Waxed Oxidized Copper Chain",
  "block.minecraft.waxed_oxidized_copper_chest": "Waxed Oxidized Copper Chest",
  "block.minecraft.waxed_oxidized_copper_door": "Waxed Oxidized Copper Door",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waxed Oxidized Copper Golem Statue",
  "block.minecraft.waxed_oxidized_copper_grate": "Waxed Oxidized Copper Grate",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waxed Oxidized Copper Lantern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Waxed Oxidized Copper Trapdoor",
  "block.minecraft.waxed_oxidized_cut_copper": "மெழுகு ஆக்ஸிஜனேற்றப்பட்ட வெட்டு செம்பு",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "மெழுகு ஆக்ஸிஜனேற்றப்பட்ட வெட்டு காப்பர் ஸ்லாப்",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "மெழுகு ஆக்ஸிஜனேற்றப்பட்ட வெட்டு செப்பு படிக்கட்டுகள்",
  "block.minecraft.waxed_oxidized_lightning_rod": "Waxed Oxidized Lightning Rod",
  "block.minecraft.waxed_weathered_chiseled_copper": "Waxed Weathered Chiseled Copper",
  "block.minecraft.waxed_weathered_copper": "மெழுகு வளிமண்டல செம்பு",
  "block.minecraft.waxed_weathered_copper_bars": "Waxed Weathered Copper Bars",
  "block.minecraft.waxed_weathered_copper_bulb": "Waxed Weathered Copper Bulb",
  "block.minecraft.waxed_weathered_copper_chain": "Waxed Weathered Copper Chain",
  "block.minecraft.waxed_weathered_copper_chest": "Waxed Weathered Copper Chest",
  "block.minecraft.waxed_weathered_copper_door": "Waxed Weathered Copper Door",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waxed Weathered Copper Golem Statue",
  "block.minecraft.waxed_weathered_copper_grate": "Waxed Weathered Copper Grate",
  "block.minecraft.waxed_weathered_copper_lantern": "Waxed Weathered Copper Lantern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Waxed Weathered Copper Trapdoor",
  "block.minecraft.waxed_weathered_cut_copper": "மெழுகு வளிமண்டல வெட்டு செம்பு",
  "block.minecraft.waxed_weathered_cut_copper_slab": "மெழுகு வளிமண்டல வெட்டு காப்பர் ஸ்லாப்",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "மெழுகு வளிமண்டல வெட்டு செப்பு படிக்கட்டுகள்",
  "block.minecraft.waxed_weathered_lightning_rod": "Waxed Weathered Lightning Rod",
  "block.minecraft.weathered_chiseled_copper": "Weathered Chiseled Copper",
  "block.minecraft.weathered_copper": "செம்பு வளிமண்டலம்",
  "block.minecraft.weathered_copper_bars": "Weathered Copper Bars",
  "block.minecraft.weathered_copper_bulb": "Weathered Copper Bulb",
  "block.minecraft.weathered_copper_chain": "Weathered Copper Chain",
  "block.minecraft.weathered_copper_chest": "Weathered Copper Chest",
  "block.minecraft.weathered_copper_door": "Weathered Copper Door",
  "block.minecraft.weathered_copper_golem_statue": "Weathered Copper Golem Statue",
  "block.minecraft.weathered_copper_grate": "Weathered Copper Grate",
  "block.minecraft.weathered_copper_lantern": "Weathered Copper Lantern",
  "block.minecraft.weathered_copper_trapdoor": "Weathered Copper Trapdoor",
  "block.minecraft.weathered_cut_copper": "பழுதான செதுக்கிய செப்பு",
  "block.minecraft.weathered_cut_copper_slab": "பழுதான செதுக்கிய செப்பு அறைகனசதுரம்",
  "block.minecraft.weathered_cut_copper_stairs": "பழுதான செதுக்கிய செப்பு படிகள்",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "அழுகிற கொடிகள்",
  "block.minecraft.weeping_vines_plant": "அழுது கொடிகள் தாவர",
  "block.minecraft.wet_sponge": "வெட் கடற்பாசி",
  "block.minecraft.wheat": "கோதுமை பயிர்கள்",
  "block.minecraft.white_banner": "வெள்ளை பேனர்",
  "block.minecraft.white_bed": "வெள்ளை படுக்கை",
  "block.minecraft.white_candle": "வெள்ளை மெழுகுவர்த்தி",
  "block.minecraft.white_candle_cake": "வெள்ளை மெழுகுவர்த்தியுடன் கேக்",
  "block.minecraft.white_carpet": "வெள்ளை கம்பளம்",
  "block.minecraft.white_concrete": "வெள்ளை கான்கிரீட்",
  "block.minecraft.white_concrete_powder": "வெள்ளை கான்கிரீட் தூள்",
  "block.minecraft.white_glazed_terracotta": "வெள்ளை பளபளப்பான டெர்ராகோட்டா",
  "block.minecraft.white_shulker_box": "வெள்ளை ஷுல்கர் பெட்டி",
  "block.minecraft.white_stained_glass": "வெள்ளை கறை படிந்த கண்ணாடி",
  "block.minecraft.white_stained_glass_pane": "வெள்ளை கறை படிந்த கண்ணாடி தகடு",
  "block.minecraft.white_terracotta": "வெள்ளை டெர்ராகோட்டா",
  "block.minecraft.white_tulip": "வெள்ளை துலிப்",
  "block.minecraft.white_wool": "வெள்ளை கம்பளி",
  "block.minecraft.wildflowers": "Wildflowers",
  "block.minecraft.wither_rose": "வாட் ரோஸ்",
  "block.minecraft.wither_skeleton_skull": "எலும்புக்கூடு மண்டை ஓடுகிறது",
  "block.minecraft.wither_skeleton_wall_skull": "எலும்புக்கூடு வோல் ஸ்கல் வாட்",
  "block.minecraft.yellow_banner": "மஞ்சள் பேனர்",
  "block.minecraft.yellow_bed": "மஞ்சள் படுக்கை",
  "block.minecraft.yellow_candle": "மஞ்சள் மெழுகுவர்த்தி",
  "block.minecraft.yellow_candle_cake": "மஞ்சள் மெழுகுவர்த்தியுடன் கேக்",
  "block.minecraft.yellow_carpet": "மஞ்சள் கம்பளம்",
  "block.minecraft.yellow_concrete": "மஞ்சள் கான்கிரீட்",
  "block.minecraft.yellow_concrete_powder": "மஞ்சள் கான்கிரீட் தூள்",
  "block.minecraft.yellow_glazed_terracotta": "மஞ்சள் பளபளப்பான டெர்ராகோட்டா",
  "block.minecraft.yellow_shulker_box": "மஞ்சள் ஷல்கர் பெட்டி",
  "block.minecraft.yellow_stained_glass": "மஞ்சள் கறை படிந்த கண்ணாடி",
  "block.minecraft.yellow_stained_glass_pane": "மஞ்சள் படிந்த கண்ணாடி பேன்",
  "block.minecraft.yellow_terracotta": "மஞ்சள் டெர்ராகோட்டா",
  "block.minecraft.yellow_wool": "மஞ்சள் கம்பளி",
  "block.minecraft.zombie_head": "சோம்பை தலை",
  "block.minecraft.zombie_wall_head": "சோம்பை வோல் ஹெட்",
  "item.minecraft.acacia_boat": "அகாசி படகு",
  "item.minecraft.acacia_chest_boat": "மார்புடன் கூடிய அகாசியா படகு",
  "item.minecraft.allay_spawn_egg": "அலே ஸ்பான் முட்டை",
  "item.minecraft.amethyst_shard": "ஆமெதிஸ்ட் சில்லு",
  "item.minecraft.angler_pottery_shard": "Angler Pottery Shard",
  "item.minecraft.angler_pottery_sherd": "Angler Pottery Sherd",
  "item.minecraft.apple": "ஆப்பிள்",
  "item.minecraft.archer_pottery_shard": "Archer Pottery Shard",
  "item.minecraft.archer_pottery_sherd": "Archer Pottery Sherd",
  "item.minecraft.armadillo_scute": "Armadillo Scute",
  "item.minecraft.armadillo_spawn_egg": "Armadillo Spawn Egg",
  "item.minecraft.armor_stand": "ஆர்மர் ஸ்டாண்ட்",
  "item.minecraft.arms_up_pottery_shard": "Arms Up Pottery Shard",
  "item.minecraft.arms_up_pottery_sherd": "Arms Up Pottery Sherd",
  "item.minecraft.arrow": "அம்பு",
  "item.minecraft.axolotl_bucket": "ஆக்சோலோட்டில் வாலி",
  "item.minecraft.axolotl_spawn_egg": "ஆக்சொலோடில் தோற்ற முட்டை",
  "item.minecraft.baked_potato": "வேகவைத்த உருளைக்கிழங்கு",
  "item.minecraft.bamboo_chest_raft": "Bamboo Raft with Chest",
  "item.minecraft.bamboo_raft": "மூங்கில் ராஃப்ட்",
  "item.minecraft.bat_spawn_egg": "பேட் ஸ்பான் முட்டை",
  "item.minecraft.bee_spawn_egg": "தேனீ ஸ்பான் முட்டை",
  "item.minecraft.beef": "மூல மாட்டிறைச்சி",
  "item.minecraft.beetroot": "பீட்ரூட்",
  "item.minecraft.beetroot_seeds": "பீட்ரூட் விதைகள்",
  "item.minecraft.beetroot_soup": "பீட்ரூட் சூப்",
  "item.minecraft.birch_boat": "பிர்ச் படகு",
  "item.minecraft.birch_chest_boat": "மார்புடன் பிர்ச் படகு",
  "item.minecraft.black_bundle": "Black Bundle",
  "item.minecraft.black_dye": "பிளாக் டை",
  "item.minecraft.black_harness": "Black Harness",
  "item.minecraft.blade_pottery_shard": "Blade Pottery Shard",
  "item.minecraft.blade_pottery_sherd": "Blade Pottery Sherd",
  "item.minecraft.blaze_powder": "பிளேஸ் தூள்",
  "item.minecraft.blaze_rod": "பிளேஸ் ராட்",
  "item.minecraft.blaze_spawn_egg": "பிளேஸ் ஸ்பான் முட்டை",
  "item.minecraft.blue_bundle": "Blue Bundle",
  "item.minecraft.blue_dye": "நீல சாயம்",
  "item.minecraft.blue_egg": "Blue Egg",
  "item.minecraft.blue_harness": "Blue Harness",
  "item.minecraft.bogged_spawn_egg": "Bogged Spawn Egg",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolt Armor Trim",
  "item.minecraft.bone": "எலும்பு",
  "item.minecraft.bone_meal": "எலும்பு உணவு",
  "item.minecraft.book": "புத்தகம்",
  "item.minecraft.bordure_indented_banner_pattern": "Bordure Indented Banner Pattern",
  "item.minecraft.bow": "வில்",
  "item.minecraft.bowl": "பவுல்",
  "item.minecraft.bread": "ரொட்டி",
  "item.minecraft.breeze_rod": "Breeze Rod",
  "item.minecraft.breeze_spawn_egg": "Breeze Spawn Egg",
  "item.minecraft.brewer_pottery_shard": "Brewer Pottery Shard",
  "item.minecraft.brewer_pottery_sherd": "Brewer Pottery Sherd",
  "item.minecraft.brewing_stand": "பிரவுனிங் ஸ்டேண்ட்",
  "item.minecraft.brick": "செங்கல்",
  "item.minecraft.brown_bundle": "Brown Bundle",
  "item.minecraft.brown_dye": "பிரவுன் சாயம்",
  "item.minecraft.brown_egg": "Brown Egg",
  "item.minecraft.brown_harness": "Brown Harness",
  "item.minecraft.brush": "தூரிகை",
  "item.minecraft.bucket": "வாளி",
  "item.minecraft.bundle": "மூட்டை",
  "item.minecraft.bundle.empty": "Empty",
  "item.minecraft.bundle.empty.description": "Can hold a mixed stack of items",
  "item.minecraft.bundle.full": "Full",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Burn Pottery Shard",
  "item.minecraft.burn_pottery_sherd": "Burn Pottery Sherd",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "ஒட்டகம் ஸ்பான் முட்டை",
  "item.minecraft.carrot": "கேரட்",
  "item.minecraft.carrot_on_a_stick": "ஒரு குச்சி மீது கேரட்",
  "item.minecraft.cat_spawn_egg": "கேட் ஸ்பான் முட்டை",
  "item.minecraft.cauldron": "கொப்பரை",
  "item.minecraft.cave_spider_spawn_egg": "குகை ஸ்பைடர் ஸ்பான் முட்டை",
  "item.minecraft.chainmail_boots": "சாப்டர்ஒருநான்என்எம்ஏநான் L பூட்ஸ்",
  "item.minecraft.chainmail_chestplate": "சாப்டர்ஒருநான்என்எம்ஏநான் L மார்புதட்டு",
  "item.minecraft.chainmail_helmet": "சாய்னெயில் ஹெல்மெட்",
  "item.minecraft.chainmail_leggings": "சாப்டர்ஒருநான்என்எம்ஏநான் L லெக்இல்கிராம்ங்கள்",
  "item.minecraft.charcoal": "கரி",
  "item.minecraft.cherry_boat": "செர்ரி படகு",
  "item.minecraft.cherry_chest_boat": "Cherry Boat with Chest",
  "item.minecraft.chest_minecart": "மார்போடு மின்கார்ட்",
  "item.minecraft.chicken": "மூல கோழி",
  "item.minecraft.chicken_spawn_egg": "சிக்கன் ஸ்பான் முட்டை",
  "item.minecraft.chorus_fruit": "கோரஸ் பழம்",
  "item.minecraft.clay_ball": "களிமண் பந்து",
  "item.minecraft.clock": "கடிகாரம்",
  "item.minecraft.coal": "நிலக்கரி",
  "item.minecraft.coast_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Coast Armor Trim",
  "item.minecraft.cocoa_beans": "கோகோ பீன்ஸ்",
  "item.minecraft.cod": "ரா காட்",
  "item.minecraft.cod_bucket": "காட் பக்",
  "item.minecraft.cod_spawn_egg": "கோட் ஸ்பான் முட்டை",
  "item.minecraft.command_block_minecart": "கட்டளைத் தொகுதியுடன் மின்கார்ட்",
  "item.minecraft.compass": "திசைகாட்டி",
  "item.minecraft.cooked_beef": "ஸ்டீக்",
  "item.minecraft.cooked_chicken": "சமைத்த சிக்கன்",
  "item.minecraft.cooked_cod": "சமைத்த காட்",
  "item.minecraft.cooked_mutton": "சமைத்த மட்டன்",
  "item.minecraft.cooked_porkchop": "சமைத்த பன்றி இறைச்சி",
  "item.minecraft.cooked_rabbit": "சமைத்த முயல்",
  "item.minecraft.cooked_salmon": "சமைத்த சால்மன்",
  "item.minecraft.cookie": "குக்கீ",
  "item.minecraft.copper_axe": "Copper Axe",
  "item.minecraft.copper_boots": "Copper Boots",
  "item.minecraft.copper_chestplate": "Copper Chestplate",
  "item.minecraft.copper_golem_spawn_egg": "Copper Golem Spawn Egg",
  "item.minecraft.copper_helmet": "Copper Helmet",
  "item.minecraft.copper_hoe": "Copper Hoe",
  "item.minecraft.copper_horse_armor": "Copper Horse Armor",
  "item.minecraft.copper_ingot": "செப்பு இங்காட்",
  "item.minecraft.copper_leggings": "Copper Leggings",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Copper Nugget",
  "item.minecraft.copper_pickaxe": "Copper Pickaxe",
  "item.minecraft.copper_shovel": "Copper Shovel",
  "item.minecraft.copper_spear": "Copper Spear",
  "item.minecraft.copper_sword": "Copper Sword",
  "item.minecraft.cow_spawn_egg": "ஆடு ஸ்பூன் முட்டை",
  "item.minecraft.creaking_spawn_egg": "Creaking Spawn Egg",
  "item.minecraft.creeper_banner_pattern": "பேனர் பேட்டர்ன்",
  "item.minecraft.creeper_banner_pattern.desc": "வேகம் சார்ஜ்",
  "item.minecraft.creeper_banner_pattern.new": "Creeper Charge Banner Pattern",
  "item.minecraft.creeper_spawn_egg": "க்ரீப்பர் ஸ்பான் முட்டை",
  "item.minecraft.crossbow": "கிராஸ்போ",
  "item.minecraft.crossbow.projectile": "துப்பாக்கி:",
  "item.minecraft.crossbow.projectile.multiple": "Projectile: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projectile: %s",
  "item.minecraft.cyan_bundle": "Cyan Bundle",
  "item.minecraft.cyan_dye": "சியான் சாய்",
  "item.minecraft.cyan_harness": "Cyan Harness",
  "item.minecraft.danger_pottery_shard": "Danger Pottery Shard",
  "item.minecraft.danger_pottery_sherd": "Danger Pottery Sherd",
  "item.minecraft.dark_oak_boat": "டார்க் ஓக் படகு",
  "item.minecraft.dark_oak_chest_boat": "மார்புடன் கூடிய இருண்ட ஓக் படகு",
  "item.minecraft.debug_stick": "பிழைத்திருத்த ஸ்டிக்",
  "item.minecraft.debug_stick.empty": "%s பண்புகள் இல்லை",
  "item.minecraft.debug_stick.select": "தேர்ந்தெடுக்கப்பட்டுள்ளன \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" க்கு %s",
  "item.minecraft.diamond": "டயமண்ட்",
  "item.minecraft.diamond_axe": "டயமண்ட் கோடாரி",
  "item.minecraft.diamond_boots": "டயமண்ட் பூட்ஸ்",
  "item.minecraft.diamond_chestplate": "டயமண்ட் செஸ்ட்டெட்",
  "item.minecraft.diamond_helmet": "டயமண்ட் ஹெல்மெட்",
  "item.minecraft.diamond_hoe": "டயமண்ட் ஹோ",
  "item.minecraft.diamond_horse_armor": "வைர குதிரை கவசம்",
  "item.minecraft.diamond_leggings": "டயமண்ட் லெக்கிங்ஸ்",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "டயமண்ட் பிக்ஸாக்",
  "item.minecraft.diamond_shovel": "டயமண்ட் திணி",
  "item.minecraft.diamond_spear": "Diamond Spear",
  "item.minecraft.diamond_sword": "டயமண்ட் வாள்",
  "item.minecraft.disc_fragment_5": "வட்டு துண்டு",
  "item.minecraft.disc_fragment_5.desc": "இசை வட்டு - 5",
  "item.minecraft.dolphin_spawn_egg": "டால்பின் ஸ்பான் முட்டை",
  "item.minecraft.donkey_spawn_egg": "கழுதை ஸ்பான் முட்டை",
  "item.minecraft.dragon_breath": "டிராகனின் மூச்சு",
  "item.minecraft.dried_kelp": "உலர்ந்த கெல்ப்",
  "item.minecraft.drowned_spawn_egg": "மூழ்கிய ஸ்பான் முட்டை",
  "item.minecraft.dune_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dune Armor Trim",
  "item.minecraft.echo_shard": "எக்கோ ஷார்ட்",
  "item.minecraft.egg": "முட்டை",
  "item.minecraft.elder_guardian_spawn_egg": "மூத்த கார்டியன் ஸ்பான் முட்டை",
  "item.minecraft.elytra": "இறக்கை மூடி",
  "item.minecraft.emerald": "எமரால்டு",
  "item.minecraft.enchanted_book": "மந்திரித்த புத்தகம்",
  "item.minecraft.enchanted_golden_apple": "மந்திரித்த கோல்டன் ஆப்பிள்",
  "item.minecraft.end_crystal": "முடி நீளம்",
  "item.minecraft.ender_dragon_spawn_egg": "எண்டர் டிராகன் ஸ்பான் முட்டை",
  "item.minecraft.ender_eye": "எண்டரின் கண்",
  "item.minecraft.ender_pearl": "எண்டர் முத்து",
  "item.minecraft.enderman_spawn_egg": "எண்டர்மன் ஸ்பான் முட்டை",
  "item.minecraft.endermite_spawn_egg": "முடிந்தவரை ஸ்பான் முட்டை",
  "item.minecraft.evoker_spawn_egg": "வருவதற்காகஆர் ஸ்பான் முட்டை",
  "item.minecraft.experience_bottle": "பாட்டில் ஓ 'மயக்கும்",
  "item.minecraft.explorer_pottery_shard": "எக்ஸ்ப்ளோரர் மட்பாண்ட ஷெர்ட்",
  "item.minecraft.explorer_pottery_sherd": "எக்ஸ்ப்ளோரர் மட்பாண்ட ஷெர்ட்",
  "item.minecraft.eye_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Eye Armor Trim",
  "item.minecraft.feather": "இறகு",
  "item.minecraft.fermented_spider_eye": "புளிக்க ஸ்பைடர் கண்",
  "item.minecraft.field_masoned_banner_pattern": "Field Masoned Banner Pattern",
  "item.minecraft.filled_map": "வரைபடம்",
  "item.minecraft.fire_charge": "தீ கட்டணம்",
  "item.minecraft.firework_rocket": "வாணவேடிக்கை ராக்கெட்",
  "item.minecraft.firework_rocket.flight": "விமான காலம்:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "வாணவேடிக்கை நட்சத்திரம்",
  "item.minecraft.firework_star.black": "கருப்பு",
  "item.minecraft.firework_star.blue": "நீலம்",
  "item.minecraft.firework_star.brown": "பழுப்பு",
  "item.minecraft.firework_star.custom_color": "தனிப்பயன்",
  "item.minecraft.firework_star.cyan": "சியான்",
  "item.minecraft.firework_star.fade_to": "மங்காது",
  "item.minecraft.firework_star.flicker": "ட்விங்கிள்",
  "item.minecraft.firework_star.gray": "கிரே",
  "item.minecraft.firework_star.green": "பச்சை",
  "item.minecraft.firework_star.light_blue": "ஒளி நீலம்",
  "item.minecraft.firework_star.light_gray": "மெல்லிய சாம்பல் நிறம்",
  "item.minecraft.firework_star.lime": "எலுமிச்சை",
  "item.minecraft.firework_star.magenta": "மெஜந்தா",
  "item.minecraft.firework_star.orange": "ஆரஞ்சு",
  "item.minecraft.firework_star.pink": "பிங்க்",
  "item.minecraft.firework_star.purple": "ஊதா",
  "item.minecraft.firework_star.red": "சிவப்பு",
  "item.minecraft.firework_star.shape": "தெரியாத வடிவம்",
  "item.minecraft.firework_star.shape.burst": "பர்ஸ்ட்",
  "item.minecraft.firework_star.shape.creeper": "படர்க்கொடிகளின்-வடிவ",
  "item.minecraft.firework_star.shape.large_ball": "பெரிய பந்து",
  "item.minecraft.firework_star.shape.small_ball": "சிறிய பந்து",
  "item.minecraft.firework_star.shape.star": "ஸ்டார்-வடிவ",
  "item.minecraft.firework_star.trail": "டிரெயில்",
  "item.minecraft.firework_star.white": "வெள்ளை",
  "item.minecraft.firework_star.yellow": "மஞ்சள்",
  "item.minecraft.fishing_rod": "மீன்பிடி ராட்",
  "item.minecraft.flint": "பிளின்ட்",
  "item.minecraft.flint_and_steel": "பிளின்ட் மற்றும் ஸ்டீல்",
  "item.minecraft.flow_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Flow Armor Trim",
  "item.minecraft.flow_banner_pattern": "Banner Pattern",
  "item.minecraft.flow_banner_pattern.desc": "Flow",
  "item.minecraft.flow_banner_pattern.new": "Flow Banner Pattern",
  "item.minecraft.flow_pottery_sherd": "Flow Pottery Sherd",
  "item.minecraft.flower_banner_pattern": "பதாகை முறை",
  "item.minecraft.flower_banner_pattern.desc": "மலர் கட்டணம்",
  "item.minecraft.flower_banner_pattern.new": "Flower Charge Banner Pattern",
  "item.minecraft.flower_pot": "மலர் பாட்",
  "item.minecraft.fox_spawn_egg": "ஃபாக்ஸ் ஸ்பான் முட்டை",
  "item.minecraft.friend_pottery_shard": "Friend Pottery Shard",
  "item.minecraft.friend_pottery_sherd": "Friend Pottery Sherd",
  "item.minecraft.frog_spawn_egg": "தவளை ஸ்பான் முட்டை",
  "item.minecraft.furnace_minecart": "உலைகளுடன் மின்கார்ட்",
  "item.minecraft.ghast_spawn_egg": "காஸ்ட் ஸ்பான் முட்டை",
  "item.minecraft.ghast_tear": "காஸ்ட் கண்ணீர்",
  "item.minecraft.glass_bottle": "கண்ணாடி குடுவை",
  "item.minecraft.glistering_melon_slice": "மெலனோ ஸ்லஸ்",
  "item.minecraft.globe_banner_pattern": "பதாகை முறை",
  "item.minecraft.globe_banner_pattern.desc": "குளோப்",
  "item.minecraft.globe_banner_pattern.new": "Globe Banner Pattern",
  "item.minecraft.glow_berries": "பளபளப்பான பெர்ரி",
  "item.minecraft.glow_ink_sac": "ஒளிர் மை சாக்கு",
  "item.minecraft.glow_item_frame": "ஒளிரும் பொருள் சட்டகம்",
  "item.minecraft.glow_squid_spawn_egg": "ஒளிர் ஸ்குயிட் தோற்ற முட்டை",
  "item.minecraft.glowstone_dust": "க்ளோஸ்டோன் தூசி",
  "item.minecraft.goat_horn": "ஆட்டு கொம்பு",
  "item.minecraft.goat_spawn_egg": "ஆடு ஸ்பான் முட்டை",
  "item.minecraft.gold_ingot": "தங்க இகோட்",
  "item.minecraft.gold_nugget": "தங்க நகஜ்",
  "item.minecraft.golden_apple": "தங்க ஆப்பிள்",
  "item.minecraft.golden_axe": "கோல்டன் ஆக்ஸ்",
  "item.minecraft.golden_boots": "கோல்டன் பூட்ஸ்",
  "item.minecraft.golden_carrot": "கோல்டன் கேரட்",
  "item.minecraft.golden_chestplate": "கோல்டன் செஸ்ட் பிளேட்",
  "item.minecraft.golden_helmet": "கோல்டன் ஹெல்மெட்",
  "item.minecraft.golden_hoe": "கோல்டன் ஹொ",
  "item.minecraft.golden_horse_armor": "கோல்டன் ஹார்ஸ் ஆர்மோர்",
  "item.minecraft.golden_leggings": "கோல்டன் லெக்கிங்ஸ்",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "கோல்டன் பிக்சே",
  "item.minecraft.golden_shovel": "கோல்டன் வெந்தயம்",
  "item.minecraft.golden_spear": "Golden Spear",
  "item.minecraft.golden_sword": "கோல்டன் வாள்",
  "item.minecraft.gray_bundle": "Gray Bundle",
  "item.minecraft.gray_dye": "சாம்பல் சாயம்",
  "item.minecraft.gray_harness": "Gray Harness",
  "item.minecraft.green_bundle": "Green Bundle",
  "item.minecraft.green_dye": "பச்சை சாயம்",
  "item.minecraft.green_harness": "Green Harness",
  "item.minecraft.guardian_spawn_egg": "கார்டியன் ஸ்பான் முட்டை",
  "item.minecraft.gunpowder": "வெடிமருந்து",
  "item.minecraft.guster_banner_pattern": "Banner Pattern",
  "item.minecraft.guster_banner_pattern.desc": "Guster",
  "item.minecraft.guster_banner_pattern.new": "Guster Banner Pattern",
  "item.minecraft.guster_pottery_sherd": "Guster Pottery Sherd",
  "item.minecraft.happy_ghast_spawn_egg": "Happy Ghast Spawn Egg",
  "item.minecraft.harness": "Harness",
  "item.minecraft.heart_of_the_sea": "கடல் இதயம்",
  "item.minecraft.heart_pottery_shard": "Heart Pottery Shard",
  "item.minecraft.heart_pottery_sherd": "Heart Pottery Sherd",
  "item.minecraft.heartbreak_pottery_shard": "Heartbreak Pottery Shard",
  "item.minecraft.heartbreak_pottery_sherd": "Heartbreak Pottery Sherd",
  "item.minecraft.hoglin_spawn_egg": "ஹாக்லின் ஸ்பான் முட்டை",
  "item.minecraft.honey_bottle": "ஒரு பாட்டில் தேன்",
  "item.minecraft.honeycomb": "தேன்கூடு",
  "item.minecraft.hopper_minecart": "ஹாப்பருடன் மின்கார்ட்",
  "item.minecraft.horse_spawn_egg": "குதிரை ஸ்பான் முட்டை",
  "item.minecraft.host_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.host_armor_trim_smithing_template.new": "Host Armor Trim",
  "item.minecraft.howl_pottery_shard": "Howl Pottery Shard",
  "item.minecraft.howl_pottery_sherd": "Howl Pottery Sherd",
  "item.minecraft.husk_spawn_egg": "ஹஸ்ஸ்க் ஸ்பான் முட்டை",
  "item.minecraft.ink_sac": "மைப்பை",
  "item.minecraft.iron_axe": "இரும்பு கோடாரி",
  "item.minecraft.iron_boots": "இரும்பு துவாரங்கள்",
  "item.minecraft.iron_chestplate": "இரும்புச் செடி",
  "item.minecraft.iron_golem_spawn_egg": "இரும்புக் கூடம் ஸ்பான் முட்டை",
  "item.minecraft.iron_helmet": "இரும்பு ஹெல்மெட்",
  "item.minecraft.iron_hoe": "இரும்புத் தாது",
  "item.minecraft.iron_horse_armor": "இரும்பு குதிரை கவசம்",
  "item.minecraft.iron_ingot": "இரும்பு இங்காட்",
  "item.minecraft.iron_leggings": "இரும்புச் சட்டை",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "இரும்பு நகம்",
  "item.minecraft.iron_pickaxe": "இரும்பு பிக்ஸாக்",
  "item.minecraft.iron_shovel": "இரும்பு திணி",
  "item.minecraft.iron_spear": "Iron Spear",
  "item.minecraft.iron_sword": "இரும்பு வாள்",
  "item.minecraft.item_frame": "பொருள் சட்டகம்",
  "item.minecraft.jungle_boat": "ஜங்கிள் படகு",
  "item.minecraft.jungle_chest_boat": "மார்புடன் கூடிய ஜங்கிள் படகு",
  "item.minecraft.knowledge_book": "அறிவு புத்தகம்",
  "item.minecraft.lapis_lazuli": "லேபிஸ் லாஜூலி",
  "item.minecraft.lava_bucket": "லாவா பக்கெட்",
  "item.minecraft.lead": "முன்னணி",
  "item.minecraft.leather": "தோல்",
  "item.minecraft.leather_boots": "தோல் பூட்ஸ்",
  "item.minecraft.leather_chestplate": "தோல் துணி",
  "item.minecraft.leather_helmet": "தோல் கேப்",
  "item.minecraft.leather_horse_armor": "தோல் குதிரை ஆர்மர்",
  "item.minecraft.leather_leggings": "தோல் கால்சட்டைகள்",
  "item.minecraft.light_blue_bundle": "Light Blue Bundle",
  "item.minecraft.light_blue_dye": "வெளிர் நீல சாயம்",
  "item.minecraft.light_blue_harness": "Light Blue Harness",
  "item.minecraft.light_gray_bundle": "Light Gray Bundle",
  "item.minecraft.light_gray_dye": "ஒளி சாம்பல் சாயம்",
  "item.minecraft.light_gray_harness": "Light Gray Harness",
  "item.minecraft.lime_bundle": "Lime Bundle",
  "item.minecraft.lime_dye": "சுண்ணாம்பு சாயம்",
  "item.minecraft.lime_harness": "Lime Harness",
  "item.minecraft.lingering_potion": "நீடித்த போஷன்",
  "item.minecraft.lingering_potion.effect.awkward": "மோசமான நீடித்த போஷன்",
  "item.minecraft.lingering_potion.effect.empty": "நீடிக்க முடியாத கிராஃபிக் போஷன்",
  "item.minecraft.lingering_potion.effect.fire_resistance": "தீ எதிர்ப்பின் நீடித்த போஷன்",
  "item.minecraft.lingering_potion.effect.harming": "தீங்கு விளைவிக்கும் நீடித்த மருந்து",
  "item.minecraft.lingering_potion.effect.healing": "குணப்படுத்தும் நீடித்த போஷன்",
  "item.minecraft.lingering_potion.effect.infested": "Lingering Potion of Infestation",
  "item.minecraft.lingering_potion.effect.invisibility": "கண்ணுக்குத் தெரியாத நீடித்த போஷன்",
  "item.minecraft.lingering_potion.effect.leaping": "பாய்ச்சலின் நீடித்த போஷன்",
  "item.minecraft.lingering_potion.effect.levitation": "லெவிட்டனின் நீடித்த போஷன்",
  "item.minecraft.lingering_potion.effect.luck": "அதிர்ஷ்டத்தின் நீடித்த போஷன்",
  "item.minecraft.lingering_potion.effect.mundane": "இவ்வுலக நீடித்த போஷன்",
  "item.minecraft.lingering_potion.effect.night_vision": "நைட் விஷனின் நீடித்த போஷன்",
  "item.minecraft.lingering_potion.effect.oozing": "Lingering Potion of Oozing",
  "item.minecraft.lingering_potion.effect.poison": "விஷத்தின் நீடித்த போஷன்",
  "item.minecraft.lingering_potion.effect.regeneration": "மீளுருவாக்கத்தின் நீடித்த போஷன்",
  "item.minecraft.lingering_potion.effect.slow_falling": "மெதுவான வீழ்ச்சியின் லிங்கரிங் போஷன்",
  "item.minecraft.lingering_potion.effect.slowness": "மந்தமான நீடித்த போஷன்",
  "item.minecraft.lingering_potion.effect.strength": "வலிமையின் நீடித்த போஷன்",
  "item.minecraft.lingering_potion.effect.swiftness": "ஸ்விஃப்ட்னஸின் நீடித்த போஷன்",
  "item.minecraft.lingering_potion.effect.thick": "அடர்த்தியான நீடித்த போஷன்",
  "item.minecraft.lingering_potion.effect.turtle_master": "டர்டில் மாஸ்டர் லிங்கரிங் போஷன்",
  "item.minecraft.lingering_potion.effect.water": "நீடித்த பாட்டில்",
  "item.minecraft.lingering_potion.effect.water_breathing": "நீர் சுவாசத்தின் நீடித்த போஷன்",
  "item.minecraft.lingering_potion.effect.weakness": "பலவீனத்தின் நீடித்த போஷன்",
  "item.minecraft.lingering_potion.effect.weaving": "Lingering Potion of Weaving",
  "item.minecraft.lingering_potion.effect.wind_charged": "Lingering Potion of Wind Charging",
  "item.minecraft.llama_spawn_egg": "லலாமா ஸ்பான் முட்டை",
  "item.minecraft.lodestone_compass": "மடய்கல் நோக்கும் திசைகாட்டி",
  "item.minecraft.mace": "Mace",
  "item.minecraft.magenta_bundle": "Magenta Bundle",
  "item.minecraft.magenta_dye": "மெஜந்தா சாயம்",
  "item.minecraft.magenta_harness": "Magenta Harness",
  "item.minecraft.magma_cream": "மாக்மா கிரீம்",
  "item.minecraft.magma_cube_spawn_egg": "மாக்மா கியூப் ஸ்பான் முட்டை",
  "item.minecraft.mangrove_boat": "மாங்குரோவ் படகு",
  "item.minecraft.mangrove_chest_boat": "மார்போடு சதுப்புநில படகு",
  "item.minecraft.map": "வெற்று வரைபடம்",
  "item.minecraft.melon_seeds": "முலாம்பழம் விதைகள்",
  "item.minecraft.melon_slice": "மெலோன் ஸ்லைஸ்",
  "item.minecraft.milk_bucket": "பால் பருந்து",
  "item.minecraft.minecart": "வேகன்",
  "item.minecraft.miner_pottery_shard": "Miner Pottery Shard",
  "item.minecraft.miner_pottery_sherd": "Miner Pottery Sherd",
  "item.minecraft.mojang_banner_pattern": "பதாகை முறை",
  "item.minecraft.mojang_banner_pattern.desc": "திங்",
  "item.minecraft.mojang_banner_pattern.new": "Thing Banner Pattern",
  "item.minecraft.mooshroom_spawn_egg": "மூசுரூம் ஸ்பான் முட்டை",
  "item.minecraft.mourner_pottery_shard": "Mourner Pottery Shard",
  "item.minecraft.mourner_pottery_sherd": "Mourner Pottery Sherd",
  "item.minecraft.mule_spawn_egg": "மூல் ஸ்பொன் முட்டை",
  "item.minecraft.mushroom_stew": "காளான் குண்டு",
  "item.minecraft.music_disc_11": "இசை வட்டு",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "இசை டிஸ்க்",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "இசை வட்டு",
  "item.minecraft.music_disc_5.desc": "சாமுவேல் அபெர்க் - 5",
  "item.minecraft.music_disc_blocks": "இசை வட்டு",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "இசை வட்டு",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "இசை வட்டு",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Music Disc",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Music Disc",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "இசை வட்டு",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Music Disc",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "இசை வட்டு",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "இசை வட்டு",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "இசை வட்டு",
  "item.minecraft.music_disc_otherside.desc": "லீனா ரெய்ன் - மறுபக்கம்",
  "item.minecraft.music_disc_pigstep": "இசை வட்டு",
  "item.minecraft.music_disc_pigstep.desc": "லீனா ரெய்ன் - பிக்ஸ்டெப்",
  "item.minecraft.music_disc_precipice": "Music Disc",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "இசை வட்டு",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "இசை வட்டு",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "இசை வட்டு",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Music Disc",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "இசை வட்டு",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "இசை வட்டு",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "ரா மட்டன்",
  "item.minecraft.name_tag": "பெயர் டேக்",
  "item.minecraft.nautilus_shell": "நாட்டிலஸ் ஷெல்",
  "item.minecraft.nautilus_spawn_egg": "Nautilus Spawn Egg",
  "item.minecraft.nether_brick": "நார் செங்கல்",
  "item.minecraft.nether_star": "நெதர் ஸ்டார்",
  "item.minecraft.nether_wart": "Nether Wart",
  "item.minecraft.netherite_axe": "நெதரைட் கோடாரி",
  "item.minecraft.netherite_boots": "நெதரைட் பூட்ஸ்",
  "item.minecraft.netherite_chestplate": "நெதரைட் செஸ்ட் பிளேட்",
  "item.minecraft.netherite_helmet": "நெதரைட் ஹெல்மெட்",
  "item.minecraft.netherite_hoe": "நெதரைட் ஹோ",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "நெதரைட் இங்காட்",
  "item.minecraft.netherite_leggings": "நெதரைட் லெகிங்ஸ்",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "நெதரைட் பிகாக்ஸ்",
  "item.minecraft.netherite_scrap": "நெதரைட் ஸ்கிராப்",
  "item.minecraft.netherite_shovel": "நெதரைட் திணி",
  "item.minecraft.netherite_spear": "Netherite Spear",
  "item.minecraft.netherite_sword": "நெதரைட் வாள்",
  "item.minecraft.netherite_upgrade_smithing_template": "Smithing Template",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherite Upgrade",
  "item.minecraft.oak_boat": "ஓக் படகு",
  "item.minecraft.oak_chest_boat": "மார்புடன் ஓக் படகு",
  "item.minecraft.ocelot_spawn_egg": "ஓஇஇஎல்ஓடி ஸ்பான் முட்டை",
  "item.minecraft.ominous_bottle": "Ominous Bottle",
  "item.minecraft.ominous_trial_key": "Ominous Trial Key",
  "item.minecraft.orange_bundle": "Orange Bundle",
  "item.minecraft.orange_dye": "ஆரஞ்சு சாயம்",
  "item.minecraft.orange_harness": "Orange Harness",
  "item.minecraft.painting": "ஓவியம்",
  "item.minecraft.pale_oak_boat": "Pale Oak Boat",
  "item.minecraft.pale_oak_chest_boat": "Pale Oak Boat with Chest",
  "item.minecraft.panda_spawn_egg": "பாண்டா ஸ்பான் முட்டை",
  "item.minecraft.paper": "காகிதம்",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "கிளி ஸ்போன் முட்டை",
  "item.minecraft.phantom_membrane": "பாண்டம் மெம்பிரேன்",
  "item.minecraft.phantom_spawn_egg": "ஃபாலோம் ஸ்பான் முட்டை",
  "item.minecraft.pig_spawn_egg": "பன்றி ஸ்பான் முட்டை",
  "item.minecraft.piglin_banner_pattern": "பதாகை முறை",
  "item.minecraft.piglin_banner_pattern.desc": "முனகல்",
  "item.minecraft.piglin_banner_pattern.new": "Snout Banner Pattern",
  "item.minecraft.piglin_brute_spawn_egg": "பிக்லின் ப்ரூட் ஸ்பான் முட்டை",
  "item.minecraft.piglin_spawn_egg": "பிக்லின் ஸ்பான் முட்டை",
  "item.minecraft.pillager_spawn_egg": "பில்லேஜர் ஸ்பான் முட்டை",
  "item.minecraft.pink_bundle": "Pink Bundle",
  "item.minecraft.pink_dye": "பிங்க் டை",
  "item.minecraft.pink_harness": "Pink Harness",
  "item.minecraft.pitcher_plant": "Pitcher Plant",
  "item.minecraft.pitcher_pod": "குடம் நெற்று",
  "item.minecraft.plenty_pottery_shard": "Plenty Pottery Shard",
  "item.minecraft.plenty_pottery_sherd": "Plenty Pottery Sherd",
  "item.minecraft.poisonous_potato": "விஷம் உருளைக்கிழங்கு",
  "item.minecraft.polar_bear_spawn_egg": "துருவ கரடி ஸ்பான் முட்டை",
  "item.minecraft.popped_chorus_fruit": "பாப் செய்யப்பட்ட கோரஸ் பழம்",
  "item.minecraft.porkchop": "மூல போர்காப்",
  "item.minecraft.potato": "உருளைக்கிழங்கு",
  "item.minecraft.potion": "போஷன்",
  "item.minecraft.potion.effect.awkward": "அருவருப்பான போஷன்",
  "item.minecraft.potion.effect.empty": "பிரிக்க முடியாத போஷன்",
  "item.minecraft.potion.effect.fire_resistance": "தீ எதிர்ப்பின் போஷன்",
  "item.minecraft.potion.effect.harming": "தீங்கு விளைவிக்கும் போஷன்",
  "item.minecraft.potion.effect.healing": "குணப்படுத்தும் போஷன்",
  "item.minecraft.potion.effect.infested": "Potion of Infestation",
  "item.minecraft.potion.effect.invisibility": "கண்ணுக்குத் தெரியாத போஷன்",
  "item.minecraft.potion.effect.leaping": "பாய்ச்சல் போஷன்",
  "item.minecraft.potion.effect.levitation": "லேவிட்டனின் போஷன்",
  "item.minecraft.potion.effect.luck": "அதிர்ஷ்ட போஷன்",
  "item.minecraft.potion.effect.mundane": "இவ்வுலகை போஷன்",
  "item.minecraft.potion.effect.night_vision": "நைட் விஷனின் போஷன்",
  "item.minecraft.potion.effect.oozing": "Potion of Oozing",
  "item.minecraft.potion.effect.poison": "விஷத்தின் போஷன்",
  "item.minecraft.potion.effect.regeneration": "மீளுருவாக்கம் போஷன்",
  "item.minecraft.potion.effect.slow_falling": "மெதுவாக விழுந்து வணக்கம்",
  "item.minecraft.potion.effect.slowness": "மந்தமான போஷன்",
  "item.minecraft.potion.effect.strength": "வலிமையின் போஷன்",
  "item.minecraft.potion.effect.swiftness": "விரைவான போஷன்",
  "item.minecraft.potion.effect.thick": "அடர்த்தியான போஷன்",
  "item.minecraft.potion.effect.turtle_master": "ஆமை மாஸ்டர் பதவி",
  "item.minecraft.potion.effect.water": "தண்ணீர் குடுவை",
  "item.minecraft.potion.effect.water_breathing": "நீர் சுவாசத்தின் போஷன்",
  "item.minecraft.potion.effect.weakness": "பலவீனத்தின் போஷன்",
  "item.minecraft.potion.effect.weaving": "Potion of Weaving",
  "item.minecraft.potion.effect.wind_charged": "Potion of Wind Charging",
  "item.minecraft.pottery_shard_archer": "Archer Pottery Shard",
  "item.minecraft.pottery_shard_arms_up": "Arms Up Pottery Shard",
  "item.minecraft.pottery_shard_prize": "Prize Pottery Shard",
  "item.minecraft.pottery_shard_skull": "Skull Pottery Shard",
  "item.minecraft.powder_snow_bucket": "பொடியான பனி வாளி",
  "item.minecraft.prismarine_crystals": "பிரிஸ்மரைன் படிகங்கள்",
  "item.minecraft.prismarine_shard": "பிரிஸ்மரைன் ஷார்ட்",
  "item.minecraft.prize_pottery_shard": "Prize Pottery Shard",
  "item.minecraft.prize_pottery_sherd": "Prize Pottery Sherd",
  "item.minecraft.pufferfish": "பஃபர்ஃபிஷ்",
  "item.minecraft.pufferfish_bucket": "பஃபெர்ஃபி ஆஃப் பஃபெர்ஃபி",
  "item.minecraft.pufferfish_spawn_egg": "பஃபெர் மீன் ஸ்பான் முட்டை",
  "item.minecraft.pumpkin_pie": "பூசணி பை",
  "item.minecraft.pumpkin_seeds": "பூசணி விதைகள்",
  "item.minecraft.purple_bundle": "Purple Bundle",
  "item.minecraft.purple_dye": "ஊதா சாயம்",
  "item.minecraft.purple_harness": "Purple Harness",
  "item.minecraft.quartz": "நேதர் குவார்ட்ஸ்",
  "item.minecraft.rabbit": "ரா ராபிட்",
  "item.minecraft.rabbit_foot": "முயல் அடி",
  "item.minecraft.rabbit_hide": "முயல் மறை",
  "item.minecraft.rabbit_spawn_egg": "முயல் ஸ்பான் முட்டை",
  "item.minecraft.rabbit_stew": "முயல் குண்டு",
  "item.minecraft.raiser_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Raiser Armor Trim",
  "item.minecraft.ravager_spawn_egg": "ராவஜர் ஸ்பான் முட்டை",
  "item.minecraft.raw_copper": "மூல செம்பு",
  "item.minecraft.raw_gold": "மூல தங்கம்",
  "item.minecraft.raw_iron": "மூல இரும்பு",
  "item.minecraft.recovery_compass": "மீட்பு திசைகாட்டி",
  "item.minecraft.red_bundle": "Red Bundle",
  "item.minecraft.red_dye": "சிவப்பு சாயம்",
  "item.minecraft.red_harness": "Red Harness",
  "item.minecraft.redstone": "ரெட்ஸ்டோன் டஸ்ட்",
  "item.minecraft.resin_brick": "Resin Brick",
  "item.minecraft.resin_clump": "Resin Clump",
  "item.minecraft.rib_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rib Armor Trim",
  "item.minecraft.rotten_flesh": "அழுகிய சதை",
  "item.minecraft.saddle": "சேணம்",
  "item.minecraft.salmon": "மூல சால்மன்",
  "item.minecraft.salmon_bucket": "சால்மன் வாளி",
  "item.minecraft.salmon_spawn_egg": "சால்மன் ஸ்பான் முட்டை",
  "item.minecraft.scrape_pottery_sherd": "Scrape Pottery Sherd",
  "item.minecraft.scute": "Scute",
  "item.minecraft.sentry_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Sentry Armor Trim",
  "item.minecraft.shaper_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Shaper Armor Trim",
  "item.minecraft.sheaf_pottery_shard": "Sheaf Pottery Shard",
  "item.minecraft.sheaf_pottery_sherd": "Sheaf Pottery Sherd",
  "item.minecraft.shears": "ஷியர்ஸ்",
  "item.minecraft.sheep_spawn_egg": "செம்மறி ஆடு",
  "item.minecraft.shelter_pottery_shard": "தங்குமிடம் மட்பாண்ட ஷார்ட்",
  "item.minecraft.shelter_pottery_sherd": "தங்குமிடம் மட்பாண்ட ஷார்ட்",
  "item.minecraft.shield": "கேடயம்",
  "item.minecraft.shield.black": "கருப்பு கவசம்",
  "item.minecraft.shield.blue": "நீல கவசம்",
  "item.minecraft.shield.brown": "பிரவுன் கேடயம்",
  "item.minecraft.shield.cyan": "சியான் கேடயம்",
  "item.minecraft.shield.gray": "சாம்பல் கேடயம்",
  "item.minecraft.shield.green": "பச்சை கவசம்",
  "item.minecraft.shield.light_blue": "வெளிர் நீல கவசம்",
  "item.minecraft.shield.light_gray": "ஒளி சாம்பல் கேடயம்",
  "item.minecraft.shield.lime": "சுண்ணாம்பு கவசம்",
  "item.minecraft.shield.magenta": "மெஜந்தா கேடயம்",
  "item.minecraft.shield.orange": "ஆரஞ்சு கவசம்",
  "item.minecraft.shield.pink": "இளஞ்சிவப்பு கவசம்",
  "item.minecraft.shield.purple": "ஊதா கவசம்",
  "item.minecraft.shield.red": "சிவப்பு கவசம்",
  "item.minecraft.shield.white": "வெள்ளை கவசம்",
  "item.minecraft.shield.yellow": "மஞ்சள் கவசம்",
  "item.minecraft.shulker_shell": "சுல்கர் ஷெல்",
  "item.minecraft.shulker_spawn_egg": "ஷுல்கர் ஸ்பான் முட்டை",
  "item.minecraft.sign": "பலகை",
  "item.minecraft.silence_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Silence Armor Trim",
  "item.minecraft.silverfish_spawn_egg": "சில்வர்ஷிப் ஸ்பான் முட்டை",
  "item.minecraft.skeleton_horse_spawn_egg": "எலும்புக்கூட்டை குதிரை ஸ்பான் முட்டை",
  "item.minecraft.skeleton_spawn_egg": "எலும்புக்கூடு ஸ்பொன் முட்டை",
  "item.minecraft.skull_banner_pattern": "பதாகை முறை",
  "item.minecraft.skull_banner_pattern.desc": "ஸ்கல் சார்ஜ்",
  "item.minecraft.skull_banner_pattern.new": "Skull Charge Banner Pattern",
  "item.minecraft.skull_pottery_shard": "Skull Pottery Shard",
  "item.minecraft.skull_pottery_sherd": "Skull Pottery Sherd",
  "item.minecraft.slime_ball": "இழிந்த தன்மையுடைய நபர்",
  "item.minecraft.slime_spawn_egg": "ஸ்லேம் ஸ்பான் முட்டை",
  "item.minecraft.smithing_template": "Smithing Template",
  "item.minecraft.smithing_template.applies_to": "Applies to:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Add ingot or crystal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "கவசம்",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Add a piece of armor",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Ingots & Crystals",
  "item.minecraft.smithing_template.ingredients": "பொருட்கள்:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Add Netherite Ingot",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamond Equipment",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Add diamond armor, weapon, or tool",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherite Ingot",
  "item.minecraft.smithing_template.upgrade": "மேம்படுத்தல்: ",
  "item.minecraft.sniffer_spawn_egg": "ஸ்னிஃபர் ஸ்பான் முட்டை",
  "item.minecraft.snort_pottery_shard": "Snort Pottery Shard",
  "item.minecraft.snort_pottery_sherd": "Snort Pottery Sherd",
  "item.minecraft.snout_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snout Armor Trim",
  "item.minecraft.snow_golem_spawn_egg": "ஸ்னோ கோலெம் ஸ்பான் முட்டை",
  "item.minecraft.snowball": "பனிப்பந்து",
  "item.minecraft.spectral_arrow": "ஸ்பெக்ட்ரல் அம்பு",
  "item.minecraft.spider_eye": "ஸ்பைடர் கண்",
  "item.minecraft.spider_spawn_egg": "ஸ்பைடர் ஸ்பான் முட்டை",
  "item.minecraft.spire_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spire Armor Trim",
  "item.minecraft.splash_potion": "ஸ்பிளாஸ் போஷன்",
  "item.minecraft.splash_potion.effect.awkward": "மோசமான ஸ்பிளாஸ் போஷன்",
  "item.minecraft.splash_potion.effect.empty": "ஸ்பிளாஸ் கிராஃப்டிகல் போஷன்",
  "item.minecraft.splash_potion.effect.fire_resistance": "தீ எதிர்ப்பின் ஸ்பிளாஸ் போஷன்",
  "item.minecraft.splash_potion.effect.harming": "தீங்கு விளைவிக்கும் ஸ்பிளாஸ் போஷன்",
  "item.minecraft.splash_potion.effect.healing": "குணப்படுத்தும் ஸ்பிளாஸ் போஷன்",
  "item.minecraft.splash_potion.effect.infested": "Splash Potion of Infestation",
  "item.minecraft.splash_potion.effect.invisibility": "கண்ணுக்குத் தெரியாத ஸ்பிளாஸ் போஷன்",
  "item.minecraft.splash_potion.effect.leaping": "பாய்ச்சலின் ஸ்பிளாஸ் போஷன்",
  "item.minecraft.splash_potion.effect.levitation": "லெவிட்டேஷனின் ஸ்பிளாஸ் போஷன்",
  "item.minecraft.splash_potion.effect.luck": "அதிர்ஷ்டத்தின் ஸ்பிளாஸ் போஷன்",
  "item.minecraft.splash_potion.effect.mundane": "இவ்வுலகம் ஸ்பிளாஸ் போஷன்",
  "item.minecraft.splash_potion.effect.night_vision": "நைட் விஷனின் ஸ்பிளாஸ் போஷன்",
  "item.minecraft.splash_potion.effect.oozing": "Splash Potion of Oozing",
  "item.minecraft.splash_potion.effect.poison": "விஷத்தின் ஸ்பிளாஸ் போஷன்",
  "item.minecraft.splash_potion.effect.regeneration": "மீளுருவாக்கத்தின் ஸ்பிளாஸ் போஷன்",
  "item.minecraft.splash_potion.effect.slow_falling": "மெதுவான வீழ்ச்சி ஸ்பிளாஸ் போஷன்",
  "item.minecraft.splash_potion.effect.slowness": "மந்தத்தின் ஸ்பிளாஸ் போஷன்",
  "item.minecraft.splash_potion.effect.strength": "வலிமையின் ஸ்பிளாஸ் போஷன்",
  "item.minecraft.splash_potion.effect.swiftness": "ஸ்விஃப்ட்னஸின் ஸ்பிளாஸ் போஷன்",
  "item.minecraft.splash_potion.effect.thick": "அடர்த்தியான ஸ்பிளாஸ் போஷன்",
  "item.minecraft.splash_potion.effect.turtle_master": "ஆமை மாஸ்டர் ஸ்பிளாஸ் போஷன்",
  "item.minecraft.splash_potion.effect.water": "ஸ்பிளாஸ் நீர் பாட்டில்",
  "item.minecraft.splash_potion.effect.water_breathing": "நீர் சுவாசத்தின் ஸ்பிளாஸ் போஷன்",
  "item.minecraft.splash_potion.effect.weakness": "பலவீனத்தின் ஸ்பிளாஸ் போஷன்",
  "item.minecraft.splash_potion.effect.weaving": "Splash Potion of Weaving",
  "item.minecraft.splash_potion.effect.wind_charged": "Splash Potion of Wind Charging",
  "item.minecraft.spruce_boat": "ஸ்ப்ரூஸ் படகு",
  "item.minecraft.spruce_chest_boat": "மார்புடன் கூடிய தளிர் படகு",
  "item.minecraft.spyglass": "உளவுக்கண்ணாடி",
  "item.minecraft.squid_spawn_egg": "ஸ்க்விட் ஸ்பான் முட்டை",
  "item.minecraft.stick": "குச்சி",
  "item.minecraft.stone_axe": "கல் அச்சு",
  "item.minecraft.stone_hoe": "ஸ்டோன் ஹோ",
  "item.minecraft.stone_pickaxe": "ஸ்டோன் பிக்காக்ஸ்",
  "item.minecraft.stone_shovel": "ஸ்டோன் திணி",
  "item.minecraft.stone_spear": "Stone Spear",
  "item.minecraft.stone_sword": "கல் வாள்",
  "item.minecraft.stray_spawn_egg": "தவறான ஸ்பான் முட்டை",
  "item.minecraft.strider_spawn_egg": "ஸ்ட்ரைடர் தோட்ற முட்டய்",
  "item.minecraft.string": "சரம்",
  "item.minecraft.sugar": "சர்க்கரை",
  "item.minecraft.suspicious_stew": "சந்தேகத்திற்கிடமான குண்டு",
  "item.minecraft.sweet_berries": "இனிப்பு பெர்ரி",
  "item.minecraft.tadpole_bucket": "டாட்போல் வாளி",
  "item.minecraft.tadpole_spawn_egg": "டாட்போல் ஸ்பான் முட்டை",
  "item.minecraft.tide_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Tide Armor Trim",
  "item.minecraft.tipped_arrow": "தலைகீழ் அம்பு",
  "item.minecraft.tipped_arrow.effect.awkward": "தலைகீழ் அம்பு",
  "item.minecraft.tipped_arrow.effect.empty": "கிராஃப்டபிள் டிப் அம்பு",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "தீ எதிர்ப்பின் அம்பு",
  "item.minecraft.tipped_arrow.effect.harming": "தீங்கு விளைவிக்கும் அம்பு",
  "item.minecraft.tipped_arrow.effect.healing": "குணப்படுத்தும் அம்பு",
  "item.minecraft.tipped_arrow.effect.infested": "Arrow of Infestation",
  "item.minecraft.tipped_arrow.effect.invisibility": "கண்ணுக்கு தெரியாத அம்பு",
  "item.minecraft.tipped_arrow.effect.leaping": "குதிக்கும் அம்பு",
  "item.minecraft.tipped_arrow.effect.levitation": "லேவிட்டனின் அம்பு",
  "item.minecraft.tipped_arrow.effect.luck": "அதிர்ஷ்ட அம்பு",
  "item.minecraft.tipped_arrow.effect.mundane": "தலைகீழ் அம்பு",
  "item.minecraft.tipped_arrow.effect.night_vision": "நைட் விஷனின் அம்பு",
  "item.minecraft.tipped_arrow.effect.oozing": "Arrow of Oozing",
  "item.minecraft.tipped_arrow.effect.poison": "விஷத்தின் அம்பு",
  "item.minecraft.tipped_arrow.effect.regeneration": "மீளுருவாக்கம் அம்பு",
  "item.minecraft.tipped_arrow.effect.slow_falling": "மெதுவாக வீழ்ச்சி அம்பு",
  "item.minecraft.tipped_arrow.effect.slowness": "மந்தத்தின் அம்பு",
  "item.minecraft.tipped_arrow.effect.strength": "வலிமையின் அம்பு",
  "item.minecraft.tipped_arrow.effect.swiftness": "விரைவான அம்பு",
  "item.minecraft.tipped_arrow.effect.thick": "தலைகீழ் அம்பு",
  "item.minecraft.tipped_arrow.effect.turtle_master": "ஆமை மாஸ்டர் அம்பு",
  "item.minecraft.tipped_arrow.effect.water": "ஸ்பிளாஷிங்கின் அம்பு",
  "item.minecraft.tipped_arrow.effect.water_breathing": "நீர் சுவாசத்தின் அம்பு",
  "item.minecraft.tipped_arrow.effect.weakness": "பலவீனத்தின் அம்பு",
  "item.minecraft.tipped_arrow.effect.weaving": "Arrow of Weaving",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Arrow of Wind Charging",
  "item.minecraft.tnt_minecart": "டி. என். டி உடன் மின்கார்ட்",
  "item.minecraft.torchflower_seeds": "Torchflower Seeds",
  "item.minecraft.totem_of_undying": "மொத்தம் நீக்குதல்",
  "item.minecraft.trader_llama_spawn_egg": "வர்த்தகர் லம்மா ஸ்பான் முட்டை",
  "item.minecraft.trial_key": "Trial Key",
  "item.minecraft.trident": "திரிசூலம்",
  "item.minecraft.tropical_fish": "நன்னீர் மீன் வளர்ப்பு",
  "item.minecraft.tropical_fish_bucket": "வெப்பமண்டல மீன் வாளி",
  "item.minecraft.tropical_fish_spawn_egg": "வெப்பமண்டல மீன் ஸ்பான் முட்டை",
  "item.minecraft.turtle_helmet": "ஆமை ஷெல்",
  "item.minecraft.turtle_scute": "Turtle Scute",
  "item.minecraft.turtle_spawn_egg": "டர்டில் ஸ்பான் முட்டை",
  "item.minecraft.vex_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Vex Armor Trim",
  "item.minecraft.vex_spawn_egg": "ரத்து ஸ்பான் முட்டை",
  "item.minecraft.villager_spawn_egg": "வில்லர் ஸ்பான் முட்டை",
  "item.minecraft.vindicator_spawn_egg": "விண்டிகேட்டர் ஸ்பான் முட்டை",
  "item.minecraft.wandering_trader_spawn_egg": "வண்டி வர்த்தகர் ஸ்பான் முட்டை",
  "item.minecraft.ward_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ward Armor Trim",
  "item.minecraft.warden_spawn_egg": "வார்டன் ஸ்பான் முட்டை",
  "item.minecraft.warped_fungus_on_a_stick": "திசைதிருப்பல் பூஞ்சை ஒரு குச்சி",
  "item.minecraft.water_bucket": "நீர் வாளி",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wayfinder Armor Trim",
  "item.minecraft.wheat": "கோதுமை",
  "item.minecraft.wheat_seeds": "கோதுமை விதைகள்",
  "item.minecraft.white_bundle": "White Bundle",
  "item.minecraft.white_dye": "வெள்ளை சாயம்",
  "item.minecraft.white_harness": "White Harness",
  "item.minecraft.wild_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wild Armor Trim",
  "item.minecraft.wind_charge": "Wind Charge",
  "item.minecraft.witch_spawn_egg": "விட்ச் ஸ்பான் முட்டை",
  "item.minecraft.wither_skeleton_spawn_egg": "எலும்புக்கூடு ஸ்பான் முட்டை",
  "item.minecraft.wither_spawn_egg": "கவிழ்ந்துவிடும் தோற்ற முட்டை",
  "item.minecraft.wolf_armor": "Wolf Armor",
  "item.minecraft.wolf_spawn_egg": "ஓநாய் ஸ்பான் முட்டை",
  "item.minecraft.wooden_axe": "மர அச்சு",
  "item.minecraft.wooden_hoe": "மரத்தாலான ஹீ",
  "item.minecraft.wooden_pickaxe": "மர பிக்காக்ஸ்",
  "item.minecraft.wooden_shovel": "மர திணி",
  "item.minecraft.wooden_spear": "Wooden Spear",
  "item.minecraft.wooden_sword": "மர வாள்",
  "item.minecraft.writable_book": "புத்தகம் மற்றும் குயில்",
  "item.minecraft.written_book": "எழுதப்பட்ட புத்தகம்",
  "item.minecraft.yellow_bundle": "Yellow Bundle",
  "item.minecraft.yellow_dye": "மஞ்சள் சாயம்",
  "item.minecraft.yellow_harness": "Yellow Harness",
  "item.minecraft.zoglin_spawn_egg": "ஜோக்ளின் தோட்ற முட்டய்",
  "item.minecraft.zombie_horse_spawn_egg": "சோம்பை குதிரை ஸ்பான் முட்டை",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "சோம்பை ஸ்பான் முட்டை",
  "item.minecraft.zombie_villager_spawn_egg": "ஸோம்பி வில்லேஜர் ஸ்பான் முட்டை",
  "item.minecraft.zombified_piglin_spawn_egg": "சோம்பை பிக்லின் ஸ்பான் முட்டை"
}
export const ta_in = items; 
